var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayMediumItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:11:21 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2012, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-MediumItalic",
    horizAdvX: 606
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway Medium",
    fontWeight: 500,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 6 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 522,
    capHeight: 709,
    bbox: "-254 -224 1344 930",
    underlineThickness: 50,
    underlinePosition: -150,
    slope: -12,
    unicodeRange: "U+0020-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 580,
    d: "M126 453h-67l15 69h67l1 4q9 34 26 66t41.5 56.5t56.5 39t70 14.5q35 0 61.5 -8t46.5 -19q27 29 61.5 47t79.5 18q21 0 36.5 -3.5t27.5 -9t20.5 -11t15.5 -8.5l-35 -65q-10 8 -24 14.5t-40 6.5t-46.5 -11.5t-36.5 -29.5t-26 -41t-15 -46l-3 -14h147l-14 -69h-148 l-96 -453h-88l96 453h-142l-96 -453h-88zM371 522q4 19 13 44.5t20 41.5q-13 11 -32 14.5t-36 3.5q-23 0 -41 -8t-31 -21.5t-21.5 -31.5t-12.5 -38l-1 -5h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 506,
    d: "M126 453h-67l15 69h67l2 11q7 39 26.5 76t49.5 66t68.5 47t85.5 18q53 0 89.5 -17.5t57.5 -34.5l-51 -65q-16 17 -44 29t-63 12q-27 0 -49 -11.5t-38.5 -29.5t-27 -41t-15.5 -46l-3 -14h255l-111 -522h-88l96 453h-167l-96 -453h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 585,
    d: "M417 -7q-44 0 -66 22.5t-22 56.5q0 8 1.5 17.5t4.5 24.5l94 439q2 8 3 17t1 17q0 30 -16.5 53.5t-59.5 23.5q-51 0 -82 -37t-44 -96l-2 -9h96l-14 -69h-97l-96 -453h-88l96 453h-67l15 69h67l4 18q20 91 78 145.5t149 54.5q79 0 116.5 -34t37.5 -91q0 -11 -1.5 -21.5 t-3.5 -21.5l-93 -439q-2 -10 -2 -16q0 -17 9 -31t30 -14q9 0 19.5 2t19.5 4t15.5 4l6.5 2l-4 -72q-1 -1 -10.5 -4t-24.5 -6.5t-33.5 -6t-36.5 -2.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 736,
    d: "M126 453h-67l15 69h67l1 4q7 31 24 62.5t42 57t57.5 41t70.5 15.5q35 0 61.5 -8t46.5 -19q29 29 69 47t89 18q50 0 87.5 -17.5t60.5 -34.5l-51 -65q-15 17 -43.5 29t-61.5 12q-28 0 -50.5 -11.5t-39 -29.5t-27 -41t-15.5 -46l-3 -14h255l-111 -522h-88l96 453h-167 l-96 -453h-88l96 453h-142l-96 -453h-88zM371 522q4 19 13 44.5t20 41.5q-13 11 -32 14.5t-36 3.5q-23 0 -41 -8.5t-31.5 -22.5t-21.5 -32t-12 -36l-1 -5h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 817,
    d: "M650 -7q-45 0 -67 22.5t-22 56.5q0 11 1.5 20.5t5.5 26.5l93 434q2 8 3 17t1 17q0 31 -16 54t-59 23q-27 0 -47.5 -11t-36 -30t-26 -44t-17.5 -53l-1 -4h95l-14 -69h-96l-96 -453h-88l96 453h-145l-96 -453h-88l96 453h-67l15 69h67l1 4q8 34 26 65.5t44 56t58.5 39.5 t70.5 15q35 0 59 -8t44 -19q62 65 161 65q78 0 115.5 -34t37.5 -91q0 -18 -5 -43l-93 -439q-2 -10 -2 -17q0 -17 9 -30.5t30 -13.5q9 0 19.5 2t19.5 4t15.5 4t7.5 2l-5 -72q0 -1 -9.5 -4t-24.5 -6.5t-33.5 -6t-36.5 -2.5zM374 522q5 21 12.5 47t16.5 40q-13 11 -29.5 14 t-31.5 3q-23 0 -42 -8.5t-33.5 -22.5t-24 -31.5t-12.5 -34.5l-1 -7h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 247
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 258,
    d: "M72 240l101 477h88l-101 -477h-88zM21 0l26 124h88l-26 -124h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 318,
    d: "M106 502l46 216h76l-46 -216h-76zM218 502l46 216h76l-46 -216h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 664,
    d: "M658 447h-128l-78 -178h126l-14 -68h-142l-89 -201h-73l90 201h-155l-89 -201h-73l90 201h-107l14 68h124l77 178h-121l14 64h137l88 199h72l-88 -199h155l87 199h73l-89 -199h113zM380 269l78 178h-155l-77 -178h154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 596,
    d: "M540 561q-16 26 -57 48t-97 25l-50 -237q48 -12 85.5 -26t63.5 -33.5t39.5 -45.5t13.5 -63q0 -59 -22.5 -102.5t-61 -72.5t-89.5 -44.5t-109 -16.5l-21 -100h-43l21 101q-67 5 -123.5 29.5t-98.5 69.5l59 76q10 -15 27.5 -30.5t41.5 -28.5t53.5 -22.5t62.5 -12.5l51 239 q-10 2 -15 4q-41 11 -73 24t-54 30.5t-33.5 41t-11.5 55.5q0 55 21 98.5t57 75t84.5 50t104.5 21.5l22 101h43l-21 -101q62 -3 108.5 -24.5t78.5 -55.5zM438 201q0 41 -32 63.5t-90 40.5l-49 -231q80 1 125.5 34t45.5 93zM198 498q0 -38 27 -57.5t81 -35.5l49 229 q-82 -4 -119.5 -41.5t-37.5 -94.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 707,
    d: "M212 428q-27 0 -49 9.5t-37.5 25.5t-24.5 38t-9 48q0 34 15.5 65.5t41 54.5t58 37t67.5 14q54 0 87 -35t33 -86q0 -35 -15.5 -66t-41 -54t-58 -37t-67.5 -14zM222 476q20 0 39 10t34 26t24.5 37t9.5 44q0 33 -18 56t-47 23q-20 0 -39 -10t-34 -26t-24.5 -37.5t-9.5 -43.5 q0 -33 18 -56t47 -23zM456 -10q-27 0 -49 9.5t-37.5 25.5t-24.5 38t-9 48q0 34 15.5 65.5t41 54.5t58 37t67.5 14q54 0 86.5 -35t32.5 -86q0 -35 -15 -66t-40.5 -54t-58 -37t-67.5 -14zM466 38q20 0 39 9.5t34 26t24.5 37.5t9.5 44q0 33 -18.5 56t-47.5 23q-20 0 -39 -10 t-34 -26t-24.5 -37.5t-9.5 -43.5q0 -33 18.5 -56t47.5 -23zM15 33l338 337l327 345l35 -37l-334 -335l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 672,
    d: "M402 98q-49 -51 -105 -79.5t-113 -28.5q-37 0 -67.5 12.5t-52.5 34t-34.5 51.5t-12.5 66q0 43 15 77.5t40.5 63.5t58 53.5t68.5 46.5q-29 45 -41.5 77.5t-12.5 61.5q0 39 17 72.5t46.5 58.5t68 39.5t80.5 14.5q54 0 96 -28t63 -77l-60 -54q-14 39 -44.5 65.5t-68.5 26.5 q-23 0 -44 -8.5t-37 -23t-25 -33.5t-9 -39t12 -50.5t48 -82.5l127 -183q21 40 37 86.5t25 97.5h176l-15 -69h-99q-14 -50 -34.5 -94.5t-45.5 -82.5l119 -170h-109zM203 60q42 0 83.5 24t77.5 69l-128 186q-59 -38 -96 -79t-37 -95q0 -51 29 -78t71 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 206,
    d: "M106 501l46 217h76l-46 -217h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 278,
    d: "M42 261q0 66 18 127t49.5 119.5t73.5 117t90 119.5l61 -30q-27 -33 -63.5 -83.5t-68.5 -110.5t-54.5 -125t-22.5 -127t14 -136t40 -140l-72 -34q-29 69 -47 149t-18 154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 278,
    d: "M256 432q0 -64 -18 -124.5t-49 -119t-73 -116t-90 -114.5l-58 34q45 55 82.5 108.5t64.5 107.5t42 107.5t15 108.5q0 40 -5 82t-12.5 81t-17 72t-18.5 55l75 30q26 -74 44 -155t18 -157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 322,
    d: "M131 538l56 65l-61 22l22 42l61 -27l12 74h51l-19 -74l73 27l3 -42l-70 -22l29 -65l-43 -25l-26 67l-57 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 416,
    d: "M375 391v-72h-118v-128h-80v128h-118v72h118v128h80v-128h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 208,
    d: "M-7 -81l39 89h-30l22 104h82l-22 -104l-48 -89h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 406,
    d: "M48 233l17 80h281l-17 -80h-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 200,
    d: "M0 0l24 112h74l-24 -112h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 628,
    d: "M680 710l-608 -710h-98l608 710h98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 594,
    d: "M231 -10q-43 0 -77.5 17.5t-58.5 48t-37 73t-13 93.5q0 78 26 146t69.5 119t100.5 80.5t119 29.5q43 0 77.5 -17.5t58.5 -48t37 -73.5t13 -94q0 -78 -26 -146t-70 -119t-101 -80t-118 -29zM248 72q41 0 79 22t66.5 60t45.5 89.5t17 110.5q0 72 -30 116.5t-83 44.5 q-42 0 -80 -22.5t-66.5 -60.5t-45.5 -90t-17 -110q0 -72 30 -116t84 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 434,
    d: "M20 80h135l83 390q-11 -12 -32 -25.5t-46 -25t-50 -19.5t-44 -8l18 84q21 0 49 12.5t55 29t47 32t24 21.5h90l-104 -491h121l-17 -80h-346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 514,
    d: "M-21 0q9 40 22.5 75.5t37 67t60 61t90.5 57.5q35 18 71 34.5t64.5 35t46.5 41t18 52.5t-23 54.5t-71 24.5q-28 0 -52.5 -8.5t-45 -21t-36.5 -26.5t-28 -25l-43 64q10 9 32 24.5t53 31.5t70 27.5t83 11.5q39 0 68.5 -10.5t50 -28.5t31 -42.5t10.5 -52.5q0 -45 -20.5 -79 t-50 -59t-63 -42.5t-59.5 -29.5q-23 -11 -51.5 -26.5t-56 -35t-50 -43.5t-33.5 -52h318l-17 -80h-426v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 519,
    d: "M152 -147q-72 0 -121 28.5t-69 80.5l70 59q14 -41 45.5 -64.5t90.5 -23.5q78 0 123.5 40t45.5 114q0 50 -32.5 79.5t-98.5 29.5h-25l16 74h27q39 0 70.5 11.5t53 31t33.5 45.5t12 56q0 42 -28 62.5t-74 20.5q-51 0 -94.5 -23.5t-75.5 -65.5l-42 56q18 25 44 45.5 t57.5 35.5t66 23t70.5 8q80 0 125.5 -40t45.5 -106q0 -34 -12 -66.5t-33 -59t-50 -44.5t-63 -24q48 -9 74 -46.5t26 -91.5t-21 -99t-58.5 -77.5t-88 -50.5t-110.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 539,
    d: "M274 42h-302l17 78l426 451h60l-96 -449h84l-17 -80h-84l-36 -169h-88zM300 122l67 313l-287 -313h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 528,
    d: "M156 -149q-72 0 -122.5 36t-67.5 96l65 48q17 -46 54 -74t88 -28q37 0 70.5 14.5t59 39.5t41 59t15.5 74q0 54 -31 87.5t-82 33.5q-40 0 -79 -19t-68 -54h-79q3 7 16.5 40t31.5 78.5t38 96t37 93.5t28 71t12 28h328l-17 -81h-264l-87 -226q25 23 58.5 36.5t71.5 13.5 q40 0 73 -13.5t56 -37.5t36 -57.5t13 -73.5q0 -61 -24.5 -112.5t-65.5 -89t-94.5 -58.5t-110.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 591,
    d: "M238 -10q-91 0 -141 60t-50 166q0 100 26 190.5t72.5 159t111.5 109t144 40.5q66 0 112 -33t65 -93l-65 -53q-11 47 -45.5 74.5t-84.5 27.5q-38 0 -73 -18.5t-64.5 -54.5t-53 -87.5t-38.5 -117.5q32 52 84.5 83t110.5 31q42 0 77 -15t59.5 -41.5t38 -62t13.5 -77.5 q0 -58 -25 -110.5t-66.5 -92t-95.5 -62.5t-112 -23zM255 66q36 0 71.5 16t63 43.5t44.5 63.5t17 76q0 29 -9 54t-25.5 44t-39.5 29.5t-51 10.5q-37 0 -72 -16t-62.5 -43.5t-44.5 -63.5t-17 -75q0 -29 9 -54.5t25.5 -44t39.5 -29.5t51 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 516,
    d: "M408 502h-342l17 81h482l-490 -710h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 576,
    d: "M220 -8q-44 0 -80.5 13.5t-62 37.5t-39.5 56.5t-14 70.5q0 41 15.5 75t39.5 60t53.5 45t57.5 30q-32 16 -53 47.5t-21 72.5q0 49 24.5 88t62.5 66t83.5 41.5t87.5 14.5q34 0 67 -10t58.5 -30t41 -49t15.5 -66q0 -32 -12 -59t-31.5 -49t-44.5 -39t-51 -28 q39 -18 65.5 -56.5t26.5 -90.5q0 -53 -24.5 -97.5t-65 -76.5t-92.5 -49.5t-107 -17.5zM239 71q31 0 63 11.5t58 32.5t43 50.5t17 64.5q0 27 -10.5 48t-28 35.5t-40 22t-46.5 7.5q-31 0 -63 -11.5t-57.5 -32.5t-42 -50.5t-16.5 -64.5q0 -26 10.5 -47t27.5 -35.5t39 -22.5 t46 -8zM311 411q24 0 51 8.5t49.5 25t37.5 41t15 55.5q0 42 -31 66t-76 24q-28 0 -55 -9t-48.5 -25.5t-35 -40.5t-13.5 -53q0 -22 9 -39t24 -29t34 -18t39 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 574,
    d: "M173 -154q-66 0 -112 33t-65 93l65 53q11 -47 45.5 -74.5t84.5 -27.5q38 0 73 18.5t64.5 54.5t52.5 87.5t38 117.5q-32 -52 -84 -83t-111 -31q-42 0 -76.5 15t-59 41.5t-38 62t-13.5 77.5q0 58 25 110.5t66.5 92t95.5 62.5t112 23q90 0 140.5 -60t50.5 -166 q0 -100 -26 -190.5t-72.5 -159t-111.5 -109t-144 -40.5zM247 158q37 0 72.5 16t63 43.5t44.5 63.5t17 75q0 29 -9 54.5t-25.5 44t-39.5 29.5t-51 11q-36 0 -71.5 -16t-63.5 -43.5t-45 -63.5t-17 -76q0 -29 9.5 -54t26 -44t39.5 -29.5t50 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 198,
    d: "M84 406l24 112h73l-24 -112h-73zM-2 0l24 112h73l-24 -112h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 202,
    d: "M85 406l23 112h73l-24 -112h-72zM-9 -81l39 89h-30l22 104h82l-22 -104l-48 -89h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 547,
    d: "M30 280l420 253v-94l-292 -180l292 -177v-98l-420 250v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 479,
    d: "M81 179v60h305v-60h-305zM81 313v60h305v-60h-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 546,
    d: "M498 234l-420 -250v98l292 177l-292 180v94l420 -253v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 462,
    d: "M117 211q11 54 37 94.5t77 69.5q22 13 50.5 27.5t54 34.5t43 48t17.5 69q0 45 -27.5 68.5t-65.5 23.5q-23 0 -45.5 -7.5t-43 -20.5t-38 -30.5t-30.5 -36.5l-51 39q19 31 45 55t56 40.5t61.5 25t63.5 8.5q31 0 59 -9.5t49.5 -28t34 -47t12.5 -67.5q0 -48 -13 -81 t-34.5 -57.5t-51 -42.5t-62.5 -35q-20 -10 -39.5 -21t-36 -26.5t-29 -37.5t-19.5 -55h-74zM74 0l25 116h73l-24 -116h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 808,
    d: "M569 28q32 0 57.5 29t43 71t26.5 89.5t9 84.5q0 49 -16 95.5t-47.5 83.5t-78.5 59.5t-110 22.5q-72 0 -141.5 -31t-124 -84.5t-88 -126.5t-33.5 -157q0 -57 16.5 -106.5t48 -86t76.5 -57t102 -20.5q42 0 78.5 10.5t75.5 27.5l5 -38q-43 -20 -85.5 -30t-82.5 -10 q-61 0 -112 22t-87.5 62.5t-56.5 96.5t-20 125q0 66 18.5 124.5t50 107.5t74 88t91.5 66.5t101.5 42t103.5 14.5q68 0 121 -24.5t89 -65t55 -92.5t19 -107q0 -24 -4 -58t-13 -70.5t-23.5 -72.5t-36 -65t-50 -46.5t-64.5 -17.5q-29 0 -49 14.5t-20 51.5v11t2 12 q-33 -32 -77.5 -53t-89.5 -21q-37 0 -66.5 14.5t-49.5 40t-31 58.5t-11 71q0 53 20.5 102.5t54 88t77.5 61.5t91 23q54 0 87.5 -27.5t47.5 -68.5l18 88h56l-75 -351q-2 -10 -3 -18.5t-1 -14.5q0 -38 32 -38zM347 49q24 0 48 9.5t44.5 25t36.5 36t25 43.5l24 137 q-16 57 -48.5 82t-70.5 25q-32 0 -65 -16.5t-59 -44.5t-42.5 -66t-16.5 -81q0 -33 10 -60.5t26.5 -47.5t39 -31t48.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 647,
    d: "M171 710h338q30 0 52.5 -12.5t37.5 -32.5t22.5 -46t7.5 -54q0 -32 -10 -62t-28 -56.5t-43 -48t-56 -34.5q45 -15 68.5 -53.5t23.5 -89.5q0 -50 -20.5 -90.5t-54.5 -69.5t-78 -45t-90 -16h-321zM357 78q26 0 51 12t44.5 32.5t31 46.5t11.5 55q0 40 -21 69t-58 29h-238 l-51 -244h230zM405 395q25 0 48.5 11.5t41.5 31.5t29 46t11 55q0 40 -19.5 66.5t-54.5 26.5h-217l-50 -237h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 653,
    d: "M293 -6q-59 0 -105.5 25.5t-78 67.5t-48 96t-16.5 111q0 73 30.5 148t84.5 135.5t128.5 98.5t162.5 38q45 0 81.5 -11.5t64.5 -32t46 -49t27 -62.5l-81 -46q-8 34 -24 57t-37.5 37t-47 20t-50.5 6q-65 0 -119 -31t-93 -79.5t-60.5 -107.5t-21.5 -116q0 -45 12 -86 t35 -71.5t56 -48.5t75 -18q26 0 55.5 7t58 22.5t55.5 39t48 56.5l66 -41q-24 -40 -60 -70.5t-77 -51.5t-84.5 -32t-82.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 692,
    d: "M171 710h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235zM272 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145l-117 -550h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 565,
    d: "M171 710h446l-17 -80h-356l-50 -237h299l-16 -75h-299l-68 -318h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 686,
    d: "M516 95q-55 -51 -110.5 -75.5t-113.5 -24.5q-57 0 -103 24.5t-78 66t-49 95t-17 111.5q0 81 33.5 157t89 135.5t127.5 95t150 35.5q98 0 152.5 -43t73.5 -112l-79 -48q-17 62 -60.5 92t-105.5 30q-59 0 -112 -29.5t-92.5 -77t-62.5 -108t-23 -122.5q0 -46 12.5 -86 t36 -70t57 -47.5t74.5 -17.5q54 0 108.5 27.5t111.5 85.5l21 97h-145l15 68h220l-75 -354h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 713,
    d: "M171 710h90l-65 -307h365l65 307h90l-151 -710h-90l69 323h-365l-69 -323h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 472,
    d: "M98 -11q-85 0 -137 44l38 73q15 -14 45 -25t71 -11q47 0 79 18t54 53.5t37.5 87.5t30.5 120l77 360h90l-77 -360q-17 -81 -38.5 -147.5t-55.5 -113.5t-85.5 -73t-128.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 625,
    d: "M171 709h90l-84 -392l425 393h98l-336 -313l200 -397h-99l-168 345l-141 -128l-46 -217h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 559,
    d: "M171 710h90l-134 -630h373l-17 -80h-463z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 838,
    d: "M171 710h95l142 -461l339 461h94l-151 -710h-90l117 549l-309 -421h-51l-130 421l-117 -549h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 739,
    d: "M171 710h70l294 -553l117 552h90l-151 -709h-75l-291 542l-115 -542h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 721,
    d: "M295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70 t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 601,
    d: "M171 710h282q38 0 68 -16t51 -42t32 -60t11 -70q0 -48 -20.5 -96t-55 -86t-80.5 -61.5t-98 -23.5h-197l-54 -255h-90zM373 335q30 0 57.5 15t48 40t32.5 57.5t12 66.5q0 51 -26 83.5t-67 32.5h-186l-63 -295h192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 720,
    d: "M488 54q-45 -28 -93.5 -43.5t-99.5 -15.5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -91 -41.5 -175t-109.5 -145l62 -100h-88zM313 76q37 0 71 11.5t64 31.5l-69 113h87l40 -65 q47 51 74 115.5t27 130.5q0 44 -11.5 84t-34 70.5t-55.5 48.5t-75 18q-62 0 -115.5 -30.5t-93.5 -78.5t-63 -108.5t-23 -120.5q0 -44 11.5 -84t34 -70t55.5 -48t76 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 633,
    d: "M20 0l151 710h290q38 0 68 -16t51 -42t32 -60t11 -70q0 -42 -15 -82.5t-40.5 -74t-60 -58.5t-74.5 -35l105 -272h-102l-98 255h-174l-54 -255h-90zM382 335q30 0 57 15.5t47 40.5t32 56.5t12 64.5q0 24 -7 45.5t-19 37.5t-28.5 25.5t-36.5 9.5h-195l-63 -295h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 588,
    d: "M242 -7q-78 0 -142.5 25.5t-111.5 74.5l59 76q11 -17 31 -34t48 -30.5t62 -22t73 -8.5q81 0 127.5 33.5t46.5 93.5q0 24 -11.5 41.5t-33 31t-52.5 23.5t-70 21q-41 11 -73 24t-54 30.5t-33.5 41t-11.5 55.5q0 58 23 103.5t63 77t93.5 48.5t113.5 17q68 0 119 -22t86 -59 l-57 -73q-8 14 -24 27t-38 23.5t-48.5 17t-56.5 6.5q-91 0 -133 -39t-42 -98q0 -22 9.5 -37.5t28.5 -27t47 -21t66 -18.5q43 -11 78 -24.5t59.5 -32.5t38 -45t13.5 -63q0 -60 -23.5 -104.5t-63.5 -73.5t-93 -43.5t-113 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 586,
    d: "M317 630h-231l17 80h552l-17 -80h-231l-134 -630h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 725,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 650,
    d: "M95 710h95l92 -597l345 597h95l-425 -710h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1002,
    d: "M93 710h97l96 -606l175 293l-51 309h85l35 -247l141 247h85l-182 -309l50 -293l353 606h99l-433 -710h-77l-61 335l-205 -335h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 610,
    d: "M267 350l-176 360h100l139 -296l264 296h99l-329 -360l170 -350h-99l-133 286l-254 -286h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 612,
    d: "M248 261l-159 449h99l122 -370l281 370h98l-352 -451l-55 -259h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 600,
    d: "M-19 70l549 560h-421l17 80h526l-15 -70l-541 -560h422l-17 -80h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 265,
    d: "M10 -40l166 780h137l-15 -72h-56l-135 -636h56l-15 -72h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 556,
    d: "M207 710l262 -710h-98l-263 710h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 265,
    d: "M-27 -40l15 72h56l135 636h-56l16 72h137l-165 -780h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 556,
    d: "M51 303l198 407h74l197 -407h-75l-159 328l-162 -328h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 483,
    d: "M-19 -80l17 80h357l-17 -80h-357z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 223,
    d: "M72 730h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 599,
    d: "M263 -10q-62 0 -102 30t-57 78l-21 -98h-78l155 730h88l-66 -312q42 51 94 82t110 31q43 0 75.5 -17.5t54.5 -47t33 -68t11 -80.5q0 -66 -25.5 -125.5t-67 -104.5t-95 -71.5t-109.5 -26.5zM260 66q39 0 76.5 20t66.5 53t46.5 75.5t17.5 87.5q0 30 -8 57.5t-24 49 t-38.5 34t-52.5 12.5q-26 0 -51.5 -10t-48.5 -26.5t-43.5 -38.5t-36.5 -47l-32 -151q0 -24 10 -45t27.5 -37t41 -25t49.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 531,
    d: "M225 -10q-48 0 -85.5 17.5t-64 47.5t-40 70t-13.5 85q0 63 25 121t67.5 102.5t100.5 71t124 26.5q75 0 121.5 -34.5t61.5 -92.5l-91 -27q-11 37 -40 57.5t-70 20.5q-40 0 -77.5 -18.5t-66.5 -50t-46.5 -74.5t-17.5 -91q0 -33 9 -61.5t25.5 -49t40 -32.5t51.5 -12 q21 0 43.5 6.5t42 17.5t35.5 25.5t25 31.5l81 -26q-17 -29 -42.5 -53t-57 -41t-67.5 -27t-74 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l67 312h88l-132 -622q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 9 2 22t7 35 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 334,
    d: "M126 453h-67l15 69h67l2 11q19 97 73 152t125 55q29 0 56 -8.5t48 -23.5l-36 -65q-11 10 -29.5 16t-36.5 6q-41 0 -69 -33t-42 -96l-3 -14h131l-15 -69h-131l-141 -665h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 599,
    d: "M164 -223q-84 0 -131 31t-71 84l60 45q20 -46 61 -69t95 -23q34 0 66.5 10t59.5 30t46.5 50t28.5 71l19 92q-37 -48 -90.5 -76t-106.5 -28q-42 0 -75.5 17t-56.5 46.5t-35 68t-12 81.5q0 63 24 121.5t64.5 103.5t94 72t112.5 27q62 0 100.5 -32t59.5 -81l22 104h78 l-110 -516q-12 -56 -40.5 -98.5t-69 -71.5t-90.5 -44t-103 -15zM244 66q26 0 52.5 10t50 26.5t42 37.5t28.5 43l32 150q-4 27 -16 49t-29 38.5t-39 25.5t-46 9q-43 0 -80.5 -21.5t-65.5 -55t-44 -75.5t-16 -82q0 -32 9.5 -60t26.5 -49t41 -33.5t54 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 567,
    d: "M160 730h88l-68 -320q42 57 98.5 89t116.5 32q66 0 93 -36t27 -94q0 -43 -10 -89l-66 -312h-88l62 292q4 20 6 36.5t2 31.5q0 92 -77 92q-24 0 -50 -10.5t-51 -28.5t-47 -43t-36 -55l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88zM160 730h88l-23 -110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 232,
    d: "M-97 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5q15 0 30.5 6.5t29 17.5t23 27t13.5 34l116 545h88l-115 -539q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5zM166 730h88l-24 -110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 542,
    d: "M160 730h88l-73 -345q23 30 49.5 56.5t55.5 46.5t61.5 31.5t67.5 11.5q54 0 79 -28.5t25 -76.5q0 -64 -42.5 -118t-125.5 -89l115 -219h-95l-124 255q47 10 83 27.5t60 39t36.5 45t12.5 47.5q0 26 -13 35.5t-34 9.5q-33 0 -69 -17.5t-69 -48t-60.5 -71.5t-44.5 -88 l-50 -234h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 280,
    d: "M112 -7q-42 0 -64.5 20.5t-22.5 57.5q0 8 1 16t3 16l133 627h87l-126 -595q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -43 45 -43q11 0 26 3.5t29 8.5l-3 -71q-23 -9 -53 -15t-53 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 883,
    d: "M116 522h80l-24 -112q40 56 96 88.5t114 32.5t88.5 -33t32.5 -94q46 63 100 95t114 32q64 0 90 -35t26 -92q0 -40 -11 -92l-67 -312h-88l62 292q9 42 9 73q0 87 -72 87q-25 0 -50 -10t-48 -28.5t-43 -44t-35 -55.5l-66 -314h-88l62 292q9 43 9 74q0 86 -71 86 q-50 0 -98 -37.5t-78 -99.5l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 567,
    d: "M116 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5q0 -22 -3.5 -46t-8.5 -50l-66 -312h-88l62 292q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 578,
    d: "M222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5 t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 600,
    d: "M116 522h78l-21 -98q40 48 93 77.5t110 29.5q43 0 77 -17.5t58 -47.5t36.5 -69.5t12.5 -83.5q0 -62 -23 -120.5t-62.5 -103.5t-91.5 -72t-110 -27q-61 0 -101 32t-57 81l-67 -316h-88zM262 66q42 0 79 20.5t65.5 54t45 75t16.5 83.5q0 32 -9 60.5t-26.5 49.5t-41.5 33.5 t-54 12.5q-22 0 -48 -9.5t-50 -25t-44 -37t-30 -45.5l-32 -149q10 -52 44.5 -87.5t84.5 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 599,
    d: "M194 -10q-41 0 -73 17t-54 46t-33.5 67.5t-11.5 82.5q0 66 25.5 125.5t67.5 104.5t95.5 71.5t110.5 26.5q58 0 99 -30t58 -78l21 99h78l-132 -623q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-20 -3 -42 -3q-27 0 -44 15t-17 40q0 5 2 15l52 245q-45 -56 -97 -84.5 t-109 -28.5zM240 66q52 0 97 32.5t79 79.5l32 150q0 25 -10 48.5t-27 40.5t-39 27.5t-47 10.5q-41 0 -79.5 -20.5t-67.5 -54t-46.5 -76t-17.5 -86.5q0 -32 8.5 -59.5t25 -48t39.5 -32.5t53 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 354,
    d: "M116 522h82l-26 -121q38 54 86.5 88t96.5 34q9 0 15 -0.5t11 -1.5l-16 -76q-63 -2 -117.5 -34t-86.5 -89l-68 -322h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 475,
    d: "M178 -10q-60 0 -114 19.5t-88 56.5l50 59q36 -35 76 -52.5t88 -17.5q60 0 97 27t37 72q0 32 -29.5 47t-89.5 31q-37 10 -64 20t-45 23t-27 29.5t-9 39.5q0 44 19 78.5t50.5 58.5t73 37t86.5 13q56 0 100 -19t72 -50l-51 -53q-26 29 -61.5 43.5t-75.5 14.5q-26 0 -48.5 -6 t-40 -18.5t-27.5 -31.5t-10 -44q0 -28 23.5 -41t75.5 -27q41 -11 72.5 -22t52.5 -25.5t31.5 -33t10.5 -44.5q0 -41 -17.5 -74.5t-48.5 -58t-74.5 -38t-94.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 338,
    d: "M142 -7q-41 0 -67.5 19t-26.5 61q0 14 3 29l75 351h-68l15 69h67l37 174h88l-37 -174h111l-15 -69h-110l-69 -324q-2 -10 -2 -15q0 -21 13 -30.5t32 -9.5q25 0 47 8.5t31 13.5l5 -70q-18 -13 -53.5 -23t-75.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 508,
    d: "M56 522h91l59 -445q81 112 139.5 222.5t87.5 222.5h84q-36 -131 -108.5 -261t-174.5 -261h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 768,
    d: "M49 522h91l83 -445q32 42 60.5 82.5t54.5 82.5l-70 280h91l40 -169q42 85 65 169h84q-20 -69 -50.5 -138.5t-72.5 -138.5l41 -168q81 112 139.5 222.5t87.5 222.5h84q-36 -131 -108.5 -261t-174.5 -261h-95l-37 147q-51 -74 -111 -147h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 492,
    d: "M189 260l-129 262h92l92 -192l4 -16l12 16l173 192h93l-240 -262l130 -260h-93l-92 191l-6 15l-11 -15l-173 -191h-93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 501,
    d: "M-35 -153q31 4 53.5 10.5t40 17t32.5 27.5t32 43l29 44l-101 533h91l72 -443l34 56q42 69 71 121t49.5 96t34.5 84.5t26 85.5h87q-14 -48 -29 -90t-38 -88.5t-56.5 -103.5t-82.5 -137l-80 -129q-34 -55 -64 -92.5t-59.5 -60.5t-61 -33.5t-68.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 470,
    d: "M-23 57l394 401h-300l14 64h398l-12 -57l-392 -401h308l-14 -64h-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 265,
    d: "M245 668l-52 -244q-3 -14 -13.5 -32t-28.5 -32q9 -10 12.5 -23t3.5 -26q0 -10 -1 -15l-54 -255h52l-15 -72h-111q-6 0 -11 4t-5 15q0 7 1 11l57 271q1 5 1 15q0 17 -7.5 29.5t-21.5 14.5l14 64q10 0 19 6t16 15t11.5 18.5t6.5 17.5l55 260q4 19 13.5 24.5t14.5 5.5h111 l-16 -72h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 302,
    d: "M118 -130v905h76v-905h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 264,
    d: "M124 668l15 72h110q4 0 10.5 -4t6.5 -17q0 -6 -1 -9l-56 -260q-1 -4 -1 -12q0 -15 6.5 -30t23.5 -15l-14 -64q-19 -3 -33.5 -20t-19.5 -39l-57 -271q-4 -17 -13 -23.5t-16 -6.5h-110l15 72h53l54 255q3 14 13.5 32t27.5 32q-8 11 -12 23.5t-4 24.5q0 5 0.5 8.5t1.5 7.5 l52 244h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 513,
    d: "M49 237q1 6 11 24t27.5 37.5t42 35t56.5 15.5q23 0 41 -9t34.5 -19.5t33.5 -19.5t37 -9q19 0 33 7.5t24 16.5t15 17.5t5 10.5h51q-1 -3 -10.5 -20t-27 -36.5t-43.5 -35t-60 -15.5q-24 0 -43 8.5t-35.5 19t-32.5 19.5t-34 9t-31.5 -8.5t-23 -19t-14 -19t-4.5 -9.5h-52v0z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 247
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 257,
    d: "M209 474l-101 -477h-88l101 477h88zM260 714l-26 -124h-88l26 124h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 548,
    d: "M176 -120l24 111q-41 3 -73 23t-54 50.5t-33.5 68.5t-11.5 78q0 55 21 109.5t59 98.5t90.5 74t115.5 37l25 115h43l-24 -115q69 -2 111.5 -35t59.5 -91l-91 -27q-11 36 -36.5 54.5t-60.5 20.5l-81 -384q16 1 36 7.5t38.5 16.5t34 24t23.5 31l81 -26q-19 -33 -48 -57.5 t-61 -41t-64 -24.5t-57 -8l-23 -110h-44zM119 221q0 -27 6.5 -52t19.5 -45t31 -33.5t41 -18.5l80 377q-38 -5 -70.5 -27.5t-56.5 -54.5t-37.5 -70.5t-13.5 -75.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 491,
    d: "M69 375h82q-8 35 -18 69t-10 68q0 42 19 78.5t50 64.5t71 44t82 16q54 0 96 -28t63 -77l-60 -54q-14 39 -46 62.5t-70 23.5q-24 0 -47 -10t-40 -28t-27.5 -41.5t-10.5 -50.5q0 -32 10.5 -65.5t18.5 -71.5h172l-15 -68h-149q0 -29 -5 -54.5t-20 -52.5t-42.5 -58.5 t-71.5 -72.5q37 10 72 10q19 0 35.5 -3t31.5 -6l30 -6t32 -3q18 0 38 4.5t46 13.5l7 -67q-26 -13 -55.5 -20t-55.5 -7q-21 0 -40.5 4t-38.5 8.5t-39 8.5t-42 4q-23 0 -54 -5t-59 -13l-8 64q46 40 76.5 70.5t49 59t26.5 57t8 64.5h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 567,
    d: "M181 486q22 17 49.5 26t59.5 9t59 -9t50 -26l71 72l41 -41l-72 -72q33 -47 33 -108q0 -60 -34 -108l73 -72l-36 -36l-74 69q-22 -17 -50 -26.5t-61 -9.5t-61 9.5t-51 26.5l-73 -69l-36 36l72 72q-16 23 -24.5 50.5t-8.5 57.5q0 62 32 108l-71 72l41 41zM180 336 q0 -26 8.5 -48t23.5 -38t35 -25.5t43 -9.5t43 9.5t35 26t23.5 39t8.5 48.5t-8.5 48t-23.5 38.5t-35 25.5t-43 9t-43 -9.5t-35 -26t-23.5 -39t-8.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 660,
    d: "M450 377h77l-13 -60h-109l-45 -58l-6 -28h142l-12 -60h-143l-36 -171h-90l36 171h-140l13 60h140l7 30l-19 56h-110l13 60h78l-120 333h98l121 -370l281 370h99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 296,
    d: "M191 273v-403h-76v403h76zM191 775v-403h-76v403h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 498,
    d: "M392 201q23 -20 23 -69q0 -57 -24.5 -98.5t-61 -68.5t-79 -40t-78.5 -13q-35 0 -63 9t-49.5 23t-37 31t-25.5 32l68 54q26 -34 55 -49.5t66 -15.5q23 0 47 8t43.5 22.5t32 36t12.5 48.5q0 19 -8 31t-21 19t-28.5 9.5t-31.5 3.5q-74 5 -116.5 39t-42.5 97q0 39 15 68 t29 45q-11 11 -17.5 33.5t-6.5 49.5q0 45 21 83.5t54 66t74.5 43.5t83.5 16q38 0 65 -9.5t46.5 -24.5t31.5 -33.5t20 -36.5l-75 -32q-9 31 -38 44t-62 13q-24 0 -47 -8t-42 -23.5t-30.5 -37t-11.5 -48.5q0 -39 26 -54t66 -16q31 0 60.5 -7t53 -22.5t38 -40t14.5 -60.5 q0 -38 -16 -69.5t-33 -48.5zM158 310q0 -33 18 -47.5t43.5 -20t52 -7.5t43.5 -10q17 12 28.5 34.5t11.5 45.5q0 20 -8.5 34t-22 22.5t-29.5 12t-32 3.5q-43 0 -69 13q-14 -12 -25 -33.5t-11 -46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 357,
    d: "M73 624l22 102h74l-22 -102h-74zM230 624l22 102h73l-21 -102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 849,
    d: "M434 -7q-80 0 -147.5 27.5t-116.5 76t-77 114.5t-28 144q0 77 28 143t77 114t116.5 75.5t147.5 27.5t148.5 -27.5t118.5 -75.5t78 -114t28 -143q0 -78 -28 -144t-78 -114.5t-118.5 -76t-148.5 -27.5zM434 31q70 0 130.5 23.5t105.5 66t70.5 101.5t25.5 131 q0 69 -25 128.5t-69.5 103t-105 68t-132.5 24.5q-71 0 -131 -24.5t-104 -68t-69 -102.5t-25 -128t25 -128t69 -102.5t104 -68t131 -24.5zM442 121q-49 0 -92.5 17t-76 48t-51.5 74t-19 95q0 43 14.5 85t43.5 75.5t73 54t103 20.5q70 0 123.5 -30t77.5 -86l-85 -27 q-9 20 -23.5 33t-30 20.5t-32 10.5t-30.5 3q-36 0 -63 -13.5t-45 -36t-27 -51t-9 -58.5q0 -38 13.5 -67.5t34.5 -49.5t47 -30.5t51 -10.5q35 0 69.5 18.5t50.5 51.5l85 -26q-8 -20 -26 -41.5t-44 -39t-59.5 -28.5t-72.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 418,
    d: "M165 344q-42 0 -67 26t-25 65q0 29 13 53t36 41.5t53.5 27.5t65.5 10q51 0 87 -17l5 25q3 13 3 24q0 29 -17.5 45.5t-50.5 16.5q-26 0 -54.5 -10.5t-61.5 -30.5l-13 45q76 46 145 46q58 0 90 -26t32 -77q0 -10 -1.5 -20t-3.5 -21l-28 -131q-1 -3 -1 -9q0 -14 16 -15 l-13 -62q-15 -3 -27 -3q-44 0 -44 32q0 5 1 10.5t3 19.5q-30 -32 -67.5 -48.5t-75.5 -16.5zM196 397q17 0 36 5.5t35 14.5t27 20.5t14 23.5l10 48q-15 8 -34.5 11.5t-39.5 3.5q-44 0 -73.5 -20.5t-29.5 -53.5q0 -23 15 -38t40 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 576,
    d: "M36 280l280 181l-16 -74l-198 -128l144 -125l-16 -74l-204 174zM270 280l280 181l-15 -74l-198 -128l144 -125l-16 -74l-204 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 571,
    d: "M517 375l-55 -255h-75l37 175h-359l17 80h435z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 560,
    d: "M48 233l17 80h435l-17 -80h-435z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 849,
    d: "M435 -7q-80 0 -147.5 27.5t-117 76t-77.5 114.5t-28 144q0 77 28 143t77.5 114t117 75.5t147.5 27.5t148 -27.5t118 -75.5t78 -114t28 -143q0 -78 -28 -144t-78 -114.5t-118 -76t-148 -27.5zM435 30q70 0 130 23.5t104.5 66.5t70 102.5t25.5 131.5q0 69 -25 128 t-69 102.5t-104.5 68t-131.5 24.5t-131.5 -24.5t-104 -68t-68 -102.5t-24.5 -127q0 -69 24.5 -128.5t68 -103t104 -68.5t131.5 -25zM280 579h192q30 0 55 -12.5t43 -33t28 -46.5t10 -52q0 -47 -26.5 -84.5t-69.5 -48.5l109 -172h-73l-102 162h-101v-162h-65v449zM469 349 q36 0 55.5 24t19.5 62t-22.5 61.5t-55.5 23.5h-121v-171h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 385,
    d: "M83 652l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 265,
    d: "M182 546q-31 0 -50 19.5t-19 50.5q0 20 8.5 39.5t23 34.5t34 24.5t41.5 9.5q32 0 50.5 -20.5t18.5 -50.5q0 -22 -8.5 -41.5t-23.5 -34t-34.5 -23t-40.5 -8.5zM192 593q17 0 33 15t16 35q0 15 -8.5 24.5t-22.5 9.5q-18 0 -34 -14.5t-16 -34.5q0 -17 9 -26t23 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 485,
    d: "M64 51v72h332v-72h-332zM396 404v-72h-126v-136h-80v136h-126v72h126v136h80v-136h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 383,
    d: "M56 400q8 39 21.5 68.5t33 51.5t45.5 38.5t61 29.5q26 10 53 19.5t49 21.5t36 29t14 43q0 24 -19.5 40t-58.5 16q-46 0 -79 -18t-52 -35l-27 39q6 7 21 18.5t38 22.5t53 19t65 8q62 0 92 -27.5t30 -71.5q0 -60 -40.5 -93t-120.5 -59q-31 -10 -52 -23t-34.5 -27 t-20.5 -28.5t-10 -27.5h218l-12 -54h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 379,
    d: "M204 394q-57 0 -91.5 24t-43.5 62l40 38q0 -11 6.5 -22.5t19 -22t32.5 -17t47 -6.5q23 0 44.5 5t38 14.5t26.5 23t10 29.5q0 30 -34 45.5t-94 15.5h-22l10 51h22q66 0 104.5 17.5t38.5 52.5q0 27 -23.5 41.5t-58.5 14.5q-37 0 -68.5 -15t-51.5 -39l-27 43q25 29 69 45.5 t89 16.5q60 0 95.5 -27t35.5 -71q0 -38 -28.5 -64.5t-80.5 -37.5q38 -6 58.5 -29.5t20.5 -57.5q0 -31 -16.5 -55.5t-43 -41t-59 -25t-65.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 222,
    d: "M83 609l-54 20l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    d: "M124 522h88l-63 -296q-9 -39 -9 -69q0 -91 80 -91q49 0 100 34.5t86 94.5l70 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 23 -19l-17 -76q-11 -2 -20 -3t-16 -1q-26 0 -40.5 11.5t-14.5 31.5q0 9 2 23.5t10 49.5q-16 -24 -39 -46t-50 -39t-56 -27t-57 -10 q-43 0 -64 22.5t-25 54.5l-54 -279h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 595,
    d: "M64 412q0 67 23 122t65.5 94t103 60.5t135.5 21.5h248l-15 -68h-66l-154 -722h-76l65 304h-62l-65 -304h-76l65 304q-91 2 -141 52t-50 136zM141 428q0 -66 36.5 -99t91.5 -37l75 350q-48 -1 -85.5 -17.5t-63.5 -45t-40 -67.5t-14 -84zM482 642h-62l-75 -350h62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 199,
    d: "M50 245l26 124h74l-26 -124h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 283,
    d: "M14 -126q11 -7 32.5 -13t46.5 -6q29 0 46 10t17 32q0 16 -11.5 22t-30.5 6q-20 0 -43 -4.5t-36 -8.5l78 109l36 -14l-45 -55q8 3 17.5 4t17.5 1q29 0 46 -12.5t17 -38.5q0 -39 -31.5 -63.5t-92.5 -24.5q-29 0 -52 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 269,
    d: "M282 455l-12 -55h-201l12 55h76l62 294q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l12 55q15 0 32.5 8.5t33 18.5t26 19t10.5 10h56l-76 -356h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 431,
    d: "M223 344q-34 0 -60 12t-43.5 32t-26.5 47t-9 57q0 43 17 82.5t46.5 70t69 48.5t84.5 18q33 0 59 -11.5t44 -31.5t27 -47t9 -58q0 -42 -17 -81.5t-46 -70t-69 -49t-85 -18.5zM236 405q25 0 48.5 12t42 32t30 47t11.5 57q0 42 -22 69t-58 27q-25 0 -48.5 -11.5t-42 -32 t-30 -47.5t-11.5 -57q0 -42 22 -69t58 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 576,
    d: "M521 234l-278 -174l15 74l197 125l-143 128l16 74l203 -181zM286 234l-278 -174l16 74l197 125l-143 128l15 74l203 -181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 818,
    d: "M629 100h-214l11 53l285 253h38l-54 -252h57l-12 -54h-56l-21 -100h-55zM643 154l38 180l-198 -180h160zM272 375l-12 -55h-201l12 55h76l62 294q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l12 55q15 0 32.5 8.5t33 18.5t26 19t10.5 10h56l-76 -356h70zM82 33 l338 337l327 345l35 -37l-334 -335l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 847,
    d: "M444 0q8 39 21 68.5t31.5 51.5t44.5 38.5t59 29.5q25 10 51 19t47 21t34.5 29t13.5 43q0 25 -18.5 41t-56.5 16q-44 0 -76.5 -18.5t-50.5 -35.5l-26 40q6 7 21 18.5t37 22.5t50.5 19t62.5 8q60 0 89 -27.5t29 -71.5q0 -30 -9 -52t-27.5 -39.5t-48 -32t-70.5 -28.5 q-30 -10 -50.5 -23t-33 -27t-19.5 -28.5t-10 -27.5h217l-11 -54h-301zM273 375l-12 -55h-201l12 55h76l62 294q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l12 55q15 0 32.5 8.5t33 18.5t26 19t10.5 10h56l-76 -356h70zM48 33l338 337l327 345l35 -37l-334 -335 l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 825,
    d: "M189 314q-60 0 -95 23t-37 63l40 38q0 -11 6.5 -23t19 -22t32 -16.5t45.5 -6.5q24 0 46 5t38.5 15t26.5 23t10 30q0 29 -34 44.5t-94 15.5h-22l10 51h22q66 0 104.5 17.5t38.5 53.5q0 26 -24 40.5t-57 14.5q-38 0 -69.5 -15t-51.5 -39l-27 43q25 29 68.5 45.5t90.5 16.5 q59 0 94.5 -27t35.5 -69q0 -41 -28.5 -67t-80.5 -37q38 -6 58.5 -30t20.5 -56t-16 -56t-42.5 -41t-60 -25.5t-68.5 -8.5zM635 100h-214l11 53l285 253h38l-54 -252h57l-12 -54h-56l-21 -100h-55zM649 154l38 180l-198 -180h160zM111 33l338 337l327 345l35 -37l-334 -335 l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 457,
    d: "M322 295q-11 -54 -37 -94.5t-77 -69.5q-22 -13 -50.5 -27.5t-54 -34.5t-43 -48.5t-17.5 -68.5q0 -45 27.5 -68.5t65.5 -23.5q23 0 45.5 7.5t43 20.5t38 30.5t30.5 36.5l51 -39q-20 -31 -45.5 -55t-55.5 -40.5t-62 -25t-63 -8.5t-59 9.5t-49.5 28t-34 47t-12.5 67.5 q0 48 13 81t34.5 57.5t51 42.5t62.5 35q20 10 39.5 21t36 26.5t29 37.5t19.5 55h74zM365 506l-25 -116h-73l24 116h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM340 917h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM432 795l-54 20l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM312 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM495 813q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5 q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM309 811l22 102h74l-22 -102h-74zM466 811l22 102h73l-21 -102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM364 834q0 37 28 59.5t67 22.5q31 0 48 -15t17 -41q0 -36 -27 -59t-68 -23q-30 0 -47.5 15t-17.5 41zM452 885q-18 0 -32.5 -12.5t-14.5 -32.5q0 -13 8.5 -22t22.5 -9 q17 0 32.5 12.5t15.5 32.5q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 924,
    d: "M500 710h466l-17 -80h-353l-48 -228h301l-17 -80h-301l-52 -242h361l-17 -80h-450l45 208h-235l-165 -208h-98zM428 288l68 317l-256 -317h188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 649,
    d: "M177 -126q11 -7 32.5 -13t46.5 -6q29 0 46 10t17 32q0 16 -11.5 22t-30.5 6q-20 0 -43 -4.5t-36 -8.5l60 84q-52 7 -92.5 34t-68 68t-42 91.5t-14.5 104.5q0 73 30.5 148t84.5 135.5t128.5 98.5t162.5 38q45 0 81.5 -11.5t64.5 -32t46 -49t27 -62.5l-81 -46q-8 34 -24 57 t-37.5 37t-47 20t-50.5 6q-65 0 -119 -31t-93 -79.5t-60.5 -107.5t-21.5 -116q0 -45 12 -86t35 -71.5t56 -48.5t75 -18q26 0 55.5 7t58 22.5t55.5 39t48 56.5l66 -41q-24 -38 -58 -68t-73 -51t-80.5 -32.5t-80.5 -12.5l-34 -43q8 3 17.5 4t17.5 1q29 0 46 -12.5t17 -38.5 q0 -39 -31.5 -63.5t-92.5 -24.5q-29 0 -52 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459zM351 917h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 580,
    d: "M432 795l-54 20l76 101h87zM171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 580,
    d: "M303 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 580,
    d: "M304 811l22 102h74l-22 -102h-74zM461 811l22 102h73l-21 -102h-74zM171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM164 917h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM229 795l-54 20l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM110 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM121 811l22 102h74l-22 -102h-74zM278 811l22 102h73l-21 -102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 699,
    d: "M57 391h53l68 319h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235l68 323h-53zM279 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145l-51 -239h151l-14 -68h-152l-51 -243 h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 739,
    d: "M171 710h70l294 -553l117 552h90l-151 -709h-75l-291 542l-115 -542h-90zM538 813q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16 t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 721,
    d: "M295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70 t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18zM421 917h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 721,
    d: "M474 795l-54 20l76 101h87zM295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119 q0 44 -11.5 84t-34 70t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 721,
    d: "M352 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5 t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 721,
    d: "M295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70 t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18zM532 813q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15 t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 721,
    d: "M356 811l22 102h74l-22 -102h-74zM513 811l22 102h73l-21 -102h-74zM295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76 q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 471,
    d: "M400 157l-56 -55l-116 116l-116 -116l-55 56l115 115l-113 114l56 55l113 -113l114 114l55 -56l-113 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 721,
    d: "M728 710l-84 -99q27 -40 41 -89t14 -102q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36q-42 0 -77 12t-64 33l-34 -40h-98l80 93q-29 40 -43.5 90.5t-14.5 104.5q0 81 34 158t90.5 137t130 96t151.5 36q43 0 78.5 -13t64.5 -36l37 44h98zM136 296q0 -36 7 -69 t22 -60l368 430q-20 17 -45.5 26.5t-56.5 9.5q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 70 -27 124l-367 -428q42 -33 100 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 724,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z M401 917h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 724,
    d: "M464 795l-54 20l76 101h87zM298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5 t-105.5 -77.5t-138.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 724,
    d: "M339 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359 q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 724,
    d: "M347 811l22 102h74l-22 -102h-74zM504 811l22 102h73l-21 -102h-74zM298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90 l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 612,
    d: "M248 261l-159 449h99l122 -370l281 370h98l-352 -451l-55 -259h-90zM404 795l-54 20l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 581,
    d: "M171 710h90l-29 -137h174q39 0 69 -16t51 -42t32 -60t11 -70q0 -49 -20.5 -96.5t-55 -85.5t-80.5 -61.5t-98 -23.5h-180l-25 -118h-90zM328 198q31 0 58 15.5t47 41t32 57.5t12 64q0 49 -25 83t-67 34h-170l-63 -295h176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 532,
    d: "M184 75q44 1 82 11t65.5 31t43 52.5t15.5 75.5q0 51 -30 81.5t-83 30.5h-19l17 80h18q26 0 48.5 9.5t39.5 26t26.5 39t9.5 49.5q0 39 -24 58t-58 19q-29 0 -52 -11t-40.5 -30t-29 -43t-17.5 -51l-107 -503h-84l110 517q9 43 31.5 79.5t54.5 62.5t71.5 40.5t82.5 14.5 q67 0 108.5 -36.5t41.5 -96.5q0 -30 -11.5 -59.5t-29.5 -53.5t-41.5 -41.5t-47.5 -24.5q53 -12 79.5 -54.5t26.5 -98.5q0 -61 -24.5 -107.5t-67 -78.5t-100 -49.5t-122.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM262 730h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM354 609l-54 20l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM223 640l116 90h64l77 -90l-53 -24l-67 63 l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM402 627q-21 0 -36 6.5t-27 14.5t-24 14.5 t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM232 624l22 102h74l-22 -102h-74zM389 624 l22 102h73l-21 -102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM272 648q0 37 28 59.5t67 22.5q31 0 48 -15 t17 -41q0 -36 -27 -59t-68 -23q-30 0 -47.5 15t-17.5 41zM360 699q-18 0 -32.5 -12.5t-14.5 -32.5q0 -13 8.5 -22t22.5 -9q17 0 32.5 12.5t15.5 32.5q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 888,
    d: "M133 -10q-33 0 -58.5 10t-43.5 28t-27.5 42.5t-9.5 53.5q0 42 19 76.5t52.5 60t78.5 39.5t96 14q32 0 63 -5.5t55 -14.5q8 26 17.5 44.5t9.5 42.5q0 36 -27 61t-78 25q-38 0 -80 -15.5t-90 -45.5l-16 57q112 68 209 68q60 0 98.5 -25t52.5 -70q41 43 94 69t113 26 q48 0 85 -17t62.5 -47t39 -70t13.5 -86q0 -38 -6.5 -56t-8.5 -24h-417q-3 -15 -3 -30q0 -32 10 -59t28.5 -46t43.5 -29.5t55 -10.5q23 0 46 6.5t44 17.5t38.5 27t29.5 36l72 -21q-18 -29 -44.5 -53t-59 -41.5t-68.5 -27.5t-74 -10q-68 0 -115 31t-69 82q-23 -31 -52.5 -52.5 t-61 -35t-62 -19.5t-54.5 -6zM169 56q24 0 52 8t53 22t44.5 31.5t26.5 37.5q-3 13 -3 33q0 29 5 54q-49 19 -104 19q-35 0 -65 -9t-51.5 -24.5t-34 -37.5t-12.5 -49q0 -35 22.5 -60t66.5 -25zM775 288q2 8 2 16.5v16.5q0 65 -35.5 104.5t-97.5 39.5q-35 0 -67 -13 t-59.5 -36.5t-48 -56t-30.5 -71.5h336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 531,
    d: "M118 -126q11 -7 32.5 -13t46.5 -6q29 0 46 10t17 32q0 16 -11.5 22t-30.5 6q-20 0 -43 -4.5t-36 -8.5l57 80q-42 5 -74 24t-54.5 48t-34 66.5t-11.5 79.5q0 63 25 121t67.5 102.5t100.5 71t124 26.5q75 0 121.5 -34.5t61.5 -92.5l-91 -27q-11 37 -40 57.5t-70 20.5 q-40 0 -77.5 -18.5t-66.5 -50t-46.5 -74.5t-17.5 -91q0 -33 9 -61.5t25.5 -49t40 -32.5t51.5 -12q21 0 43.5 6.5t42 17.5t35.5 25.5t25 31.5l81 -26q-33 -55 -94 -90.5t-133 -39.5l-31 -39q8 3 17.5 4t17.5 1q29 0 46 -12.5t17 -38.5q0 -39 -31.5 -63.5t-92.5 -24.5 q-29 0 -52 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18zM282 730h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 539,
    d: "M344 609l-54 20l76 101h87zM228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5 q46 0 90 23.5t69 63.5l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 539,
    d: "M234 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59 t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 539,
    d: "M236 624l22 102h74l-22 -102h-74zM393 624l22 102h73l-21 -102h-74zM228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11 q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56 t-73.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88zM98 730h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 226,
    d: "M181 609l-54 20l76 101h87zM116 522h88l-111 -522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 226,
    d: "M60 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM116 522h88l-111 -522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 226,
    d: "M62 624l22 102h74l-22 -102h-74zM219 624l22 102h73l-21 -102h-74zM116 522h88l-111 -522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 583,
    d: "M563 676l-87 -48q40 -62 56.5 -129.5t16.5 -126.5q0 -88 -28.5 -158.5t-75.5 -120t-106.5 -76.5t-120.5 -27q-44 0 -81 15.5t-63.5 42.5t-41 64t-14.5 79q0 56 24.5 107t65 90t92.5 62t106 23q59 0 101 -28.5t58 -76.5q0 17 -1 32.5t-3 31.5q-5 42 -18.5 82t-40.5 80 l-110 -62l-19 37l103 58q-22 26 -51 51.5t-67 51.5h122q41 -29 72 -68l92 51zM109 202q0 -29 9.5 -53.5t26 -43t40 -29t52.5 -10.5q39 0 76 17t65.5 45t45.5 64.5t17 75.5q0 28 -9.5 52.5t-26.5 42.5t-40.5 28t-52.5 10q-39 0 -75.5 -16t-65 -43.5t-45.5 -63.5t-17 -76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 567,
    d: "M116 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5q0 -22 -3.5 -46t-8.5 -50l-66 -312h-88l62 292q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88zM385 627q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5 q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 578,
    d: "M222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5 t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5zM277 730h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 578,
    d: "M349 609l-54 20l76 101h87zM222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5 q0 33 -9 61t-25.5 48.5t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 578,
    d: "M229 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19 t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 578,
    d: "M222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5 t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5zM410 627q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15 t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 578,
    d: "M241 624l22 102h74l-22 -102h-74zM398 624l22 102h73l-21 -102h-74zM222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66 q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 533,
    d: "M225 405v102h75v-102h-75zM225 66v102h75v-102h-75zM61 251v72h403v-72h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 578,
    d: "M72 57q-25 29 -37.5 68t-12.5 83q0 63 25.5 121t68.5 103t100.5 72t121.5 27q36 0 66.5 -10.5t54.5 -28.5l32 32h55l-59 -59q26 -30 39 -69t13 -84q0 -62 -25 -120t-68 -103t-100.5 -72t-122.5 -27q-38 0 -69 10.5t-55 29.5l-32 -32h-54zM239 66q39 0 76 19t66.5 51 t47.5 74.5t18 90.5q0 55 -25 96l-262 -302q32 -29 79 -29zM113 219q0 -55 25 -96l260 302q-32 30 -77 30q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5zM268 730h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 577,
    d: "M331 609l-54 20l76 101h87zM155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5 t9 47.5q-45 -59 -106 -90.5t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 577,
    d: "M230 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1 q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 577,
    d: "M231 624l22 102h74l-22 -102h-74zM388 624l22 102h73l-21 -102h-74zM155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3 t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 501,
    d: "M-35 -153q31 4 53.5 10.5t40 17t32.5 27.5t32 43l29 44l-101 533h91l72 -443l34 56q42 69 71 121t49.5 96t34.5 84.5t26 85.5h87q-14 -48 -29 -90t-38 -88.5t-56.5 -103.5t-82.5 -137l-80 -129q-34 -55 -64 -92.5t-59.5 -60.5t-61 -33.5t-68.5 -11.5zM296 609l-54 20 l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 578,
    d: "M156 710h90l-55 -261q29 35 69 60t96 25q46 0 80.5 -18t57.5 -48t35 -68.5t12 -78.5q0 -57 -22.5 -117t-62.5 -109.5t-95.5 -81t-122.5 -31.5q-60 0 -89.5 24t-40.5 54l-58 -273h-90zM254 62q41 0 77 20.5t62.5 54t41.5 76.5t15 88q0 31 -7.5 59t-22.5 49t-37 33t-51 12 q-24 0 -47 -9t-44 -24t-39.5 -35t-33.5 -42l-36 -171q-1 -4 -1.5 -7t-0.5 -8q0 -18 9.5 -35.5t26 -31t39.5 -21.5t49 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 501,
    d: "M-35 -153q31 4 53.5 10.5t40 17t32.5 27.5t32 43l29 44l-101 533h91l72 -443l34 56q42 69 71 121t49.5 96t34.5 84.5t26 85.5h87q-14 -48 -29 -90t-38 -88.5t-56.5 -103.5t-82.5 -137l-80 -129q-34 -55 -64 -92.5t-59.5 -60.5t-61 -33.5t-68.5 -11.5zM178 624l22 102h74 l-22 -102h-74zM335 624l22 102h73l-21 -102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM300 838l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM226 652l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM438 848q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM349 662q20 0 40 19.5t29 48.5h50 q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 652,
    d: "M494 -181q-34 7 -51 24.5t-17 40.5q0 29 23 57.5t74 58.5h-41l-34 208h-278l-121 -208h-96l425 710h77l123 -710q-54 -31 -76 -53.5t-22 -45.5q0 -32 45 -36zM444 278l-49 328l-193 -328h242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    d: "M410 -181q-34 7 -51 24.5t-17 40.5q0 29 22.5 57t72.5 58q-35 8 -35 42q0 16 9 57q-39 -51 -94 -79.5t-109 -28.5q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414 q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-54 -31 -76 -53.5t-22 -45.5q0 -32 45 -36zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5 t41.5 -33t54 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 653,
    d: "M471 795l-54 20l76 101h87zM293 -6q-59 0 -105.5 25.5t-78 67.5t-48 96t-16.5 111q0 73 30.5 148t84.5 135.5t128.5 98.5t162.5 38q45 0 81.5 -11.5t64.5 -32t46 -49t27 -62.5l-81 -46q-8 34 -24 57t-37.5 37t-47 20t-50.5 6q-65 0 -119 -31t-93 -79.5t-60.5 -107.5 t-21.5 -116q0 -45 12 -86t35 -71.5t56 -48.5t75 -18q26 0 55.5 7t58 22.5t55.5 39t48 56.5l66 -41q-24 -40 -60 -70.5t-77 -51.5t-84.5 -32t-82.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 531,
    d: "M342 609l-54 20l76 101h87zM225 -10q-48 0 -85.5 17.5t-64 47.5t-40 70t-13.5 85q0 63 25 121t67.5 102.5t100.5 71t124 26.5q75 0 121.5 -34.5t61.5 -92.5l-91 -27q-11 37 -40 57.5t-70 20.5q-40 0 -77.5 -18.5t-66.5 -50t-46.5 -74.5t-17.5 -91q0 -33 9 -61.5t25.5 -49 t40 -32.5t51.5 -12q21 0 43.5 6.5t42 17.5t35.5 25.5t25 31.5l81 -26q-17 -29 -42.5 -53t-57 -41t-67.5 -27t-74 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 653,
    d: "M357 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM293 -6q-59 0 -105.5 25.5t-78 67.5t-48 96t-16.5 111q0 73 30.5 148t84.5 135.5t128.5 98.5t162.5 38q45 0 81.5 -11.5t64.5 -32t46 -49t27 -62.5l-81 -46q-8 34 -24 57t-37.5 37t-47 20t-50.5 6q-65 0 -119 -31 t-93 -79.5t-60.5 -107.5t-21.5 -116q0 -45 12 -86t35 -71.5t56 -48.5t75 -18q26 0 55.5 7t58 22.5t55.5 39t48 56.5l66 -41q-24 -40 -60 -70.5t-77 -51.5t-84.5 -32t-82.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 531,
    d: "M231 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM225 -10q-48 0 -85.5 17.5t-64 47.5t-40 70t-13.5 85q0 63 25 121t67.5 102.5t100.5 71t124 26.5q75 0 121.5 -34.5t61.5 -92.5l-91 -27q-11 37 -40 57.5t-70 20.5q-40 0 -77.5 -18.5t-66.5 -50t-46.5 -74.5t-17.5 -91 q0 -33 9 -61.5t25.5 -49t40 -32.5t51.5 -12q21 0 43.5 6.5t42 17.5t35.5 25.5t25 31.5l81 -26q-17 -29 -42.5 -53t-57 -41t-67.5 -27t-74 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 653,
    d: "M293 -6q-59 0 -105.5 25.5t-78 67.5t-48 96t-16.5 111q0 73 30.5 148t84.5 135.5t128.5 98.5t162.5 38q45 0 81.5 -11.5t64.5 -32t46 -49t27 -62.5l-81 -46q-8 34 -24 57t-37.5 37t-47 20t-50.5 6q-65 0 -119 -31t-93 -79.5t-60.5 -107.5t-21.5 -116q0 -45 12 -86 t35 -71.5t56 -48.5t75 -18q26 0 55.5 7t58 22.5t55.5 39t48 56.5l66 -41q-24 -40 -60 -70.5t-77 -51.5t-84.5 -32t-82.5 -11zM441 810l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 531,
    d: "M225 -10q-48 0 -85.5 17.5t-64 47.5t-40 70t-13.5 85q0 63 25 121t67.5 102.5t100.5 71t124 26.5q75 0 121.5 -34.5t61.5 -92.5l-91 -27q-11 37 -40 57.5t-70 20.5q-40 0 -77.5 -18.5t-66.5 -50t-46.5 -74.5t-17.5 -91q0 -33 9 -61.5t25.5 -49t40 -32.5t51.5 -12 q21 0 43.5 6.5t42 17.5t35.5 25.5t25 31.5l81 -26q-17 -29 -42.5 -53t-57 -41t-67.5 -27t-74 -10zM317 624l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 653,
    d: "M367 892l53 24l67 -63l94 63l43 -24l-116 -90h-64zM293 -6q-59 0 -105.5 25.5t-78 67.5t-48 96t-16.5 111q0 73 30.5 148t84.5 135.5t128.5 98.5t162.5 38q45 0 81.5 -11.5t64.5 -32t46 -49t27 -62.5l-81 -46q-8 34 -24 57t-37.5 37t-47 20t-50.5 6q-65 0 -119 -31 t-93 -79.5t-60.5 -107.5t-21.5 -116q0 -45 12 -86t35 -71.5t56 -48.5t75 -18q26 0 55.5 7t58 22.5t55.5 39t48 56.5l66 -41q-24 -40 -60 -70.5t-77 -51.5t-84.5 -32t-82.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 531,
    d: "M241 706l53 24l67 -63l94 63l43 -24l-116 -90h-64zM225 -10q-48 0 -85.5 17.5t-64 47.5t-40 70t-13.5 85q0 63 25 121t67.5 102.5t100.5 71t124 26.5q75 0 121.5 -34.5t61.5 -92.5l-91 -27q-11 37 -40 57.5t-70 20.5q-40 0 -77.5 -18.5t-66.5 -50t-46.5 -74.5t-17.5 -91 q0 -33 9 -61.5t25.5 -49t40 -32.5t51.5 -12q21 0 43.5 6.5t42 17.5t35.5 25.5t25 31.5l81 -26q-17 -29 -42.5 -53t-57 -41t-67.5 -27t-74 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 692,
    d: "M310 892l53 24l67 -63l94 63l43 -24l-116 -90h-64zM171 710h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235zM272 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145 l-117 -550h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    d: "M646 629l76 101h87l-109 -121zM208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l67 312h88l-132 -622q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1 q-28 0 -42.5 12.5t-14.5 32.5q0 9 2 22t7 35q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 699,
    d: "M57 391h53l68 319h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235l68 323h-53zM279 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145l-51 -239h151l-14 -68h-152l-51 -243 h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M427 657h91l16 73h88l-16 -73h77l-12 -56h-77l-104 -493q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 8 2 21t7 36q-39 -51 -94 -79.5t-109 -28.5q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5 q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l39 183h-91zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33 t54 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459zM284 838l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18zM216 652l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459zM417 848q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18zM354 662q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44 t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459zM379 810l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18zM316 624l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-196q-54 -31 -76 -53.5t-22 -45.5q0 -32 45 -36l-31 -46q-34 7 -51 24.5t-17 40.5q0 29 23 57.5t74 58.5h-208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 539,
    d: "M192 -186q-34 7 -51 24.5t-17 40.5q0 28 21.5 55t68.5 56q-46 3 -81.5 21t-60 47t-37 68t-12.5 84q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5 t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5l71 -21q-32 -49 -84.5 -83t-113.5 -45q-53 -30 -74.5 -52.5t-21.5 -45.5q0 -32 45 -36zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5 q0 38 -27.5 56t-73.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 580,
    d: "M302 892l53 24l67 -63l94 63l43 -24l-116 -90h-64zM171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 539,
    d: "M243 706l53 24l67 -63l94 63l43 -24l-116 -90h-64zM228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59 t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 686,
    d: "M341 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM516 95q-55 -51 -110.5 -75.5t-113.5 -24.5q-57 0 -103 24.5t-78 66t-49 95t-17 111.5q0 81 33.5 157t89 135.5t127.5 95t150 35.5q98 0 152.5 -43t73.5 -112l-79 -48q-17 62 -60.5 92t-105.5 30q-59 0 -112 -29.5 t-92.5 -77t-62.5 -108t-23 -122.5q0 -46 12.5 -86t36 -70t57 -47.5t74.5 -17.5q54 0 108.5 27.5t111.5 85.5l21 97h-145l15 68h220l-75 -354h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 599,
    d: "M221 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM164 -223q-84 0 -131 31t-71 84l60 45q20 -46 61 -69t95 -23q34 0 66.5 10t59.5 30t46.5 50t28.5 71l19 92q-37 -48 -90.5 -76t-106.5 -28q-42 0 -75.5 17t-56.5 46.5t-35 68t-12 81.5q0 63 24 121.5t64.5 103.5t94 72 t112.5 27q62 0 100.5 -32t59.5 -81l22 104h78l-110 -516q-12 -56 -40.5 -98.5t-69 -71.5t-90.5 -44t-103 -15zM244 66q26 0 52.5 10t50 26.5t42 37.5t28.5 43l32 150q-4 27 -16 49t-29 38.5t-39 25.5t-46 9q-43 0 -80.5 -21.5t-65.5 -55t-44 -75.5t-16 -82q0 -32 9.5 -60 t26.5 -49t41 -33.5t54 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 686,
    d: "M516 95q-55 -51 -110.5 -75.5t-113.5 -24.5q-57 0 -103 24.5t-78 66t-49 95t-17 111.5q0 81 33.5 157t89 135.5t127.5 95t150 35.5q98 0 152.5 -43t73.5 -112l-79 -48q-17 62 -60.5 92t-105.5 30q-59 0 -112 -29.5t-92.5 -77t-62.5 -108t-23 -122.5q0 -46 12.5 -86 t36 -70t57 -47.5t74.5 -17.5q54 0 108.5 27.5t111.5 85.5l21 97h-145l15 68h220l-75 -354h-76zM467 848q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 599,
    d: "M164 -223q-84 0 -131 31t-71 84l60 45q20 -46 61 -69t95 -23q34 0 66.5 10t59.5 30t46.5 50t28.5 71l19 92q-37 -48 -90.5 -76t-106.5 -28q-42 0 -75.5 17t-56.5 46.5t-35 68t-12 81.5q0 63 24 121.5t64.5 103.5t94 72t112.5 27q62 0 100.5 -32t59.5 -81l22 104h78 l-110 -516q-12 -56 -40.5 -98.5t-69 -71.5t-90.5 -44t-103 -15zM244 66q26 0 52.5 10t50 26.5t42 37.5t28.5 43l32 150q-4 27 -16 49t-29 38.5t-39 25.5t-46 9q-43 0 -80.5 -21.5t-65.5 -55t-44 -75.5t-16 -82q0 -32 9.5 -60t26.5 -49t41 -33.5t54 -12.5zM342 662 q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 686,
    d: "M516 95q-55 -51 -110.5 -75.5t-113.5 -24.5q-57 0 -103 24.5t-78 66t-49 95t-17 111.5q0 81 33.5 157t89 135.5t127.5 95t150 35.5q98 0 152.5 -43t73.5 -112l-79 -48q-17 62 -60.5 92t-105.5 30q-59 0 -112 -29.5t-92.5 -77t-62.5 -108t-23 -122.5q0 -46 12.5 -86 t36 -70t57 -47.5t74.5 -17.5q54 0 108.5 27.5t111.5 85.5l21 97h-145l15 68h220l-75 -354h-76zM431 810l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 599,
    d: "M164 -223q-84 0 -131 31t-71 84l60 45q20 -46 61 -69t95 -23q34 0 66.5 10t59.5 30t46.5 50t28.5 71l19 92q-37 -48 -90.5 -76t-106.5 -28q-42 0 -75.5 17t-56.5 46.5t-35 68t-12 81.5q0 63 24 121.5t64.5 103.5t94 72t112.5 27q62 0 100.5 -32t59.5 -81l22 104h78 l-110 -516q-12 -56 -40.5 -98.5t-69 -71.5t-90.5 -44t-103 -15zM244 66q26 0 52.5 10t50 26.5t42 37.5t28.5 43l32 150q-4 27 -16 49t-29 38.5t-39 25.5t-46 9q-43 0 -80.5 -21.5t-65.5 -55t-44 -75.5t-16 -82q0 -32 9.5 -60t26.5 -49t41 -33.5t54 -12.5zM298 624l23 106h79 l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 686,
    d: "M217 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM516 95q-55 -51 -110.5 -75.5t-113.5 -24.5q-57 0 -103 24.5t-78 66t-49 95t-17 111.5q0 81 33.5 157t89 135.5t127.5 95t150 35.5q98 0 152.5 -43t73.5 -112l-79 -48q-17 62 -60.5 92t-105.5 30q-59 0 -112 -29.5 t-92.5 -77t-62.5 -108t-23 -122.5q0 -46 12.5 -86t36 -70t57 -47.5t74.5 -17.5q54 0 108.5 27.5t111.5 85.5l21 97h-145l15 68h220l-75 -354h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 599,
    d: "M164 -223q-84 0 -131 31t-71 84l60 45q20 -46 61 -69t95 -23q34 0 66.5 10t59.5 30t46.5 50t28.5 71l19 92q-37 -48 -90.5 -76t-106.5 -28q-42 0 -75.5 17t-56.5 46.5t-35 68t-12 81.5q0 63 24 121.5t64.5 103.5t94 72t112.5 27q62 0 100.5 -32t59.5 -81l22 104h78 l-110 -516q-12 -56 -40.5 -98.5t-69 -71.5t-90.5 -44t-103 -15zM244 66q26 0 52.5 10t50 26.5t42 37.5t28.5 43l32 150q-4 27 -16 49t-29 38.5t-39 25.5t-46 9q-43 0 -80.5 -21.5t-65.5 -55t-44 -75.5t-16 -82q0 -32 9.5 -60t26.5 -49t41 -33.5t54 -12.5zM404 745l-37 -81 h25l-18 -84h-77l18 84l46 81h43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 713,
    d: "M336 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM171 710h90l-65 -307h365l65 307h90l-151 -710h-90l69 323h-365l-69 -323h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 567,
    d: "M276 640l107 89h59l72 -89l-49 -24l-62 62l-88 -62zM160 730h88l-68 -320q42 57 98.5 89t116.5 32q66 0 93 -36t27 -94q0 -43 -10 -89l-66 -312h-88l62 292q4 20 6 36.5t2 31.5q0 92 -77 92q-24 0 -50 -10.5t-51 -28.5t-47 -43t-36 -55l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 723,
    d: "M105 595h47l25 115h90l-25 -115h365l25 115h90l-25 -115h48l-10 -47h-48l-116 -548h-90l69 323h-365l-69 -323h-90l116 548h-47zM567 403l30 145h-365l-30 -145h365z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 567,
    d: "M75 657h69l16 73h88l-16 -73h99l-12 -56h-99l-40 -191q42 57 98.5 89t116.5 32q66 0 93 -36t27 -94q0 -43 -10 -89l-66 -312h-88l62 292q4 20 6 36.5t2 31.5q0 92 -77 92q-24 0 -50 -10.5t-51 -28.5t-47 -43t-36 -55l-67 -315h-88l127 601h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM299 813q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5 t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88zM238 627q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5 t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM104 838l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88zM41 652l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM232 848q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88zM179 662q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709q-54 -31 -76 -53.5t-22 -45.5q0 -32 45 -36l-31 -46q-34 7 -51 24.5t-17 40.5q0 29 23 57.5t74 58.5h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522q-54 -31 -76 -53.5t-22 -45.5q0 -32 45 -36l-31 -46q-34 7 -51 24.5t-17 40.5q0 29 23 57.5t74 58.5h-33zM160 730h88l-23 -110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM196 810l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 730,
    d: "M171 709h90l-151 -709h-90zM356 -11q-85 0 -137 44l38 73q15 -14 45 -25t71 -11q47 0 79 18t54 53.5t37.5 87.5t30.5 120l77 360h90l-77 -360q-17 -81 -38.5 -147.5t-55.5 -113.5t-85.5 -73t-128.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 458,
    d: "M116 522h88l-111 -522h-88zM160 730h88l-23 -110h-88zM129 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5q15 0 30.5 6.5t29 17.5t23 27t13.5 34l116 545h88l-115 -539q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5zM392 730h88l-24 -110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 472,
    d: "M333 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM98 -11q-85 0 -137 44l38 73q15 -14 45 -25t71 -11q47 0 79 18t54 53.5t37.5 87.5t30.5 120l77 360h90l-77 -360q-17 -81 -38.5 -147.5t-55.5 -113.5t-85.5 -73t-128.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 226,
    d: "M-103 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5q15 0 30.5 6.5t29 17.5t23 27t13.5 34l116 545h88l-115 -539q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5zM54 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 625,
    d: "M198 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM171 709h90l-84 -392l425 393h98l-336 -313l200 -397h-99l-168 345l-141 -128l-46 -217h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 542,
    d: "M145 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM160 730h88l-73 -345q23 30 49.5 56.5t55.5 46.5t61.5 31.5t67.5 11.5q54 0 79 -28.5t25 -76.5q0 -64 -42.5 -118t-125.5 -89l115 -219h-95l-124 255q47 10 83 27.5t60 39t36.5 45t12.5 47.5q0 26 -13 35.5t-34 9.5 q-33 0 -69 -17.5t-69 -48t-60.5 -71.5t-44.5 -88l-50 -234h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 518,
    d: "M116 522h88l-58 -272l307 271h96l-242 -216l142 -305h-95l-114 255l-113 -94l-34 -161h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 559,
    d: "M244 795l-54 20l76 101h87zM171 710h90l-134 -630h373l-17 -80h-463z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 280,
    d: "M219 770l-54 20l76 101h87zM112 -7q-42 0 -64.5 20.5t-22.5 57.5q0 8 1 16t3 16l133 627h87l-126 -595q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -43 45 -43q11 0 26 3.5t29 8.5l-3 -71q-23 -9 -53 -15t-53 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 559,
    d: "M178 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM171 710h90l-134 -630h373l-17 -80h-463z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 280,
    d: "M29 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM112 -7q-42 0 -64.5 20.5t-22.5 57.5q0 8 1 16t3 16l133 627h87l-126 -595q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -43 45 -43q11 0 26 3.5t29 8.5l-3 -71q-23 -9 -53 -15t-53 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 559,
    d: "M317 629l76 101h87l-109 -121zM171 710h90l-134 -630h373l-17 -80h-463z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 271,
    d: "M285 629l76 101h87l-109 -121zM112 -7q-42 0 -64.5 20.5t-22.5 57.5q0 8 1 16t3 16l133 627h87l-126 -595q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -43 45 -43q11 0 26 3.5t29 8.5l-3 -71q-23 -9 -53 -15t-53 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 559,
    d: "M171 710h90l-134 -630h373l-17 -80h-463zM327 343l26 124h74l-26 -124h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 325,
    d: "M112 -7q-42 0 -64.5 20.5t-22.5 57.5q0 8 1 16t3 16l133 627h87l-126 -595q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -43 45 -43q11 0 26 3.5t29 8.5l-3 -71q-23 -9 -53 -15t-53 -6zM231 269l26 124h74l-26 -124h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 565,
    d: "M9 283l91 62l78 365h90l-62 -293l154 106l14 -49l-183 -126l-57 -268h373l-17 -80h-463l58 275l-61 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 301,
    d: "M15 332l94 61l72 337h88l-58 -271l97 63l16 -49l-127 -82l-50 -236q-6 -26 -6 -39q0 -43 44 -43q11 0 26.5 3.5t29.5 8.5l-3 -71q-23 -9 -53.5 -15t-53.5 -6q-42 0 -64.5 20.5t-22.5 57.5q0 8 1 16t3 16l47 222l-65 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 739,
    d: "M481 795l-54 20l76 101h87zM171 710h70l294 -553l117 552h90l-151 -709h-75l-291 542l-115 -542h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 567,
    d: "M386 609l-54 20l76 101h87zM116 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5q0 -22 -3.5 -46t-8.5 -50l-66 -312h-88l62 292q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 739,
    d: "M228 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM171 710h70l294 -553l117 552h90l-151 -709h-75l-291 542l-115 -542h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 567,
    d: "M137 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM116 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5q0 -22 -3.5 -46t-8.5 -50l-66 -312h-88l62 292q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 739,
    d: "M358 892l53 24l67 -63l94 63l43 -24l-116 -90h-64zM171 710h70l294 -553l117 552h90l-151 -709h-75l-291 542l-115 -542h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 567,
    d: "M236 706l53 24l67 -63l94 63l43 -24l-116 -90h-64zM116 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5q0 -22 -3.5 -46t-8.5 -50l-66 -312h-88l62 292q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 567,
    d: "M40 692l5 38h110l-110 -121l-53 20zM116 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5q0 -22 -3.5 -46t-8.5 -50l-66 -312h-88l62 292q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 732,
    d: "M387 -186q-32 0 -59.5 10t-45.5 32l53 59q10 -13 25.5 -18t32.5 -5q15 0 31 6.5t29.5 17.5t23 27t13.5 34l8 38l-273 525l-115 -540h-90l151 710h69l287 -549l117 548h90l-155 -729q-8 -37 -27.5 -67.5t-46 -52.5t-57.5 -34t-61 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 567,
    d: "M243 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5q15 0 30 6.5t28.5 17.5t23.5 27t14 34l67 315q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88l111 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5 q0 -22 -3.5 -46t-8.5 -50l-70 -329q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 721,
    d: "M340 838l12 58h279l-13 -58h-278zM295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5 t23 119q0 44 -11.5 84t-34 70t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 578,
    d: "M221 652l12 58h279l-13 -58h-278zM222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5 t18 90.5q0 33 -9 61t-25.5 48.5t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 721,
    d: "M295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70 t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18zM472 848q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5 q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 578,
    d: "M222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5 t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5zM359 662q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5 q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 721,
    d: "M408 796l-41 20l72 101h75zM540 796l-41 20l72 101h75zM295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5 t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 578,
    d: "M279 609l-41 20l72 101h75zM411 609l-41 20l72 101h75zM222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19 t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1077,
    d: "M295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90 137t129.5 96t151.5 36q39 0 71 -12.5t56.5 -34.5t41 -51.5t25.5 -63.5l33 157h443l-17 -80h-353l-48 -228h301l-17 -80h-301l-52 -242h361l-17 -80h-451l34 157q-24 -35 -54 -64.5t-64 -51t-71 -34 t-75 -12.5zM312 76q61 0 115 30.5t93.5 79t62.5 108.5t23 120q0 44 -11.5 84t-34 70t-55 48t-74.5 18q-62 0 -115.5 -30.5t-93.5 -78.5t-63 -108.5t-23 -120.5q0 -44 11.5 -84t34 -70t55 -48t75.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 979,
    d: "M222 -10q-46 0 -83 16.5t-63 45.5t-40 68.5t-14 86.5q0 66 26.5 125t70 103.5t100.5 70t119 25.5q69 0 114.5 -40.5t58.5 -111.5q46 73 107.5 112.5t133.5 39.5q46 0 83 -16t62.5 -44.5t39 -69.5t13.5 -90q0 -36 -5 -55t-8 -25h-408q-2 -8 -2 -15v-15q0 -32 9.5 -58.5 t27.5 -46t42.5 -30.5t54.5 -11q24 0 47.5 6.5t44.5 18t38.5 27.5t28.5 36l70 -21q-20 -30 -47.5 -54t-59.5 -41.5t-67.5 -27t-71.5 -9.5q-67 0 -114.5 40t-68.5 109q-51 -71 -112 -110t-127 -39zM239 66q40 0 77.5 19t66.5 51t46.5 74.5t17.5 90.5q0 33 -9 61t-25 48.5 t-39.5 32.5t-51.5 12q-39 0 -77 -19t-67 -52t-47 -76t-18 -91q0 -32 9 -60t25.5 -48t39.5 -31.5t52 -11.5zM865 288q1 8 1.5 16t0.5 16q0 66 -36 105.5t-95 39.5q-33 0 -64 -13t-57 -36.5t-46 -56t-30 -71.5h326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 633,
    d: "M409 797l-54 20l76 101h87zM20 0l151 710h290q38 0 68 -16t51 -42t32 -60t11 -70q0 -42 -15 -82.5t-40.5 -74t-60 -58.5t-74.5 -35l105 -272h-102l-98 255h-174l-54 -255h-90zM382 335q30 0 57 15.5t47 40.5t32 56.5t12 64.5q0 24 -7 45.5t-19 37.5t-28.5 25.5t-36.5 9.5 h-195l-63 -295h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 354,
    d: "M267 609l-54 20l76 101h87zM116 522h82l-26 -121q38 54 86.5 88t96.5 34q9 0 15 -0.5t11 -1.5l-16 -76q-63 -2 -117.5 -34t-86.5 -89l-68 -322h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 633,
    d: "M176 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM20 0l151 710h290q38 0 68 -16t51 -42t32 -60t11 -70q0 -42 -15 -82.5t-40.5 -74t-60 -58.5t-74.5 -35l105 -272h-102l-98 255h-174l-54 -255h-90zM382 335q30 0 57 15.5t47 40.5t32 56.5t12 64.5q0 24 -7 45.5 t-19 37.5t-28.5 25.5t-36.5 9.5h-195l-63 -295h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 354,
    d: "M-35 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM116 522h82l-26 -121q38 54 86.5 88t96.5 34q9 0 15 -0.5t11 -1.5l-16 -76q-63 -2 -117.5 -34t-86.5 -89l-68 -322h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 633,
    d: "M308 894l53 24l67 -63l94 63l43 -24l-116 -90h-64zM20 0l151 710h290q38 0 68 -16t51 -42t32 -60t11 -70q0 -42 -15 -82.5t-40.5 -74t-60 -58.5t-74.5 -35l105 -272h-102l-98 255h-174l-54 -255h-90zM382 335q30 0 57 15.5t47 40.5t32 56.5t12 64.5q0 24 -7 45.5 t-19 37.5t-28.5 25.5t-36.5 9.5h-195l-63 -295h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 354,
    d: "M146 706l53 24l67 -63l94 63l43 -24l-116 -90h-64zM116 522h82l-26 -121q38 54 86.5 88t96.5 34q9 0 15 -0.5t11 -1.5l-16 -76q-63 -2 -117.5 -34t-86.5 -89l-68 -322h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 588,
    d: "M413 809l-54 20l76 101h87zM242 -7q-78 0 -142.5 25.5t-111.5 74.5l59 76q11 -17 31 -34t48 -30.5t62 -22t73 -8.5q81 0 127.5 33.5t46.5 93.5q0 24 -11.5 41.5t-33 31t-52.5 23.5t-70 21q-41 11 -73 24t-54 30.5t-33.5 41t-11.5 55.5q0 58 23 103.5t63 77t93.5 48.5 t113.5 17q68 0 119 -22t86 -59l-57 -73q-8 14 -24 27t-38 23.5t-48.5 17t-56.5 6.5q-91 0 -133 -39t-42 -98q0 -22 9.5 -37.5t28.5 -27t47 -21t66 -18.5q43 -11 78 -24.5t59.5 -32.5t38 -45t13.5 -63q0 -60 -23.5 -104.5t-63.5 -73.5t-93 -43.5t-113 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 475,
    d: "M292 609l-54 20l76 101h87zM178 -10q-60 0 -114 19.5t-88 56.5l50 59q36 -35 76 -52.5t88 -17.5q60 0 97 27t37 72q0 32 -29.5 47t-89.5 31q-37 10 -64 20t-45 23t-27 29.5t-9 39.5q0 44 19 78.5t50.5 58.5t73 37t86.5 13q56 0 100 -19t72 -50l-51 -53q-26 29 -61.5 43.5 t-75.5 14.5q-26 0 -48.5 -6t-40 -18.5t-27.5 -31.5t-10 -44q0 -28 23.5 -41t75.5 -27q41 -11 72.5 -22t52.5 -25.5t31.5 -33t10.5 -44.5q0 -41 -17.5 -74.5t-48.5 -58t-74.5 -38t-94.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 588,
    d: "M286 840l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM242 -7q-78 0 -142.5 25.5t-111.5 74.5l59 76q11 -17 31 -34t48 -30.5t62 -22t73 -8.5q81 0 127.5 33.5t46.5 93.5q0 24 -11.5 41.5t-33 31t-52.5 23.5t-70 21q-41 11 -73 24t-54 30.5t-33.5 41t-11.5 55.5 q0 58 23 103.5t63 77t93.5 48.5t113.5 17q68 0 119 -22t86 -59l-57 -73q-8 14 -24 27t-38 23.5t-48.5 17t-56.5 6.5q-91 0 -133 -39t-42 -98q0 -22 9.5 -37.5t28.5 -27t47 -21t66 -18.5q43 -11 78 -24.5t59.5 -32.5t38 -45t13.5 -63q0 -60 -23.5 -104.5t-63.5 -73.5 t-93 -43.5t-113 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 475,
    d: "M190 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM178 -10q-60 0 -114 19.5t-88 56.5l50 59q36 -35 76 -52.5t88 -17.5q60 0 97 27t37 72q0 32 -29.5 47t-89.5 31q-37 10 -64 20t-45 23t-27 29.5t-9 39.5q0 44 19 78.5t50.5 58.5t73 37t86.5 13q56 0 100 -19t72 -50 l-51 -53q-26 29 -61.5 43.5t-75.5 14.5q-26 0 -48.5 -6t-40 -18.5t-27.5 -31.5t-10 -44q0 -28 23.5 -41t75.5 -27q41 -11 72.5 -22t52.5 -25.5t31.5 -33t10.5 -44.5q0 -41 -17.5 -74.5t-48.5 -58t-74.5 -38t-94.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 588,
    d: "M147 -126q11 -7 32.5 -13t46.5 -6q29 0 46 10t17 32q0 16 -11.5 22t-30.5 6q-20 0 -43 -4.5t-36 -8.5l58 82q-72 2 -133 27t-105 72l59 76q11 -17 31 -34t48 -30.5t62 -22t73 -8.5q81 0 127.5 33.5t46.5 93.5q0 24 -11.5 41.5t-33 31t-52.5 23.5t-70 21q-41 11 -73 24 t-54 30.5t-33.5 41t-11.5 55.5q0 58 23 103.5t63 77t93.5 48.5t113.5 17q68 0 119 -22t86 -59l-57 -73q-8 14 -24 27t-38 23.5t-48.5 17t-56.5 6.5q-91 0 -133 -39t-42 -98q0 -22 9.5 -37.5t28.5 -27t47 -21t66 -18.5q43 -11 78 -24.5t59.5 -32.5t38 -45t13.5 -63 q0 -56 -20.5 -98.5t-56.5 -72t-84 -45.5t-103 -19l-34 -42q8 3 17.5 4t17.5 1q29 0 46 -12.5t17 -38.5q0 -39 -31.5 -63.5t-92.5 -24.5q-29 0 -52 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 475,
    d: "M79 -126q11 -7 32.5 -13t46.5 -6q29 0 46 10t17 32q0 16 -11.5 22t-30.5 6q-20 0 -43 -4.5t-36 -8.5l56 79q-54 4 -101.5 22.5t-78.5 52.5l50 59q36 -35 76 -52.5t88 -17.5q60 0 97 27t37 72q0 32 -29.5 47t-89.5 31q-37 10 -64 20t-45 23t-27 29.5t-9 39.5q0 44 19 78.5 t50.5 58.5t73 37t86.5 13q56 0 100 -19t72 -50l-51 -53q-26 29 -61.5 43.5t-75.5 14.5q-26 0 -48.5 -6t-40 -18.5t-27.5 -31.5t-10 -44q0 -28 23.5 -41t75.5 -27q41 -11 72.5 -22t52.5 -25.5t31.5 -33t10.5 -44.5q0 -38 -15.5 -70.5t-44 -56.5t-67.5 -38.5t-86 -17.5 l-31 -39q8 3 17.5 4t17.5 1q29 0 46 -12.5t17 -38.5q0 -39 -31.5 -63.5t-92.5 -24.5q-29 0 -52 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 588,
    d: "M292 906l53 24l67 -63l94 63l43 -24l-116 -90h-64zM242 -7q-78 0 -142.5 25.5t-111.5 74.5l59 76q11 -17 31 -34t48 -30.5t62 -22t73 -8.5q81 0 127.5 33.5t46.5 93.5q0 24 -11.5 41.5t-33 31t-52.5 23.5t-70 21q-41 11 -73 24t-54 30.5t-33.5 41t-11.5 55.5 q0 58 23 103.5t63 77t93.5 48.5t113.5 17q68 0 119 -22t86 -59l-57 -73q-8 14 -24 27t-38 23.5t-48.5 17t-56.5 6.5q-91 0 -133 -39t-42 -98q0 -22 9.5 -37.5t28.5 -27t47 -21t66 -18.5q43 -11 78 -24.5t59.5 -32.5t38 -45t13.5 -63q0 -60 -23.5 -104.5t-63.5 -73.5 t-93 -43.5t-113 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 475,
    d: "M190 706l53 24l67 -63l94 63l43 -24l-116 -90h-64zM178 -10q-60 0 -114 19.5t-88 56.5l50 59q36 -35 76 -52.5t88 -17.5q60 0 97 27t37 72q0 32 -29.5 47t-89.5 31q-37 10 -64 20t-45 23t-27 29.5t-9 39.5q0 44 19 78.5t50.5 58.5t73 37t86.5 13q56 0 100 -19t72 -50 l-51 -53q-26 29 -61.5 43.5t-75.5 14.5q-26 0 -48.5 -6t-40 -18.5t-27.5 -31.5t-10 -44q0 -28 23.5 -41t75.5 -27q41 -11 72.5 -22t52.5 -25.5t31.5 -33t10.5 -44.5q0 -41 -17.5 -74.5t-48.5 -58t-74.5 -38t-94.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 585,
    d: "M316 630h-231l17 80h552l-17 -80h-231l-134 -630h-14l-39 -48q8 3 17.5 4t17.5 1q29 0 46 -12.5t17 -38.5q0 -39 -31.5 -63.5t-92.5 -24.5q-29 0 -52 5.5t-40 13.5l28 37q11 -7 32.5 -13t46.5 -6q29 0 46 10t17 32q0 16 -11.5 22t-30.5 6q-20 0 -43 -4.5t-36 -8.5l63 88 h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 338,
    d: "M42 -126q11 -7 32.5 -13t46.5 -6q29 0 46 10t17 32q0 16 -11.5 22t-30.5 6q-20 0 -43 -4.5t-36 -8.5l58 82q-32 5 -52.5 24t-20.5 55q0 14 3 29l75 351h-68l15 69h67l37 174h88l-37 -174h111l-15 -69h-110l-69 -324q-2 -10 -2 -15q0 -21 13 -30.5t32 -9.5q25 0 47 8.5 t31 13.5l5 -70q-16 -11 -44 -20t-61 -12l-34 -42q8 3 17.5 4t17.5 1q29 0 46 -12.5t17 -38.5q0 -39 -31.5 -63.5t-92.5 -24.5q-29 0 -52 5.5t-40 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 586,
    d: "M284 892l53 24l67 -63l94 63l43 -24l-116 -90h-64zM317 630h-231l17 80h552l-17 -80h-231l-134 -630h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 338,
    d: "M303 629l76 101h87l-109 -121zM142 -7q-41 0 -67.5 19t-26.5 61q0 14 3 29l75 351h-68l15 69h67l37 174h88l-37 -174h111l-15 -69h-110l-69 -324q-2 -10 -2 -15q0 -21 13 -30.5t32 -9.5q25 0 47 8.5t31 13.5l5 -70q-18 -13 -53.5 -23t-75.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 617,
    d: "M84 397h198l50 233h-231l17 80h552l-17 -80h-231l-50 -233h199l-10 -47h-199l-74 -350h-90l74 350h-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 338,
    d: "M37 350h67l22 103h-67l14 69h68l37 174h88l-37 -174h110l-14 -69h-111l-22 -103h111l-12 -56h-111l-32 -149q-4 -19 -4 -28q0 -23 12.5 -33t32.5 -10q24 0 46.5 8.5t30.5 13.5l6 -70q-19 -13 -54.5 -23t-75.5 -10q-41 0 -67.5 19t-26.5 61q0 14 3 29l41 192h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 724,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z M522 813q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5zM400 627q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32 t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 724,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z M331 838l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5zM207 652l12 58h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 724,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z M465 848q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5zM346 662q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 724,
    d: "M394 834q0 37 28 59.5t67 22.5q31 0 48 -15t17 -41q0 -36 -27 -59t-68 -23q-30 0 -47.5 15t-17.5 41zM482 885q-18 0 -32.5 -12.5t-14.5 -32.5q0 -13 8.5 -22t22.5 -9q17 0 32.5 12.5t15.5 32.5q0 14 -9 22.5t-23 8.5zM298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93 q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 577,
    d: "M267 648q0 37 28 59.5t67 22.5q31 0 48 -15t17 -41q0 -36 -27 -59t-68 -23q-30 0 -47.5 15t-17.5 41zM355 699q-18 0 -32.5 -12.5t-14.5 -32.5q0 -13 8.5 -22t22.5 -9q17 0 32.5 12.5t15.5 32.5q0 14 -9 22.5t-23 8.5zM155 -10q-122 0 -122 132q0 35 11 87l67 313h87 l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 724,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z M385 796l-41 20l72 101h75zM517 796l-41 20l72 101h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5zM259 609l-41 20l72 101h75zM391 609l-41 20l72 101h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 724,
    d: "M240 -181q-34 7 -51 24.5t-17 40.5q0 28 22 56t70 57q-53 5 -90 25t-60 51.5t-33 72t-10 86.5q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -70 -43 -133 t-71 -111t-100.5 -78t-130.5 -33q-49 -29 -69.5 -51t-20.5 -44q0 -32 45 -36l-31 -46v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-54 -31 -76 -53.5t-22 -45.5q0 -32 45 -36l-31 -46q-34 7 -51 24.5t-17 40.5 q0 29 23 57t72 58q-33 7 -33 41q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5t-125 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1002,
    d: "M477 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM93 710h97l96 -606l175 293l-51 309h85l35 -247l141 247h85l-182 -309l50 -293l353 606h99l-433 -710h-77l-61 335l-205 -335h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 768,
    d: "M306 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63zM49 522h91l83 -445q32 42 60.5 82.5t54.5 82.5l-70 280h91l40 -169q42 85 65 169h84q-20 -69 -50.5 -138.5t-72.5 -138.5l41 -168q81 112 139.5 222.5t87.5 222.5h84q-36 -131 -108.5 -261t-174.5 -261h-95l-37 147 q-51 -74 -111 -147h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 612,
    d: "M248 261l-159 449h99l122 -370l281 370h98l-352 -451l-55 -259h-90zM273 826l116 90h64l77 -90l-53 -24l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 501,
    d: "M-35 -153q31 4 53.5 10.5t40 17t32.5 27.5t32 43l29 44l-101 533h91l72 -443l34 56q42 69 71 121t49.5 96t34.5 84.5t26 85.5h87q-14 -48 -29 -90t-38 -88.5t-56.5 -103.5t-82.5 -137l-80 -129q-34 -55 -64 -92.5t-59.5 -60.5t-61 -33.5t-68.5 -11.5zM175 640l116 90h64 l77 -90l-53 -24l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 612,
    d: "M248 261l-159 449h99l122 -370l281 370h98l-352 -451l-55 -259h-90zM291 811l22 102h74l-22 -102h-74zM448 811l22 102h73l-21 -102h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 600,
    d: "M397 795l-54 20l76 101h87zM-19 70l549 560h-421l17 80h526l-15 -70l-541 -560h422l-17 -80h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 470,
    d: "M278 609l-54 20l76 101h87zM-23 57l394 401h-300l14 64h398l-12 -57l-392 -401h308l-14 -64h-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 600,
    d: "M-19 70l549 560h-421l17 80h526l-15 -70l-541 -560h422l-17 -80h-535zM358 810l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 470,
    d: "M-23 57l394 401h-300l14 64h398l-12 -57l-392 -401h308l-14 -64h-408zM244 624l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 600,
    d: "M285 892l53 24l67 -63l94 63l43 -24l-116 -90h-64zM-19 70l549 560h-421l17 80h526l-15 -70l-541 -560h422l-17 -80h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 470,
    d: "M171 706l53 24l67 -63l94 63l43 -24l-116 -90h-64zM-23 57l394 401h-300l14 64h398l-12 -57l-392 -401h308l-14 -64h-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 706,
    d: "M282 -5q-57 0 -104 22.5t-80.5 61t-52 91t-18.5 112.5q0 43 8 71t13 39h536q1 9 1.5 18t0.5 18q0 45 -12.5 82.5t-35.5 64.5t-54.5 42t-70.5 15q-32 0 -64.5 -10t-61 -27.5t-52 -42t-38.5 -53.5l-78 39q27 39 63.5 72t78.5 56t87.5 36t89.5 13q56 0 101.5 -22t77.5 -61 t49.5 -92t17.5 -114q0 -88 -34 -166t-90 -137t-128.5 -93.5t-149.5 -34.5zM301 76q44 0 86 18t77.5 49.5t63 75.5t41.5 95h-449q-3 -13 -4 -25.5t-1 -25.5q0 -39 12.5 -73t36 -59.5t58 -40t79.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 512,
    d: "M42 -186q-32 0 -59.5 10t-46.5 32l53 59q11 -13 27 -18t33 -5q15 0 30.5 6.5t29 17.5t23 27t13.5 34l88 415h-67l14 69h68l15 72q20 97 73 152t124 55q29 0 56.5 -8.5t47.5 -23.5l-35 -65q-11 10 -29.5 16t-37.5 6q-41 0 -68.5 -33t-41.5 -96l-16 -75h131l-15 -69h-131 l-88 -413q-8 -36 -27 -66.5t-45.5 -52.5t-57 -34t-61.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1292,
    d: "M171 710h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235zM272 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145l-117 -550h145zM977 892l53 24l67 -63l94 63l43 -24 l-116 -90h-64zM673 70l549 560h-421l17 80h526l-15 -70l-541 -560h422l-17 -80h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1162,
    d: "M171 710h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235zM272 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145l-117 -550h145zM863 706l53 24l67 -63l94 63l43 -24 l-116 -90h-64zM669 57l394 401h-300l14 64h398l-12 -57l-392 -401h308l-14 -64h-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1076,
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l67 312h88l-132 -622q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 9 2 22t7 35 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM777 706l53 24l67 -63l94 63l43 -24l-116 -90 h-64zM583 57l394 401h-300l14 64h398l-12 -57l-392 -401h308l-14 -64h-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1031,
    d: "M171 710h90l-134 -630h373l-17 -80h-463zM657 -11q-85 0 -137 44l38 73q15 -14 45 -25t71 -11q47 0 79 18t54 53.5t37.5 87.5t30.5 120l77 360h90l-77 -360q-17 -81 -38.5 -147.5t-55.5 -113.5t-85.5 -73t-128.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 791,
    d: "M171 710h90l-134 -630h373l-17 -80h-463zM462 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5q15 0 30.5 6.5t29 17.5t23 27t13.5 34l116 545h88l-115 -539q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5zM725 730h88l-24 -110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 512,
    d: "M112 -7q-42 0 -64.5 20.5t-22.5 57.5q0 8 1 16t3 16l133 627h87l-126 -595q-1 -5 -1.5 -9.5t-0.5 -9.5q0 -43 45 -43q11 0 26 3.5t29 8.5l-3 -71q-23 -9 -53 -15t-53 -6zM183 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5q15 0 30.5 6.5t29 17.5t23 27t13.5 34 l116 545h88l-115 -539q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5zM446 730h88l-24 -110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1211,
    d: "M171 710h70l294 -553l117 552h90l-151 -709h-75l-291 542l-115 -542h-90zM837 -11q-85 0 -137 44l38 73q15 -14 45 -25t71 -11q47 0 79 18t54 53.5t37.5 87.5t30.5 120l77 360h90l-77 -360q-17 -81 -38.5 -147.5t-55.5 -113.5t-85.5 -73t-128.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 971,
    d: "M171 710h70l294 -553l117 552h90l-151 -709h-75l-291 542l-115 -542h-90zM642 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5q15 0 30.5 6.5t29 17.5t23 27t13.5 34l116 545h88l-115 -539q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5zM905 730h88l-24 -110 h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 799,
    d: "M116 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5q0 -22 -3.5 -46t-8.5 -50l-66 -312h-88l62 292q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88zM470 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5 q15 0 30.5 6.5t29 17.5t23 27t13.5 34l116 545h88l-115 -539q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5zM733 730h88l-24 -110h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 720,
    d: "M237 -181q-34 7 -51 24.5t-17 40.5q0 29 22.5 56.5t70.5 56.5q-53 6 -93.5 32.5t-68 66t-42 89t-14.5 103.5q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -78 -32 -152.5t-85.5 -133.5t-123 -96.5t-145.5 -41.5q-49 -29 -69.5 -51 t-20.5 -44q0 -32 45 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 578,
    d: "M187 -186q-34 7 -51 24.5t-17 40.5q0 28 21.5 55t68.5 56q-45 3 -80 21t-58.5 47.5t-36 68t-12.5 81.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -57 -21 -110t-57.5 -96t-85.5 -73t-106 -39q-53 -30 -74.5 -52.5 t-21.5 -45.5q0 -32 45 -36zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1281,
    d: "M171 710h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235zM272 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145l-117 -550h145zM662 70l549 560h-421l17 80h526l-15 -70 l-541 -560h422l-17 -80h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1162,
    d: "M171 710h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235zM272 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145l-117 -550h145zM669 57l394 401h-300l14 64h398l-12 -57 l-392 -401h308l-14 -64h-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1076,
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l67 312h88l-132 -622q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 9 2 22t7 35 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM583 57l394 401h-300l14 64h398l-12 -57 l-392 -401h308l-14 -64h-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 686,
    d: "M516 95q-55 -51 -110.5 -75.5t-113.5 -24.5q-57 0 -103 24.5t-78 66t-49 95t-17 111.5q0 81 33.5 157t89 135.5t127.5 95t150 35.5q98 0 152.5 -43t73.5 -112l-79 -48q-17 62 -60.5 92t-105.5 30q-59 0 -112 -29.5t-92.5 -77t-62.5 -108t-23 -122.5q0 -46 12.5 -86 t36 -70t57 -47.5t74.5 -17.5q54 0 108.5 27.5t111.5 85.5l21 97h-145l15 68h220l-75 -354h-76zM454 795l-54 20l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 599,
    d: "M164 -223q-84 0 -131 31t-71 84l60 45q20 -46 61 -69t95 -23q34 0 66.5 10t59.5 30t46.5 50t28.5 71l19 92q-37 -48 -90.5 -76t-106.5 -28q-42 0 -75.5 17t-56.5 46.5t-35 68t-12 81.5q0 63 24 121.5t64.5 103.5t94 72t112.5 27q62 0 100.5 -32t59.5 -81l22 104h78 l-110 -516q-12 -56 -40.5 -98.5t-69 -71.5t-90.5 -44t-103 -15zM244 66q26 0 52.5 10t50 26.5t42 37.5t28.5 43l32 150q-4 27 -16 49t-29 38.5t-39 25.5t-46 9q-43 0 -80.5 -21.5t-65.5 -55t-44 -75.5t-16 -82q0 -32 9.5 -60t26.5 -49t41 -33.5t54 -12.5zM327 609l-54 20 l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 652,
    d: "M486 802q18 -15 18 -41q0 -24 -12.5 -42t-33.5 -29l120 -690h-96l-34 208h-278l-121 -208h-96l413 690q-22 14 -22 45q0 34 24.5 56t59.5 25l68 102h87zM444 278l-49 328l-193 -328h242zM432 786q-18 0 -32.5 -12.5t-14.5 -32.5q0 -13 8.5 -22t22.5 -9q17 0 32.5 12.5 t15.5 32.5q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM385 765l-54 20l76 101h87zM271 648 q0 37 28 59.5t67 22.5q31 0 48 -15t17 -41q0 -36 -27 -59t-68 -23q-30 0 -47.5 15t-17.5 41zM359 699q-18 0 -32.5 -12.5t-14.5 -32.5q0 -13 8.5 -22t22.5 -9q17 0 32.5 12.5t15.5 32.5q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 924,
    d: "M591 795l-54 20l76 101h87zM500 710h466l-17 -80h-353l-48 -228h301l-17 -80h-301l-52 -242h361l-17 -80h-450l45 208h-235l-165 -208h-98zM428 288l68 317l-256 -317h188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 886,
    d: "M514 609l-54 20l76 101h87zM131 -10q-33 0 -58.5 10t-43.5 28t-27.5 42.5t-9.5 53.5q0 42 19 76.5t52.5 60t78.5 39.5t96 14q32 0 63 -5.5t55 -14.5q8 26 17.5 44.5t9.5 42.5q0 36 -27 61t-78 25q-38 0 -80 -15.5t-90 -45.5l-16 57q112 68 209 68q60 0 98.5 -25t52.5 -70 q41 43 94 69t113 26q48 0 85 -17t62.5 -47t39 -70t13.5 -86q0 -38 -6.5 -56t-8.5 -24h-417q-3 -15 -3 -30q0 -32 10 -59t28.5 -46t43.5 -29.5t55 -10.5q23 0 46 6.5t44 17.5t38.5 27t29.5 36l72 -21q-18 -29 -44.5 -53t-59 -41.5t-68.5 -27.5t-74 -10q-68 0 -115 31t-69 82 q-23 -31 -52.5 -52.5t-61 -35t-62 -19.5t-54.5 -6zM167 56q24 0 52 8t53 22t44.5 31.5t26.5 37.5q-3 13 -3 33q0 29 5 54q-49 19 -104 19q-35 0 -65 -9t-51.5 -24.5t-34 -37.5t-12.5 -49q0 -35 22.5 -60t66.5 -25zM773 288q2 8 2 16.5v16.5q0 65 -35.5 104.5t-97.5 39.5 q-35 0 -67 -13t-59.5 -36.5t-48 -56t-30.5 -71.5h336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 721,
    d: "M728 710l-84 -99q27 -40 41 -89t14 -102q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36q-42 0 -77 12t-64 33l-34 -40h-98l80 93q-29 40 -43.5 90.5t-14.5 104.5q0 81 34 158t90.5 137t130 96t151.5 36q43 0 78.5 -13t64.5 -36l37 44h98zM136 296q0 -36 7 -69 t22 -60l368 430q-20 17 -45.5 26.5t-56.5 9.5q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 70 -27 124l-367 -428q42 -33 100 -33zM480 795l-54 20l76 101h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 578,
    d: "M349 609l-54 20l76 101h87zM72 57q-25 29 -37.5 68t-12.5 83q0 63 25.5 121t68.5 103t100.5 72t121.5 27q36 0 66.5 -10.5t54.5 -28.5l32 32h55l-59 -59q26 -30 39 -69t13 -84q0 -62 -25 -120t-68 -103t-100.5 -72t-122.5 -27q-38 0 -69 10.5t-55 29.5l-32 -32h-54z M239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 55 -25 96l-262 -302q32 -29 79 -29zM113 219q0 -55 25 -96l260 302q-32 30 -77 30q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM434 918h74l30 -101l-50 -20zM302 918h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM337 730h74l30 -101l-50 -20zM205 730h75 l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 652,
    d: "M378 710h77l123 -710h-96l-34 208h-278l-121 -208h-96zM444 278l-49 328l-193 -328h242zM328 805q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l23 104h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 16 9 57 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM241 619q5 24 17 44t29.5 35t38 23.5t42.5 8.5 q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459zM432 918h74l30 -101l-50 -20zM300 918h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18zM356 730h74l30 -101l-50 -20zM224 730h75l29 -101 l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459zM317 805q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18zM256 619q5 24 17 44t29.5 35t38 23.5t42.5 8.5 q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM238 918h74l30 -101l-50 -20zM106 918h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88zM180 730h74l30 -101l-50 -20zM48 730h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM132 805q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88zM75 619q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 721,
    d: "M295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70 t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18zM494 918h74l30 -101l-50 -20zM362 918h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 578,
    d: "M222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5 t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5zM351 730h74l30 -101l-50 -20zM219 730h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 721,
    d: "M295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70 t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18zM377 805q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 578,
    d: "M222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5 t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5zM256 619q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 633,
    d: "M20 0l151 710h290q38 0 68 -16t51 -42t32 -60t11 -70q0 -42 -15 -82.5t-40.5 -74t-60 -58.5t-74.5 -35l105 -272h-102l-98 255h-174l-54 -255h-90zM382 335q30 0 57 15.5t47 40.5t32 56.5t12 64.5q0 24 -7 45.5t-19 37.5t-28.5 25.5t-36.5 9.5h-195l-63 -295h201z M416 918h74l30 -101l-50 -20zM284 918h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 354,
    d: "M116 522h82l-26 -121q38 54 86.5 88t96.5 34q9 0 15 -0.5t11 -1.5l-16 -76q-63 -2 -117.5 -34t-86.5 -89l-68 -322h-88zM269 730h74l30 -101l-50 -20zM137 730h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 633,
    d: "M20 0l151 710h290q38 0 68 -16t51 -42t32 -60t11 -70q0 -42 -15 -82.5t-40.5 -74t-60 -58.5t-74.5 -35l105 -272h-102l-98 255h-174l-54 -255h-90zM382 335q30 0 57 15.5t47 40.5t32 56.5t12 64.5q0 24 -7 45.5t-19 37.5t-28.5 25.5t-36.5 9.5h-195l-63 -295h201z M310 805q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 354,
    d: "M116 522h82l-26 -121q38 54 86.5 88t96.5 34q9 0 15 -0.5t11 -1.5l-16 -76q-63 -2 -117.5 -34t-86.5 -89l-68 -322h-88zM154 619q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5 t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 724,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z M472 918h74l30 -101l-50 -20zM340 918h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5zM341 730h74l30 -101l-50 -20zM209 730h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 724,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z M365 805q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5zM236 619q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 588,
    d: "M163 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM242 -7q-78 0 -142.5 25.5t-111.5 74.5l59 76q11 -17 31 -34t48 -30.5t62 -22t73 -8.5q81 0 127.5 33.5t46.5 93.5q0 24 -11.5 41.5t-33 31t-52.5 23.5t-70 21q-41 11 -73 24t-54 30.5t-33.5 41t-11.5 55.5 q0 58 23 103.5t63 77t93.5 48.5t113.5 17q68 0 119 -22t86 -59l-57 -73q-8 14 -24 27t-38 23.5t-48.5 17t-56.5 6.5q-91 0 -133 -39t-42 -98q0 -22 9.5 -37.5t28.5 -27t47 -21t66 -18.5q43 -11 78 -24.5t59.5 -32.5t38 -45t13.5 -63q0 -60 -23.5 -104.5t-63.5 -73.5 t-93 -43.5t-113 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 475,
    d: "M99 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM178 -10q-60 0 -114 19.5t-88 56.5l50 59q36 -35 76 -52.5t88 -17.5q60 0 97 27t37 72q0 32 -29.5 47t-89.5 31q-37 10 -64 20t-45 23t-27 29.5t-9 39.5q0 44 19 78.5t50.5 58.5t73 37t86.5 13q56 0 100 -19t72 -50 l-51 -53q-26 29 -61.5 43.5t-75.5 14.5q-26 0 -48.5 -6t-40 -18.5t-27.5 -31.5t-10 -44q0 -28 23.5 -41t75.5 -27q41 -11 72.5 -22t52.5 -25.5t31.5 -33t10.5 -44.5q0 -41 -17.5 -74.5t-48.5 -58t-74.5 -38t-94.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 586,
    d: "M151 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM317 630h-231l17 80h552l-17 -80h-231l-134 -630h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 338,
    d: "M61 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43zM142 -7q-41 0 -67.5 19t-26.5 61q0 14 3 29l75 351h-68l15 69h67l37 174h88l-37 -174h111l-15 -69h-110l-69 -324q-2 -10 -2 -15q0 -21 13 -30.5t32 -9.5q25 0 47 8.5t31 13.5l5 -70q-18 -13 -53.5 -23t-75.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 226,
    d: "M-103 -186q-33 0 -60 10t-46 32l53 59q11 -13 27 -18t33 -5q15 0 30.5 6.5t29 17.5t23 27t13.5 34l116 545h88l-115 -539q-8 -37 -27.5 -68t-45.5 -53.5t-57 -35t-62 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 567,
    d: "M213 -10q-48 0 -86 16t-64 43.5t-39.5 65.5t-13.5 82q0 22 3.5 47t12.5 46h408q1 8 1.5 16t0.5 16q0 64 -35.5 103t-92.5 39q-23 0 -46 -6.5t-44 -17.5t-38.5 -27t-29.5 -35l-71 21q18 28 44.5 52.5t59 42t69 27.5t74.5 10q48 0 85.5 -17t63.5 -47t39.5 -70t13.5 -86 q0 -63 -25 -121t-67.5 -102.5t-100 -71t-122.5 -26.5zM228 56q32 0 63 13t57 36.5t45.5 56t30.5 70.5h-327q-2 -8 -2 -16v-16q0 -65 37 -104.5t96 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 535,
    d: "M321 692l5 38h110l-110 -121l-53 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 327,
    d: "M61 640l116 90h64l77 -90l-53 -24l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 327,
    d: "M75 706l53 24l67 -63l94 63l43 -24l-116 -90h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 385,
    d: "M95 710h279l-13 -58h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 284,
    d: "M159 662q20 0 40 19.5t29 48.5h50q-5 -24 -17.5 -44t-29.5 -35t-38 -23.5t-43 -8.5q-39 0 -62 23.5t-23 61.5q0 12 3 26h51q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -21 11.5 -36t30.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 174,
    d: "M56 624l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 240,
    d: "M69 648q0 37 28 59.5t67 22.5q31 0 48 -15t17 -41q0 -36 -27 -59t-68 -23q-30 0 -47.5 15t-17.5 41zM157 699q-18 0 -32.5 -12.5t-14.5 -32.5q0 -13 8.5 -22t22.5 -9q17 0 32.5 12.5t15.5 32.5q0 14 -9 22.5t-23 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 245,
    d: "M100 -181q-34 7 -51 24.5t-17 40.5q0 33 31 65.5t99 68.5l22 -18q-54 -31 -76 -53.5t-22 -45.5q0 -32 45 -36l-31 -46v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 396,
    d: "M267 627q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 324,
    d: "M84 609l-41 20l72 101h75zM216 609l-41 20l72 101h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 324,
    d: "M196 730h74l30 -101l-50 -20zM64 730h75l29 -101l-50 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 284,
    d: "M61 619q5 24 17 44t29.5 35t38 23.5t42.5 8.5q38 0 61.5 -25.5t23.5 -61.5q0 -12 -3 -24h-49q1 7 1.5 13t0.5 12q0 43 -41 43q-32 0 -48 -19.5t-23 -48.5h-50v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 625,
    d: "M-18 67l265 643h74l263 -643v-67h-602v67zM485 80l-201 526l-202 -526h403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 802,
    d: "M51 79h179q-78 44 -123.5 118.5t-45.5 167.5q0 69 25 132.5t68.5 111.5t103 77t129.5 29t129.5 -29t103 -77t68.5 -111.5t25 -132.5q0 -93 -45.5 -167.5t-123.5 -118.5h179v-79h-289v79q43 14 78 43.5t59.5 68.5t37.5 84t13 90q0 50 -16.5 98t-47 86t-74 61t-97.5 23 t-97.5 -23t-74 -61t-47 -86t-16.5 -98q0 -45 13 -90t37.5 -84t59.5 -68.5t78 -43.5v-79h-289v79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 584,
    d: "M116 522h88l-63 -296q-9 -39 -9 -69q0 -91 80 -91q49 0 100 34.5t86 94.5l70 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 23 -19l-17 -76q-11 -2 -20 -3t-16 -1q-26 0 -40.5 11.5t-14.5 31.5q0 9 2 23.5t10 49.5q-16 -24 -39 -46t-50 -39t-56 -27t-57 -10 q-43 0 -64 22.5t-25 54.5l-54 -279h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 692,
    d: "M510 -7q-49 0 -78 29t-29 81v339h-181v-442h-85v442h-80v80h541v-80h-110v-307q0 -29 15.5 -45.5t43.5 -16.5q11 0 26 3.5t28 8.5l14 -71q-22 -9 -52 -15t-53 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 692,
    d: "M171 710h235q67 0 116.5 -21t81.5 -58t48 -87t16 -107q0 -94 -31 -174t-86.5 -138.5t-131 -91.5t-164.5 -33h-235zM272 80q70 0 126 28t95.5 75.5t60.5 109.5t21 130q0 45 -12 83t-35 65.5t-58 43t-81 15.5h-145l-117 -550h145zM184 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t63.5 103.5t92 72t109.5 27q60 0 99.5 -32.5t56.5 -80.5l67 312h88l-132 -622q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-28 0 -42.5 12.5t-14.5 32.5q0 9 2 22t7 35 q-39 -51 -94 -79.5t-109 -28.5zM246 66q22 0 47.5 9t50 25t44.5 37.5t30 45.5l31 150q-3 25 -15 47.5t-29.5 39t-39 26t-44.5 9.5q-42 0 -79 -20.5t-65.5 -54t-45 -75.5t-16.5 -84q0 -32 9 -60.5t26.5 -49.5t41.5 -33t54 -12zM157 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 713,
    d: "M171 710h90l-65 -307h365l65 307h90l-151 -710h-90l69 323h-365l-69 -323h-90zM215 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 567,
    d: "M160 730h88l-68 -320q42 57 98.5 89t116.5 32q66 0 93 -36t27 -94q0 -43 -10 -89l-66 -312h-88l62 292q4 20 6 36.5t2 31.5q0 92 -77 92q-24 0 -50 -10.5t-51 -28.5t-47 -43t-36 -55l-67 -315h-88zM137 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 739,
    d: "M434 810l23 106h79l-22 -106h-80zM171 710h70l294 -553l117 552h90l-151 -709h-75l-291 542l-115 -542h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 567,
    d: "M297 624l23 106h79l-22 -106h-80zM116 522h80l-24 -112q41 55 103 88t128 33q63 0 88.5 -33.5t25.5 -89.5q0 -22 -3.5 -46t-8.5 -50l-66 -312h-88l62 292q9 43 9 75q0 85 -71 85q-25 0 -52.5 -10.5t-53.5 -28.5t-48 -43t-37 -55l-67 -315h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 633,
    d: "M20 0l151 710h290q38 0 68 -16t51 -42t32 -60t11 -70q0 -42 -15 -82.5t-40.5 -74t-60 -58.5t-74.5 -35l105 -272h-102l-98 255h-174l-54 -255h-90zM382 335q30 0 57 15.5t47 40.5t32 56.5t12 64.5q0 24 -7 45.5t-19 37.5t-28.5 25.5t-36.5 9.5h-195l-63 -295h201z M175 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 354,
    d: "M116 522h82l-26 -121q38 54 86.5 88t96.5 34q9 0 15 -0.5t11 -1.5l-16 -76q-63 -2 -117.5 -34t-86.5 -89l-68 -322h-88zM-28 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 588,
    d: "M242 -7q-78 0 -142.5 25.5t-111.5 74.5l59 76q11 -17 31 -34t48 -30.5t62 -22t73 -8.5q81 0 127.5 33.5t46.5 93.5q0 24 -11.5 41.5t-33 31t-52.5 23.5t-70 21q-41 11 -73 24t-54 30.5t-33.5 41t-11.5 55.5q0 58 23 103.5t63 77t93.5 48.5t113.5 17q68 0 119 -22t86 -59 l-57 -73q-8 14 -24 27t-38 23.5t-48.5 17t-56.5 6.5q-91 0 -133 -39t-42 -98q0 -22 9.5 -37.5t28.5 -27t47 -21t66 -18.5q43 -11 78 -24.5t59.5 -32.5t38 -45t13.5 -63q0 -60 -23.5 -104.5t-63.5 -73.5t-93 -43.5t-113 -14.5zM160 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 475,
    d: "M178 -10q-60 0 -114 19.5t-88 56.5l50 59q36 -35 76 -52.5t88 -17.5q60 0 97 27t37 72q0 32 -29.5 47t-89.5 31q-37 10 -64 20t-45 23t-27 29.5t-9 39.5q0 44 19 78.5t50.5 58.5t73 37t86.5 13q56 0 100 -19t72 -50l-51 -53q-26 29 -61.5 43.5t-75.5 14.5q-26 0 -48.5 -6 t-40 -18.5t-27.5 -31.5t-10 -44q0 -28 23.5 -41t75.5 -27q41 -11 72.5 -22t52.5 -25.5t31.5 -33t10.5 -44.5q0 -41 -17.5 -74.5t-48.5 -58t-74.5 -38t-94.5 -13.5zM94 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 586,
    d: "M317 630h-231l17 80h552l-17 -80h-231l-134 -630h-90zM149 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 338,
    d: "M142 -7q-41 0 -67.5 19t-26.5 61q0 14 3 29l75 351h-68l15 69h67l37 174h88l-37 -174h111l-15 -69h-110l-69 -324q-2 -10 -2 -15q0 -21 13 -30.5t32 -9.5q25 0 47 8.5t31 13.5l5 -70q-18 -13 -53.5 -23t-75.5 -10zM59 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1002,
    d: "M93 710h97l96 -606l175 293l-51 309h85l35 -247l141 247h85l-182 -309l50 -293l353 606h99l-433 -710h-77l-61 335l-205 -335h-77zM512 917h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 768,
    d: "M49 522h91l83 -445q32 42 60.5 82.5t54.5 82.5l-70 280h91l40 -169q42 85 65 169h84q-20 -69 -50.5 -138.5t-72.5 -138.5l41 -168q81 112 139.5 222.5t87.5 222.5h84q-36 -131 -108.5 -261t-174.5 -261h-95l-37 147q-51 -74 -111 -147h-95zM364 730h86l34 -101l-61 -20z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1002,
    d: "M590 795l-54 20l76 101h87zM93 710h97l96 -606l175 293l-51 309h85l35 -247l141 247h85l-182 -309l50 -293l353 606h99l-433 -710h-77l-61 335l-205 -335h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 768,
    d: "M426 609l-54 20l76 101h87zM49 522h91l83 -445q32 42 60.5 82.5t54.5 82.5l-70 280h91l40 -169q42 85 65 169h84q-20 -69 -50.5 -138.5t-72.5 -138.5l41 -168q81 112 139.5 222.5t87.5 222.5h84q-36 -131 -108.5 -261t-174.5 -261h-95l-37 147q-51 -74 -111 -147h-95z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1002,
    d: "M477 811l22 102h74l-22 -102h-74zM634 811l22 102h73l-21 -102h-74zM93 710h97l96 -606l175 293l-51 309h85l35 -247l141 247h85l-182 -309l50 -293l353 606h99l-433 -710h-77l-61 335l-205 -335h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 768,
    d: "M308 624l22 102h74l-22 -102h-74zM465 624l22 102h73l-21 -102h-74zM49 522h91l83 -445q32 42 60.5 82.5t54.5 82.5l-70 280h91l40 -169q42 85 65 169h84q-20 -69 -50.5 -138.5t-72.5 -138.5l41 -168q81 112 139.5 222.5t87.5 222.5h84q-36 -131 -108.5 -261t-174.5 -261 h-95l-37 147q-51 -74 -111 -147h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 600,
    d: "M-19 70l549 560h-421l17 80h526l-15 -70l-541 -560h422l-17 -80h-535zM163 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 470,
    d: "M-23 57l394 401h-300l14 64h398l-12 -57l-392 -401h308l-14 -64h-408zM91 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459zM168 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18zM154 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 580,
    d: "M171 710h450l-17 -80h-360l-49 -230h313l-16 -75h-313l-52 -245h369l-17 -80h-459zM473 813q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5 q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 539,
    d: "M228 -10q-49 0 -87 17t-64.5 47t-40 70t-13.5 86q0 63 24 121t67 102.5t101 71t126 26.5q77 0 124.5 -35.5t47.5 -105.5q0 -80 -69.5 -120.5t-215.5 -40.5q-24 0 -53.5 1t-61.5 4q-1 -6 -1 -12v-11q0 -31 8 -59t24 -49.5t40.5 -34t57.5 -12.5q46 0 90 23.5t69 63.5 l71 -21q-18 -29 -45 -53t-59 -41.5t-67.5 -27.5t-72.5 -10zM333 465q-43 0 -77.5 -14.5t-60 -38.5t-43 -54.5t-27.5 -62.5q30 -3 56.5 -4t49.5 -1q57 0 95.5 7.5t62.5 21t34.5 32t10.5 40.5q0 38 -27.5 56t-73.5 18zM410 627q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5 q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 258,
    d: "M171 709h90l-151 -709h-90zM-16 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 226,
    d: "M116 522h88l-111 -522h-88zM160 730h88l-23 -110h-88zM-30 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 721,
    d: "M295 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90.5 137t130 96t151.5 36q60 0 106.5 -25t78 -66t48 -94t16.5 -110q0 -81 -33.5 -157.5t-90 -136t-129.5 -95.5t-151 -36zM313 76q61 0 115 30.5t93.5 79t62.5 108.5t23 119q0 44 -11.5 84t-34 70 t-55.5 48t-75 18q-62 0 -115.5 -30t-93.5 -78.5t-63 -108.5t-23 -120q0 -44 11.5 -84t34 -70t55.5 -48t76 -18zM225 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 578,
    d: "M222 -10q-48 0 -85.5 17.5t-63 47t-38.5 69t-13 84.5q0 63 25 121t68 103t100.5 72t121.5 27q48 0 85.5 -17.5t63.5 -47t39.5 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-101 -72t-122.5 -27zM239 66q39 0 76 19t66.5 51t47.5 74.5t18 90.5q0 33 -9 61t-25.5 48.5 t-40 32.5t-51.5 12q-38 0 -75.5 -19t-67 -51.5t-47.5 -75.5t-18 -90q0 -33 9 -61t25.5 -48.5t39.5 -32t52 -11.5zM149 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 724,
    d: "M298 -5q-63 0 -106 18.5t-70 50.5t-39 75t-12 93q0 55 14 119l76 359h90l-76 -359q-12 -54 -12 -104q0 -36 7.5 -67t25.5 -54.5t47 -36.5t71 -13q58 0 101 24t74 62.5t51 88t31 100.5l76 359h90l-76 -359q-15 -72 -44.5 -136.5t-74.5 -113.5t-105.5 -77.5t-138.5 -28.5z M214 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 577,
    d: "M155 -10q-122 0 -122 132q0 35 11 87l67 313h87l-63 -296q-9 -41 -9 -69q0 -91 78 -91q50 0 101.5 34.5t86.5 94.5l69 327h88l-88 -414q-1 -4 -1.5 -7t-0.5 -6q0 -18 22 -19l-16 -76q-11 -2 -19.5 -3t-15.5 -1q-27 0 -41 12t-14 32q0 9 2 24.5t9 47.5q-45 -59 -106 -90.5 t-125 -31.5zM134 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 612,
    d: "M248 261l-159 449h99l122 -370l281 370h98l-352 -451l-55 -259h-90zM333 917h86l34 -101l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 501,
    d: "M-35 -153q31 4 53.5 10.5t40 17t32.5 27.5t32 43l29 44l-101 533h91l72 -443l34 56q42 69 71 121t49.5 96t34.5 84.5t26 85.5h87q-14 -48 -29 -90t-38 -88.5t-56.5 -103.5t-82.5 -137l-80 -129q-34 -55 -64 -92.5t-59.5 -60.5t-61 -33.5t-68.5 -11.5zM223 730h86l34 -101 l-61 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 612,
    d: "M248 261l-159 449h99l122 -370l281 370h98l-352 -451l-55 -259h-90zM457 813q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16 t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 501,
    d: "M-35 -153q31 4 53.5 10.5t40 17t32.5 27.5t32 43l29 44l-101 533h91l72 -443l34 56q42 69 71 121t49.5 96t34.5 84.5t26 85.5h87q-14 -48 -29 -90t-38 -88.5t-56.5 -103.5t-82.5 -137l-80 -129q-34 -55 -64 -92.5t-59.5 -60.5t-61 -33.5t-68.5 -11.5zM353 627 q-21 0 -36 6.5t-27 14.5t-24 14.5t-27 6.5q-16 0 -26.5 -7t-17 -15.5t-9.5 -16.5t-3 -9h-52q1 6 9 23t23 35t36 31.5t50 13.5q20 0 34 -6.5t25.5 -15t24 -15t29.5 -6.5q18 0 30 7t19.5 16t11 16.5t3.5 9.5h51q-1 -6 -9 -22.5t-23.5 -34.5t-38 -32t-53.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 558
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 875
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 560,
    d: "M48 233l17 80h435l-17 -80h-435z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 872,
    d: "M48 233l17 80h747l-17 -80h-747z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 206,
    d: "M225 730l-43 -115h29l-24 -114h-84l24 114l54 115h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 200,
    d: "M111 501l43 115h-29l24 114h84l-24 -114l-54 -115h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 212,
    d: "M-13 -115l44 115h-30l24 114h84l-24 -114l-53 -115h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 337,
    d: "M225 730l-43 -115h29l-24 -114h-84l24 114l54 115h44zM356 730l-43 -115h29l-24 -114h-84l24 114l54 115h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 331,
    d: "M111 501l43 115h-29l24 114h84l-24 -114l-54 -115h-44zM242 501l43 115h-29l24 114h84l-24 -114l-54 -115h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 348,
    d: "M-13 -115l44 115h-30l24 114h84l-24 -114l-53 -115h-45zM122 -115l44 115h-29l24 114h84l-25 -114l-53 -115h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 410,
    d: "M72 -130l76 361h-125l17 80h125l99 464h84l-99 -464h125l-17 -80h-125l-76 -361h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 409,
    d: "M72 -130l57 272h-125l17 80h125l24 111h-125l17 80h125l77 362h84l-77 -362h124l-17 -80h-124l-24 -111h125l-17 -80h-125l-57 -272h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 345,
    d: "M273 363q0 -22 -9.5 -42t-25.5 -35t-36.5 -24t-41.5 -9q-32 0 -52 22.5t-20 55.5q0 22 10 42t25.5 35t35.5 24t41 9q33 0 53 -23t20 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 493,
    d: "M0 0l24 112h74l-24 -112h-74zM147 0l24 112h73l-24 -112h-73zM293 0l24 112h74l-24 -112h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1053,
    d: "M220 428q-28 0 -50.5 9.5t-38.5 25.5t-24.5 38t-8.5 47q0 35 15.5 66t41 54.5t58 37.5t66.5 14q27 0 49.5 -9.5t38.5 -25.5t24.5 -38.5t8.5 -47.5q0 -35 -15.5 -66t-41 -54t-57.5 -37t-66 -14zM230 476q19 0 38 10t34 26.5t24 37.5t9 44q0 32 -18.5 55t-48.5 23 q-19 0 -38 -10t-34 -26.5t-24 -37.5t-9 -44q0 -32 18.5 -55t48.5 -23zM464 -10q-28 0 -50.5 9.5t-38.5 25.5t-24.5 38t-8.5 48q0 34 15.5 65.5t41 54.5t57.5 37t66 14q28 0 50 -9.5t38 -25.5t24.5 -38t8.5 -47q0 -35 -15.5 -66t-40.5 -54.5t-57 -37.5t-66 -14zM473 38 q19 0 38 10t34 26.5t24.5 37.5t9.5 44q0 32 -18.5 55t-48.5 23q-20 0 -39 -10t-34 -26.5t-24 -37.5t-9 -44q0 -32 18.5 -55t48.5 -23zM809 -10q-28 0 -50.5 9.5t-38.5 25.5t-24.5 38t-8.5 47q0 35 15.5 66t41 54.5t58 37.5t66.5 14q27 0 49.5 -9.5t38 -25.5t24 -38t8.5 -47 q0 -35 -15.5 -66t-40.5 -54.5t-57 -37.5t-66 -14zM818 38q19 0 38 10t34 26.5t24.5 37.5t9.5 44q0 32 -18.5 55t-48.5 23q-20 0 -39 -10t-34 -26.5t-24 -37.5t-9 -44q0 -32 18.5 -55t48.5 -23zM21 33l338 337l327 345l35 -37l-334 -335l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 341,
    d: "M36 280l280 181l-16 -74l-198 -128l144 -125l-16 -74l-204 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 341,
    d: "M286 234l-278 -174l16 74l197 125l-143 128l15 74l203 -181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 168,
    d: "M-254 33l338 337l327 345l35 -37l-334 -335l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 450,
    d: "M247 399q-40 0 -68.5 15t-47 39.5t-27 54.5t-8.5 60q0 42 18.5 85t51 78t75.5 57t93 22q39 0 67.5 -15.5t46.5 -40t26.5 -54.5t8.5 -60q0 -42 -18 -84.5t-50 -77.5t-75 -57t-93 -22zM154 575q0 -22 6 -43.5t19 -39t32.5 -28t46.5 -10.5q39 0 70.5 17.5t53 44.5t33.5 58.5 t12 58.5q0 22 -6.5 44t-19.5 39.5t-32.5 28t-46.5 10.5q-39 0 -70 -18t-52.5 -45t-33.5 -58.5t-12 -58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 379,
    d: "M261 405l21 99h-214l11 53l285 253h38l-54 -252h57l-12 -54h-56l-21 -99h-55zM136 558h160l38 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 368,
    d: "M264 664q56 0 90 -29.5t34 -77.5q0 -35 -16 -64t-42.5 -50t-61.5 -32.5t-73 -11.5q-48 0 -82.5 20t-46.5 54l42 34q12 -26 38.5 -40.5t63.5 -14.5q24 0 46 7t38.5 20t26.5 31t10 41q0 35 -25 52.5t-56 17.5q-28 0 -56.5 -13t-46.5 -34h-50q9 21 23.5 54.5t30 68.5t29 66 t19.5 47h219l-12 -55h-178l-53 -117q17 12 40 19t49 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 399,
    d: "M420 557q0 -33 -16 -62.5t-43 -51.5t-62.5 -35t-74.5 -13q-61 0 -95.5 36.5t-34.5 100.5q0 58 16.5 109t46.5 88.5t71.5 59t91.5 21.5q43 0 75 -18t45 -51l-41 -37q-8 24 -33 39t-59 15q-52 0 -92 -37.5t-55 -106.5q10 13 24.5 24t31.5 18.5t35 11.5t36 4q60 0 96.5 -33 t36.5 -82zM237 446q24 0 47.5 8.5t41.5 22.5t29 32t11 38q0 32 -25.5 54.5t-66.5 22.5q-25 0 -48 -8t-41 -22t-29 -32t-11 -38q0 -32 26 -55t66 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 354,
    d: "M354 755h-233l11 55h320l-314 -405h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 389,
    d: "M401 535q0 -30 -16 -55t-42 -43t-59.5 -28t-69.5 -10q-61 0 -97.5 30.5t-36.5 74.5q0 23 9.5 42t25 33.5t35 25t39.5 17.5q-23 9 -38.5 26.5t-15.5 43.5q0 27 15.5 48.5t40 37t54 24t57.5 8.5q24 0 46 -6.5t39 -18t27.5 -28.5t10.5 -38q0 -36 -26.5 -60.5t-63.5 -36.5 q29 -12 47.5 -34t18.5 -53zM346 534q0 15 -7.5 26.5t-20 19.5t-28.5 12.5t-33 4.5q-22 0 -43.5 -6t-38.5 -16.5t-27.5 -25.5t-10.5 -33q0 -15 8 -26.5t20.5 -19.5t29 -12t33.5 -4q21 0 42 5.5t38 16t27.5 25.5t10.5 33zM190 693q0 -24 24 -37t53 -13q16 0 34 4.5t33 12.5 t25 20t10 27q0 24 -23.5 37t-54.5 13q-19 0 -37 -4.5t-32.5 -13t-23 -20t-8.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 399,
    d: "M107 648q0 33 16 62.5t43 51.5t62.5 35t73.5 13q61 0 96 -36.5t35 -100.5q0 -59 -16.5 -109.5t-46.5 -88t-71.5 -59t-91.5 -21.5q-43 0 -75 18.5t-45 51.5l41 36q8 -25 32.5 -39.5t59.5 -14.5q52 0 92 37.5t55 106.5q-20 -26 -56 -42t-72 -16q-60 0 -96 33t-36 82z M290 759q-24 0 -47.5 -8.5t-41.5 -22.5t-29 -32t-11 -38q0 -32 26 -54t66 -22q24 0 47.5 8t41.5 21.5t29 31.5t11 38q0 32 -26 55t-66 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 450,
    d: "M144 -85q-40 0 -68.5 15t-47 39.5t-27 54.5t-8.5 60q0 42 18.5 85t51 78t75.5 57t93 22q39 0 67.5 -15.5t46.5 -40t26.5 -54.5t8.5 -60q0 -42 -18.5 -84.5t-50 -77.5t-75 -57t-92.5 -22zM50 91q0 -22 6 -43.5t19 -39t33 -28t47 -10.5q39 0 70 17.5t53 44.5t34 58.5 t12 58.5q0 22 -6.5 44t-19.5 39.5t-32.5 28t-46.5 10.5q-39 0 -70 -18t-53 -45t-34 -58.5t-12 -58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 291,
    d: "M202 -26l-11 -54h-224l11 54h87l63 295q-7 -7 -20.5 -15.5t-29.5 -16t-32.5 -12.5t-29.5 -5l12 55q17 0 36.5 8.5t36.5 18.5t28.5 19t11.5 10h56l-76 -357h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 386,
    d: "M-46 -80q8 39 21.5 68.5t33 51.5t46 38.5t61.5 29.5q26 10 53 19t48.5 21t35.5 29t14 43q0 25 -19.5 41t-58.5 16q-46 0 -79 -18.5t-52 -35.5l-27 40q6 7 21.5 18.5t38 22.5t52.5 19t65 8q62 0 92 -27.5t30 -71.5q0 -29 -9.5 -51.5t-29 -40.5t-50 -32.5t-71.5 -27.5 q-31 -10 -52 -23t-34.5 -27t-20.5 -28.5t-10 -27.5h225l-12 -54h-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 380,
    d: "M100 -85q-59 0 -95 22.5t-37 63.5l39 37q0 -11 6.5 -22.5t19.5 -22t32.5 -17t45.5 -6.5q24 0 45.5 5t38 15t26.5 23t10 30q0 29 -33.5 45t-93.5 16h-22l10 50h22q65 0 104 17.5t39 53.5q0 26 -24.5 40.5t-56.5 14.5q-39 0 -70 -15t-51 -39l-27 43q25 29 68.5 45.5 t89.5 16.5q60 0 95.5 -27t35.5 -69q0 -41 -28.5 -67t-80.5 -37q38 -6 58.5 -30t20.5 -56t-16 -56t-42.5 -40.5t-60 -25t-68.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 377,
    d: "M157 -80l21 100h-214l11 53l285 253h38l-54 -252h57l-12 -54h-56l-21 -100h-55zM32 74h160l38 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 369,
    d: "M162 180q56 0 90 -30t34 -78q0 -34 -16 -63t-42.5 -50t-61 -32.5t-72.5 -11.5q-48 0 -82.5 20t-47.5 53l42 34q13 -25 39 -40t63 -15q24 0 46 7t38.5 20.5t26.5 31.5t10 41q0 35 -25 52.5t-56 17.5q-28 0 -56.5 -13t-46.5 -34h-50q9 21 23.5 54.5t30 68.5t29 66t19.5 47 h219l-12 -55h-178l-53 -117q17 12 40 19t49 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 398,
    d: "M317 76q0 -33 -16 -62t-43 -51t-62 -35t-74 -13q-61 0 -95.5 36t-34.5 101q0 58 16.5 109t46.5 88t71.5 58.5t91.5 21.5q43 0 75 -18t44 -51l-40 -37q-8 25 -33.5 39.5t-58.5 14.5q-53 0 -92.5 -37.5t-54.5 -106.5q10 13 24.5 24t31.5 18.5t35 11.5t36 4q60 0 96 -33 t36 -82zM135 -35q24 0 47 8.5t41 22.5t29 32t11 38q0 32 -25 54.5t-66 22.5q-25 0 -48.5 -8t-41.5 -22t-29 -32t-11 -38q0 -32 26.5 -55t66.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 353,
    d: "M252 271h-234l12 55h320l-315 -406h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 391,
    d: "M300 51q0 -30 -16 -55t-42.5 -43t-60 -28t-69.5 -10q-61 0 -97.5 30.5t-36.5 74.5q0 23 9.5 42t25 33.5t35 25t39.5 17.5q-23 9 -38.5 26.5t-15.5 43.5q0 27 15.5 48.5t40 37t54 24t57.5 8.5q24 0 46 -6.5t39.5 -18t28 -28.5t10.5 -38q0 -36 -27 -60.5t-64 -36.5 q29 -12 48 -34t19 -53zM244 50q0 15 -7.5 26.5t-20 19.5t-28.5 12.5t-33 4.5q-21 0 -42.5 -6t-39 -16.5t-28 -26t-10.5 -33.5q0 -14 8 -25.5t20.5 -19.5t29 -12t33.5 -4q21 0 42 5.5t38 16t27.5 25.5t10.5 33zM88 208q0 -12 6.5 -21t17.5 -15.5t25 -10t28 -3.5q16 0 34 4.5 t33 13t25 20.5t10 27q0 23 -23 36.5t-55 13.5q-19 0 -37 -4.5t-32.5 -13t-23 -20.5t-8.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 400,
    d: "M5 167q0 33 16 62.5t43 51.5t62.5 35t73.5 13q61 0 96 -36.5t35 -100.5q0 -59 -16.5 -109.5t-46 -87.5t-71 -58.5t-92.5 -21.5q-43 0 -75.5 18t-45.5 51l42 37q8 -25 32.5 -39.5t59.5 -14.5q51 0 91.5 37t55.5 106q-20 -26 -56 -42t-72 -16q-60 0 -96 33t-36 82zM188 278 q-25 0 -48 -8.5t-41 -22.5t-29 -32t-11 -38q0 -32 26 -54t66 -22q24 0 47 8t41 22t29 32t11 38q0 32 -25.5 54.5t-65.5 22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 536,
    d: "M154 2q-31 11 -55.5 31.5t-41 47.5t-25 60t-8.5 69q0 54 18 104t50.5 91.5t76.5 71.5t96 44l26 124h44l-25 -116q8 1 15.5 1.5t15.5 0.5q7 0 14 -0.5t12 -1.5l25 116h44l-27 -124q45 -14 74.5 -44t40.5 -73l-91 -27q-11 37 -40 57.5t-70 20.5q-40 0 -77.5 -18.5 t-66.5 -50t-46.5 -74.5t-17.5 -91q0 -33 9 -61.5t25.5 -49t40 -32.5t51.5 -12q21 0 43.5 6.5t42 17.5t35.5 25.5t25 31.5l81 -26q-26 -44 -71 -76t-99 -46l-25 -119h-44l24 111q-7 -1 -13.5 -1h-12.5q-8 0 -15.5 0.5t-15.5 1.5l-24 -112h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 589,
    d: "M52 0l27 127h-85l14 68h85l110 515h447l-17 -80h-357l-50 -237h300l-16 -75h-300l-27 -123h112l-14 -68h-112l-27 -127h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 481,
    d: "M73 404h69q-8 27 -14 53.5t-6 54.5q0 42 19 78.5t50 64.5t71 44t82 16q54 0 96 -28t63 -77l-60 -54q-14 39 -46 62.5t-70 23.5q-24 0 -47 -10t-40 -28t-27.5 -41.5t-10.5 -50.5q0 -26 7 -52.5t15 -55.5h182l-11 -52h-160q2 -11 3 -24t1 -35h143l-11 -52h-140 q-5 -18 -14.5 -36.5t-25.5 -39.5t-38 -44.5t-53 -51.5q37 10 72 10q19 0 35.5 -3t31.5 -6l30 -6t32 -3q18 0 38 4.5t46 13.5l7 -67q-26 -13 -55.5 -20t-55.5 -7q-21 0 -40.5 4t-38.5 8.5t-39 8.5t-42 4q-23 0 -54 -5t-59 -13l-8 64q69 58 104.5 100.5t47.5 84.5h-114l11 52 h111q0 32 -6 59h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 817,
    d: "M794 376h-83l-13 -59h84l-11 -52h-84l-56 -265h-76l-142 265h-207l-56 -265h-90l56 265h-86l11 52h86l13 59h-86l11 52h86l60 282h70l149 -282h201l61 281h90l-60 -281h83zM217 317h168l-31 59h-125zM489 317h119l12 59h-162zM240 428h86l-61 114zM574 157l23 108h-80z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1081,
    d: "M49 357h152l-13 69h-124l11 52h104l-42 232h97l37 -232h219l-37 228h85l36 -247l141 247h85l-135 -228h221l135 232h98l-142 -232h105l-11 -52h-125l-42 -69h152l-11 -52h-173l-185 -305h-78l-61 335l-204 -335h-78l-56 305h-172zM330 104l119 201h-151zM668 104l117 201 h-151zM625 357h190l40 69h-220l-17 -29zM499 426h-220l11 -69h190l24 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 757,
    d: "M152 422q20 58 56.5 110.5t86 93t110.5 64.5t130 24q45 0 81.5 -11.5t64.5 -32t46 -49t27 -62.5l-81 -46q-8 34 -24 57t-38 37t-47 20t-50 6q-48 0 -90 -17t-76.5 -46.5t-61 -67.5t-42.5 -80h298l-33 -52h-281q-3 -15 -5 -30t-3 -29h265l-33 -52h-230q5 -39 19 -72.5 t36.5 -58t53 -39t67.5 -14.5q26 0 55 7t58 22.5t56 39t48 56.5l66 -41q-24 -40 -60 -70.5t-77 -51.5t-84.5 -32t-82.5 -11q-55 0 -98.5 21.5t-75 58.5t-50 84.5t-23.5 100.5h-105l33 52h71q1 14 3 29t5 30h-67l33 52h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 478,
    d: "M490 537h-101q1 -5 1 -15q0 -42 -15 -82.5t-40.5 -74t-60.5 -58.5t-75 -35l106 -272h-102l-131 335h76q30 0 57.5 15.5t47.5 40.5t32 56.5t12 64.5q0 6 -0.5 12.5t-1.5 12.5h-207l11 52h176q-12 19 -29.5 30t-39.5 11h-99l18 80h402l-11 -52h-174q26 -31 38 -69h121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 343,
    d: "M180 -7q-52 0 -81 29t-29 81v507q0 28 10.5 51.5t28.5 41t42.5 27.5t53.5 10q57 0 91.5 -36t34.5 -94q0 -39 -15.5 -89.5t-41 -101.5t-58.5 -98t-68 -80v-106q0 -29 18 -45.5t49 -16.5q12 0 27 3.5t29 8.5l14 -71q-22 -9 -52 -15t-53 -6zM260 604q0 32 -14 49.5t-40 17.5 t-42 -17t-16 -44v-277q22 27 42 62.5t35.5 73t25 73t9.5 62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1105,
    d: "M224 542l-115 -542h-90l151 710h70l294 -553l117 552h90l-151 -709h-75zM921 344q-34 0 -60 12t-43.5 32t-26.5 47t-9 57q0 43 17 82.5t46 70t69 48.5t85 18q33 0 59 -11.5t43.5 -31.5t27 -47t9.5 -58q0 -42 -17 -81.5t-46 -70t-69 -49t-85 -18.5zM854 501q0 -42 22 -69 t58 -27q25 0 48.5 12t42 32t29.5 47t11 57q0 42 -22 69t-57 27q-25 0 -49 -11.5t-42.5 -32t-29.5 -47.5t-11 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 712,
    d: "M645 710h86l-62 -290h-59l44 208l-108 -166h-49l-37 166l-45 -208h-59l61 290h85l34 -178zM321 632q-8 11 -28.5 21t-46.5 10q-57 0 -57 -35q0 -10 11.5 -18t43.5 -16q41 -10 64.5 -26.5t23.5 -51.5q0 -26 -10.5 -45t-28.5 -31t-42.5 -18t-52.5 -6q-70 0 -115 42l37 45 q10 -13 34 -23.5t56 -10.5q27 0 42 7.5t15 23.5q0 14 -13 22t-47 17q-39 11 -60 26t-21 46q0 25 10.5 44t28.5 32.5t42 20.5t51 7q32 0 55.5 -9t40.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 731,
    d: "M373 652h-90l-49 -232h-60l49 232h-90l13 60h240zM429 710h85l34 -178l109 178h86l-62 -290h-60l45 208l-109 -166h-48l-38 166l-44 -208h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 802,
    d: "M51 79h179q-78 44 -123.5 118.5t-45.5 167.5q0 69 25 132.5t68.5 111.5t103 77t129.5 29t129.5 -29t103 -77t68.5 -111.5t25 -132.5q0 -93 -45.5 -167.5t-123.5 -118.5h179v-79h-289v79q43 14 78 43.5t59.5 68.5t37.5 84t13 90q0 50 -16.5 98t-47 86t-74 61t-97.5 23 t-97.5 -23t-74 -61t-47 -86t-16.5 -98q0 -45 13 -90t37.5 -84t59.5 -68.5t78 -43.5v-79h-289v79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    d: "M300 27q69 0 114.5 22t74.5 52l26 -28q-35 -35 -87.5 -59t-127.5 -24q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59.5t54 -87.5t19.5 -107h-420v-150q29 -36 69 -57t87 -21zM300 494q-47 0 -87 -21.5t-69 -58.5v-119 h314v118q-29 38 -69.5 59.5t-88.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 849,
    d: "M586 -5q-60 0 -95.5 22.5t-36.5 63.5l39 37q0 -11 6.5 -22.5t19.5 -22t32.5 -17t45.5 -6.5q24 0 45.5 5t38 15t26.5 23t10 30q0 29 -33.5 45t-93.5 16h-22l10 50h22q65 0 104 17.5t39 53.5q0 26 -24.5 40.5t-56.5 14.5q-39 0 -70 -15t-51 -39l-27 43q25 29 68.5 45.5 t89.5 16.5q60 0 95.5 -27t35.5 -69q0 -41 -28.5 -67t-80.5 -37q38 -6 58.5 -30t20.5 -56t-16 -56t-42.5 -40.5t-60 -25t-68.5 -8.5zM275 375l-12 -55h-201l12 55h76l62 294q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l12 55q15 0 32.5 8.5t33 18.5t26 19t10.5 10h56 l-76 -356h70zM50 33l338 337l327 345l35 -37l-334 -335l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 863,
    d: "M600 -5q-60 0 -95.5 22.5t-36.5 63.5l39 37q0 -11 6.5 -22.5t19.5 -22t32.5 -17t45.5 -6.5q24 0 45.5 5t38 15t26.5 23t10 30q0 29 -33.5 45t-93.5 16h-22l10 50h22q65 0 104 17.5t39 53.5q0 26 -24.5 40.5t-56.5 14.5q-39 0 -70 -15t-51 -39l-27 43q25 29 68.5 45.5 t89.5 16.5q60 0 95.5 -27t35.5 -69q0 -41 -28.5 -67t-80.5 -37q38 -6 58.5 -30t20.5 -56t-16 -56t-42.5 -40.5t-60 -25t-68.5 -8.5zM45 320q8 39 20.5 68.5t31.5 51.5t44.5 38.5t58.5 29.5q25 10 51.5 19.5t47.5 21.5t34.5 29t13.5 43q0 24 -19 40t-57 16q-44 0 -76 -18 t-50 -35l-26 39q6 7 20.5 18.5t36.5 22.5t51 19t63 8q60 0 88.5 -27.5t28.5 -71.5q0 -58 -37.5 -91.5t-117.5 -60.5q-30 -10 -50 -22.5t-33 -27t-20 -29t-10 -27.5h211l-12 -54h-293zM102 33l338 337l327 345l35 -37l-334 -335l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 848,
    d: "M586 -5q-61 0 -97.5 30.5t-36.5 74.5q0 23 9.5 42t25 33.5t35 25t39.5 17.5q-23 9 -38.5 26.5t-15.5 43.5q0 27 15.5 48.5t40 37t54 24t57.5 8.5q24 0 46 -6.5t39.5 -18t28 -28.5t10.5 -38q0 -36 -27 -60.5t-64 -36.5q29 -12 48 -34t19 -53q0 -30 -16 -55t-42.5 -43 t-60 -28t-69.5 -10zM600 50q21 0 42 5.5t38 16t27.5 25.5t10.5 33q0 15 -7.5 26.5t-20 19.5t-28.5 12.5t-33 4.5q-21 0 -42.5 -6t-39 -16.5t-28 -26t-10.5 -33.5q0 -14 8 -25.5t20.5 -19.5t29 -12t33.5 -4zM639 238q17 0 35 4.5t33 13t24.5 20.5t9.5 27q0 23 -23.5 36.5 t-54.5 13.5q-19 0 -37 -4.5t-32.5 -13t-23 -20.5t-8.5 -27q0 -12 6.5 -21t17.5 -15.5t25 -10t28 -3.5zM274 375l-12 -55h-201l12 55h76l62 294q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l12 55q15 0 32.5 8.5t33 18.5t26 19t10.5 10h56l-76 -356h70zM61 33l338 337 l327 345l35 -37l-334 -335l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 854,
    d: "M191 314q-60 0 -95 23t-37 63l40 38q0 -11 6.5 -23t19 -22t32 -16.5t45.5 -6.5q24 0 46 5t38.5 15t26.5 23t10 30q0 29 -34 44.5t-94 15.5h-22l10 51h22q66 0 104.5 17.5t38.5 53.5q0 26 -24 40.5t-57 14.5q-38 0 -69.5 -15t-51.5 -39l-27 43q25 29 68.5 45.5t90.5 16.5 q59 0 94.5 -27t35.5 -69q0 -41 -28.5 -67t-80.5 -37q38 -6 58.5 -30t20.5 -56t-16 -56t-42.5 -41t-60 -25.5t-68.5 -8.5zM591 -5q-61 0 -97.5 30.5t-36.5 74.5q0 23 9.5 42t25 33.5t35 25t39.5 17.5q-23 9 -38.5 26.5t-15.5 43.5q0 27 15.5 48.5t40 37t54 24t57.5 8.5 q24 0 46 -6.5t39.5 -18t28 -28.5t10.5 -38q0 -36 -27 -60.5t-64 -36.5q29 -12 48 -34t19 -53q0 -30 -16 -55t-42.5 -43t-60 -28t-69.5 -10zM605 50q21 0 42 5.5t38 16t27.5 25.5t10.5 33q0 15 -7.5 26.5t-20 19.5t-28.5 12.5t-33 4.5q-21 0 -42.5 -6t-39 -16.5t-28 -26 t-10.5 -33.5q0 -14 8 -25.5t20.5 -19.5t29 -12t33.5 -4zM644 238q17 0 35 4.5t33 13t24.5 20.5t9.5 27q0 23 -23.5 36.5t-54.5 13.5q-19 0 -37 -4.5t-32.5 -13t-23 -20.5t-8.5 -27q0 -12 6.5 -21t17.5 -15.5t25 -10t28 -3.5zM86 33l338 337l327 345l35 -37l-334 -335 l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 864,
    d: "M601 -5q-61 0 -97.5 30.5t-36.5 74.5q0 23 9.5 42t25 33.5t35 25t39.5 17.5q-23 9 -38.5 26.5t-15.5 43.5q0 27 15.5 48.5t40 37t54 24t57.5 8.5q24 0 46 -6.5t39.5 -18t28 -28.5t10.5 -38q0 -36 -27 -60.5t-64 -36.5q29 -12 48 -34t19 -53q0 -30 -16 -55t-42.5 -43 t-60 -28t-69.5 -10zM615 50q21 0 42 5.5t38 16t27.5 25.5t10.5 33q0 15 -7.5 26.5t-20 19.5t-28.5 12.5t-33 4.5q-21 0 -42.5 -6t-39 -16.5t-28 -26t-10.5 -33.5q0 -14 8 -25.5t20.5 -19.5t29 -12t33.5 -4zM654 238q17 0 35 4.5t33 13t24.5 20.5t9.5 27q0 23 -23.5 36.5 t-54.5 13.5q-19 0 -37 -4.5t-32.5 -13t-23 -20.5t-8.5 -27q0 -12 6.5 -21t17.5 -15.5t25 -10t28 -3.5zM253 584q56 0 90 -29.5t34 -77.5q0 -35 -16 -64t-42.5 -50t-61.5 -32.5t-73 -11.5q-48 0 -82.5 20t-46.5 54l42 34q12 -26 38.5 -40.5t63.5 -14.5q24 0 46 7t38.5 20 t26.5 31t10 41q0 35 -25 52.5t-56 17.5q-28 0 -56.5 -13t-46.5 -34h-50q9 21 23.5 54.5t30 68.5t29 66t19.5 47h219l-12 -55h-178l-53 -117q17 12 40 19t49 7zM86 33l338 337l327 345l35 -37l-334 -335l-332 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 835,
    d: "M573 -5q-61 0 -97.5 30.5t-36.5 74.5q0 23 9.5 42t25 33.5t35 25t39.5 17.5q-23 9 -38.5 26.5t-15.5 43.5q0 27 15.5 48.5t40 37t54 24t57.5 8.5q24 0 46 -6.5t39.5 -18t28 -28.5t10.5 -38q0 -36 -27 -60.5t-64 -36.5q29 -12 48 -34t19 -53q0 -30 -16 -55t-42.5 -43 t-60 -28t-69.5 -10zM587 50q21 0 42 5.5t38 16t27.5 25.5t10.5 33q0 15 -7.5 26.5t-20 19.5t-28.5 12.5t-33 4.5q-21 0 -42.5 -6t-39 -16.5t-28 -26t-10.5 -33.5q0 -14 8 -25.5t20.5 -19.5t29 -12t33.5 -4zM626 238q17 0 35 4.5t33 13t24.5 20.5t9.5 27q0 23 -23.5 36.5 t-54.5 13.5q-19 0 -37 -4.5t-32.5 -13t-23 -20.5t-8.5 -27q0 -12 6.5 -21t17.5 -15.5t25 -10t28 -3.5zM16 33l338 337l327 345l35 -37l-334 -335l-332 -348zM352 675h-233l11 55h320l-314 -405h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 560,
    d: "M250 -10q-48 0 -88 16t-69.5 43.5t-45.5 65t-16 80.5q0 47 19.5 90.5t53.5 76.5t78 52.5t94 19.5q57 0 98.5 -25.5t56.5 -68.5q2 22 3 42t1 37q0 62 -10 104t-29 67.5t-46 36.5t-60 11q-42 0 -81 -14.5t-59 -37.5l-49 53q32 37 84.5 56.5t112.5 19.5q109 0 164.5 -74 t55.5 -242q0 -101 -19.5 -177.5t-55 -128t-84.5 -77.5t-109 -26zM252 66q33 0 62.5 13t52 35.5t35.5 52t13 61.5q0 28 -10.5 53t-29 43t-43.5 28.5t-54 10.5q-32 0 -61.5 -13t-52 -35t-36 -51t-13.5 -62q0 -29 10.5 -53.5t29 -43t43.5 -29t54 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 652,
    d: "M600 67v-67h-602v67l265 643h74zM501 80l-201 526l-202 -526h403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 776,
    d: "M572 630h-331v-720h-85v720h-80v80h661v-80h-80v-720h-85v720z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 615,
    d: "M538 637h-338v-4l191 -264l-212 -285v-4h374v-80h-480v63l223 293l-216 298v56h458v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 551,
    d: "M74 269v72h403v-72h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 579,
    d: "M-61 38l682 677l43 -43l-682 -677z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 199,
    d: "M50 245l26 124h74l-26 -124h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 420,
    d: "M17 365h157l63 -288l112 713h84l-152 -790h-94l-86 301h-84v64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 688,
    d: "M213 517q28 0 49.5 -7.5t38 -20t29 -29t23.5 -35.5q11 19 23.5 35.5t29 29t37.5 20t50 7.5q36 0 65.5 -13t50.5 -35.5t32 -53t11 -64.5t-12 -64t-33.5 -52.5t-51 -35.5t-63.5 -13q-54 0 -85 24.5t-52 58.5q-20 -34 -52 -58.5t-90 -24.5q-30 0 -59 13t-51.5 35.5t-36 53 t-13.5 64.5t12 64t33.5 52.5t51 35.5t63.5 13zM213 256q21 0 37.5 7.5t30 20.5t24 30t20.5 36q-10 19 -20.5 36.5t-23.5 31t-29.5 21t-38.5 7.5q-16 0 -32 -5.5t-29 -16.5t-21 -29t-8 -43q0 -26 8 -44t21 -29.5t29 -17t32 -5.5zM493 256q16 0 32 5.5t28.5 17t20.5 29.5t8 44 q0 25 -8 43t-20.5 29t-28.5 16.5t-32 5.5q-23 0 -39.5 -8t-29 -21.5t-22.5 -32t-19 -38.5q19 -37 43.5 -63.5t66.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 311,
    d: "M104 669q-2 35 -3 48.5t-1 19.5q0 38 28 60.5t79 22.5q23 0 53 -6t53 -15l-21 -61q-14 5 -29 8.5t-26 3.5q-26 0 -41.5 -9.5t-15.5 -29.5q0 -9 0.5 -18.5t2.5 -39.5l37 -675q1 -14 1.5 -22.5t0.5 -13v-6v-2.5q0 -48 -27.5 -74.5t-77.5 -26.5q-23 0 -52.5 6t-52.5 15 l21 61q14 -5 28.5 -8.5t25.5 -3.5q26 0 41 15.5t15 41.5v5t-1 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 442,
    d: "M369 335q-14 -19 -36 -32.5t-56 -13.5q-23 0 -39.5 6.5t-31 14.5t-28.5 14.5t-30 6.5q-20 0 -31.5 -8t-16.5 -18l-40 44q12 19 32.5 33t53.5 14q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q23 0 35.5 7t20.5 15zM369 198q-14 -17 -36 -29t-56 -12q-23 0 -39.5 6.5t-31 14.5 t-28.5 14.5t-30 6.5q-20 0 -31.5 -8t-16.5 -18l-40 44q12 19 32.5 33t53.5 14q21 0 37 -6.5t30.5 -15t29 -15t32.5 -6.5q23 0 35.5 6.5t20.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 485,
    d: "M84 373h180l67 122l38 -22l-55 -100h75v-60h-107l-41 -74h148v-60h-181l-66 -122l-38 22l54 100h-74v60h107l41 74h-148v60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 460,
    d: "M51 51v72h332v-72h-332zM50 390l330 163v-84l-202 -100l202 -97v-88l-330 160v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 481,
    d: "M70 123h332v-72h-332v72zM73 272l202 97l-202 100v84l330 -163v-46l-330 -160v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 523,
    d: "M322 730l186 -364l-186 -366h-94l-186 366l186 364h94zM429 354l-155 308l-145 -287l154 -310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 163,
    d: "M16 -213l37 81h-25l18 84h77l-18 -84l-46 -81h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 791,
    d: "M179 -10q-63 0 -115 21.5t-83 52.5l48 60q74 -69 161 -69q25 0 49.5 6t43.5 18t30.5 29.5t11.5 40.5q0 20 -9 33t-25 21.5t-37 14t-46 10.5q-32 7 -60 14t-48.5 20t-32 33.5t-11.5 53.5q0 44 20.5 78t52.5 57t71.5 35t77.5 12q29 0 60 -7t53 -24q-4 17 -7 35.5t-3 38.5 q0 31 10 61.5t33 54.5t61 39t94 15q70 0 95.5 -24.5t25.5 -72.5q0 -26 -5 -56.5t-13 -68.5h110l-15 -69h-109l-69 -324q-1 -5 -1.5 -8t-0.5 -8q0 -20 13 -29.5t33 -9.5q23 0 45 8.5t32 13.5l4 -70q-9 -4 -23 -9.5t-31 -11t-36 -9t-38 -3.5q-40 0 -67 19t-27 59 q0 12 2.5 24.5l5.5 27.5l70 330h-68l15 69h67q8 39 12.5 67.5t4.5 48.5q0 35 -14.5 48.5t-48.5 13.5t-58 -10.5t-39 -28.5t-22 -41.5t-7 -50.5q0 -19 3 -37t7 -32t8 -24t6 -13l-50 -53q-27 33 -61 45t-66 12q-24 0 -47.5 -5.5t-41.5 -17t-29.5 -30t-11.5 -43.5 q0 -23 9 -36.5t26 -22t41.5 -14t55.5 -11.5q30 -6 55.5 -13t44 -19.5t29 -32.5t10.5 -51q0 -45 -20 -78.5t-52.5 -56.5t-74 -34.5t-84.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 563,
    d: "M131 551h289q25 0 44.5 -9.5t32.5 -25.5t19.5 -37t6.5 -43q0 -24 -8 -47.5t-23 -43.5t-35.5 -36t-45.5 -26q38 -12 59 -41.5t21 -71.5q0 -39 -17 -70.5t-45.5 -53.5t-65.5 -34t-77 -12h-272zM300 69q21 0 41 8.5t35.5 23t25 33t9.5 39.5q0 29 -18 51t-49 22h-198 l-37 -177h191zM336 311q20 0 39 8t33.5 21.5t23 32.5t8.5 40q0 30 -17.5 49t-46.5 19h-180l-36 -170h176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 570,
    d: "M246 -5q-51 0 -91.5 20t-68 53t-42 76t-14.5 88q0 56 25.5 113.5t70.5 104t107 75.5t136 29q77 0 125.5 -33t63.5 -87l-71 -42q-7 25 -21.5 42.5t-33 28t-39.5 15t-42 4.5q-54 0 -98 -22.5t-75.5 -57.5t-48.5 -78.5t-17 -85.5q0 -35 10.5 -66t30 -54t48 -37t64.5 -14 q44 0 94 22t85 72l58 -38q-20 -31 -50 -54.5t-64.5 -40t-71.5 -25t-70 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 567,
    d: "M307 551h66l117 -551h-84l-33 155h-234l-98 -155h-86zM368 225l-49 227l-147 -227h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 604,
    d: "M131 551h202q58 0 101.5 -17t71.5 -46t42 -68.5t14 -85.5q0 -73 -26 -134t-72.5 -105.5t-110 -69.5t-137.5 -25h-202zM231 71q58 0 104 20.5t78 55t49 80t17 95.5q0 70 -40.5 114t-120.5 44h-122l-87 -409h122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 510,
    d: "M131 551h386l-15 -71h-306l-35 -166h266l-14 -66h-266l-38 -177h313l-15 -71h-393z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 495,
    d: "M131 551h382l-15 -71h-302l-37 -172h255l-15 -67h-254l-51 -241h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 699,
    d: "M301 -5q-61 0 -108.5 24.5t-80.5 65t-50 94t-17 112.5q0 79 33 155t88.5 136t129.5 96.5t156 36.5q85 0 142.5 -41.5t82.5 -110.5l-83 -57q-7 22 -20 45t-33.5 41.5t-47.5 30t-63 11.5q-61 0 -114.5 -30.5t-93.5 -78.5t-63 -108t-23 -120q0 -43 11 -83t33 -70.5t54.5 -49 t76.5 -18.5q43 0 83 17t74 45t60.5 64t41.5 75h-179l17 80h277q0 -2 -2 -9t-4 -15t-3.5 -15.5t-2.5 -9.5q-18 -63 -54 -119.5t-85 -99.5t-108.5 -68.5t-124.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 594,
    d: "M429 71q-90 -75 -185 -75q-49 0 -88.5 19.5t-67 52t-42.5 75t-15 88.5q0 63 27.5 121.5t73.5 103.5t106 72t126 27q81 0 128 -33t64 -87l-71 -44q-14 47 -51 69.5t-88 22.5q-48 0 -91 -21.5t-74.5 -56.5t-50 -79t-18.5 -90q0 -35 11 -65.5t31 -53.5t48 -36t63 -13 q89 0 181 84l14 65h-122l12 60h190l-59 -277h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 622,
    d: "M131 551h80l-50 -233h308l49 233h80l-117 -551h-80l52 246h-307l-52 -246h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 235,
    d: "M131 551h80l-117 -551h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 417,
    d: "M82 -8q-74 0 -119 33l35 66q12 -10 38 -19t61 -9q40 0 66 13.5t44 39.5t30 65t23 90l60 280h80l-60 -280q-14 -63 -31 -114.5t-45.5 -88t-72 -56.5t-109.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 549,
    d: "M131 551h80l-63 -295l351 295h86l-281 -243l177 -308h-86l-150 261l-115 -93l-36 -168h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 468,
    d: "M131 551h80l-102 -480h298l-15 -71h-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 222,
    d: "M59 629l76 101h87l-109 -121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 728,
    d: "M131 551h85l129 -345l275 345h84l-117 -551h-80l87 409l-250 -311h-45l-118 311l-87 -409h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 644,
    d: "M131 551h62l260 -410l87 410h80l-117 -551h-67l-257 402l-85 -402h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 625,
    d: "M247 -4q-52 0 -92.5 19t-68.5 51.5t-42.5 74.5t-14.5 87q0 62 28 121t74.5 104.5t108 73t127.5 27.5q52 0 92.5 -19.5t68.5 -52t42 -74.5t14 -87q0 -62 -28 -120.5t-74.5 -104t-107.5 -73t-127 -27.5zM264 68q51 0 94.5 22.5t75.5 57.5t50 79t18 87q0 34 -10 64.5 t-29.5 53.5t-47.5 36.5t-64 13.5q-51 0 -94.5 -22t-76 -57t-51 -79t-18.5 -88q0 -33 10 -63.5t29.5 -54t48 -37t65.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 527,
    d: "M131 551h241q33 0 59.5 -13t45 -34t28 -48t9.5 -55q0 -38 -17 -75t-46 -66.5t-67.5 -47.5t-82.5 -18h-166l-41 -194h-80zM311 265q25 0 47 10.5t38.5 28t26 40.5t9.5 49q0 38 -22.5 62.5t-57.5 24.5h-156l-46 -215h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 624,
    d: "M411 42q-38 -22 -79 -34t-85 -12q-52 0 -92.5 19t-68.5 51.5t-42.5 74.5t-14.5 87q0 62 28 121t75 104.5t108 73.5t127 28q52 0 92.5 -19.5t68.5 -52.5t42 -75t14 -87q0 -69 -33 -131.5t-88 -109.5l55 -80h-78zM264 68q29 0 56.5 8t52.5 22l-61 89h79l33 -49q36 36 57 83 t21 94q0 33 -10 63.5t-29 54t-47.5 37t-64.5 13.5q-51 0 -94.5 -22t-76 -57.5t-51 -79.5t-18.5 -88q0 -33 10 -63.5t29.5 -54t48 -37t65.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 556,
    d: "M131 551h248q34 0 60.5 -13t44.5 -34t27.5 -48t9.5 -55q0 -32 -12 -62.5t-33 -56t-49 -44.5t-61 -28l94 -210h-92l-87 194h-146l-41 -194h-80zM318 265q24 0 46 11t38.5 28.5t26.5 40.5t10 47q0 37 -22 62.5t-58 25.5h-163l-46 -215h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 510,
    d: "M201 -6q-65 0 -120.5 19.5t-95.5 56.5l52 68q21 -28 68 -50t113 -22q63 0 100 23t37 67q0 18 -9.5 30.5t-27.5 22.5t-44 18t-59 16q-70 17 -106.5 43.5t-36.5 77.5q0 45 19 80.5t52 60t77 37.5t94 13q57 0 101 -17t73 -46l-49 -65q-17 23 -53.5 40t-87.5 17 q-73 0 -106.5 -27t-33.5 -69q0 -32 32 -47.5t95 -31.5q36 -9 65.5 -19.5t50.5 -25.5t32.5 -35.5t11.5 -49.5q0 -48 -19.5 -82.5t-53 -57.5t-78 -34t-93.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 515,
    d: "M256 480h-197l15 71h472l-15 -71h-195l-102 -480h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 625,
    d: "M249 -4q-54 0 -91.5 15t-60.5 41t-33.5 60.5t-10.5 74.5q0 20 2.5 41.5t7.5 43.5l59 279h80l-59 -279q-8 -38 -8 -70q0 -28 6.5 -52.5t21.5 -42.5t39.5 -28.5t60.5 -10.5q48 0 83.5 17.5t60.5 46t40.5 65.5t23.5 75l59 279h80l-59 -279q-12 -56 -36 -106.5t-61.5 -88 t-88 -59.5t-116.5 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 563,
    d: "M63 551h85l91 -439l276 439h85l-351 -551h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1024,
    d: "M97 710h101l45 -577l299 577h98l59 -577l290 577h102l-365 -710h-94l-72 563l-306 -563h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 865,
    d: "M62 551h87l97 -454l134 208l-48 243h75l34 -189l115 189h75l-151 -243l47 -208l289 454h88l-358 -551h-68l-59 252l-165 -252h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 536,
    d: "M219 272l-156 279h89l122 -222l217 222h88l-274 -279l151 -272h-88l-118 214l-208 -214h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 531,
    d: "M200 200l-142 351h87l109 -281l230 281h88l-293 -352l-42 -199h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 531,
    d: "M-15 62l452 418h-355l15 71h449l-13 -62l-445 -418h356l-15 -71h-457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 602,
    d: "M207 -10q-44 0 -78.5 17t-58 46.5t-36 69t-12.5 83.5q0 64 25 123t65.5 104t93 71.5t108.5 26.5q60 0 100 -31.5t55 -82.5l22 100h88l-110 -517h-88l21 99q-37 -50 -87 -79.5t-108 -29.5zM244 66q53 0 98.5 33t76.5 83l32 148q-8 54 -42.5 89.5t-85.5 35.5q-41 0 -79 -21 t-66.5 -55t-45.5 -75.5t-17 -83.5q0 -32 9 -60t25.5 -49t40.5 -33t54 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 527,
    d: "M130 -10q-31 0 -56 10t-43 28t-27.5 42.5t-9.5 53.5q0 48 22.5 84t57.5 59.5t79 35t88 11.5q48 0 81.5 -8.5t50.5 -17.5l9 42q4 19 4 39q0 45 -26.5 71.5t-77.5 26.5q-39 0 -81 -15.5t-90 -45.5l-16 57q50 30 102 49t106 19q86 0 128.5 -41t42.5 -111q0 -28 -6 -58 l-68 -321h-85l16 79q-42 -46 -94.5 -67.5t-106.5 -21.5zM167 56q19 0 39.5 4t40.5 12t38.5 20t33.5 28q10 11 17 20.5t9 18.5l16 77q-27 13 -57.5 19t-60.5 6q-27 0 -55.5 -6.5t-52.5 -21t-39 -37.5t-15 -55q0 -38 24.5 -61.5t61.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 862,
    d: "M224 -10q-49 0 -87 18t-63.5 48.5t-38.5 70t-13 83.5q0 59 24 116.5t66 103t99.5 73.5t125.5 28q47 0 76.5 -11.5t53.5 -31.5q-5 17 -10 40t-5 46q0 36 13 67t37 54t59 36t80 13q38 0 63 -7.5t40 -21t21 -32.5t6 -42q0 -26 -5 -56t-13 -63h110l-15 -69h-110l-68 -324 q-1 -4 -1 -7.5v-6.5q0 -21 12.5 -31t31.5 -10q25 0 47 9t31 13l4 -70q-17 -8 -52.5 -20.5t-76.5 -12.5q-40 0 -66.5 19t-26.5 61q0 14 3 29l75 351h-68l15 69h67q7 31 12 58t5 49q0 33 -16 52t-58 19q-29 0 -51 -11t-36 -30t-21 -43t-7 -49q0 -22 3.5 -46t8.5 -46.5t10 -41 t7 -29.5l-91 -27q-13 40 -42 59t-71 19t-79.5 -21t-65.5 -54t-44 -75t-16 -84q0 -32 9 -60.5t25.5 -49.5t40 -33t52.5 -12q18 0 39.5 5.5t41.5 16t37.5 25.5t27.5 34l80 -26q-18 -31 -45 -55t-59.5 -41t-67.5 -26t-70 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 600,
    d: "M208 -10q-44 0 -78.5 17.5t-58.5 47t-36.5 69t-12.5 83.5q0 63 24 121.5t64 103.5t92 72t108 27q61 0 99.5 -32.5t57.5 -80.5l67 312h88l-155 -730h-88l19 92q-37 -47 -86.5 -74.5t-103.5 -27.5zM245 66q22 0 48.5 9t51 25t44.5 37.5t29 45.5l31 150q-3 26 -14.5 48 t-29.5 38.5t-40 26t-45 9.5q-41 0 -78.5 -21t-65.5 -54t-44.5 -75t-16.5 -84q0 -32 9 -60.5t26 -49.5t41 -33t54 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 576,
    d: "M509 233q0 -53 -24.5 -97.5t-65 -76.5t-92.5 -49.5t-107 -17.5q-44 0 -80.5 13.5t-62 37.5t-39.5 56.5t-14 70.5q0 41 15.5 75t39.5 60t53.5 45t57.5 30q-32 16 -53 47.5t-21 72.5q0 49 24.5 88t62.5 66t83.5 41.5t87.5 14.5q34 0 67 -10t58.5 -30t41 -49t15.5 -66 q0 -32 -12 -59t-31.5 -49t-44.5 -39t-51 -28q39 -18 65.5 -56.5t26.5 -90.5zM420 230q0 27 -10.5 48t-28 35.5t-40 22t-46.5 7.5q-31 0 -63 -11.5t-57.5 -32.5t-42 -50.5t-16.5 -64.5q0 -26 10.5 -47t27.5 -35.5t39 -22.5t46 -8q31 0 63 11.5t58 32.5t43 50.5t17 64.5z M205 503q0 -22 9 -39t24 -29t34 -18t39 -6q24 0 51 8.5t49.5 25t37.5 41t15 55.5q0 42 -31 66t-76 24q-28 0 -55 -9t-48.5 -25.5t-35 -40.5t-13.5 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 539,
    d: "M191 -10q-72 0 -122.5 36t-67.5 97l65 48q17 -47 54 -74.5t88 -27.5q37 0 70.5 14.5t59 39.5t41 59t15.5 73q0 54 -31 88t-82 34q-39 0 -78.5 -19t-68.5 -54h-79q3 7 16.5 40t31 78t38 95.5t37 93.5t28 71l11.5 28h329l-18 -81h-263l-88 -226q53 50 131 50q40 0 73 -13.5 t56 -37.5t36 -57.5t13 -73.5q0 -61 -24.5 -112.5t-65.5 -89t-94 -58.5t-111 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 554,
    d: "M278 0l38 181h-314l17 79l436 450h61l-95 -449h84l-17 -80h-84l-38 -181h-88zM342 261l67 314l-298 -314h231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 226,
    d: "M115 517h88l-155 -730h-88zM159 722h88l-22 -102h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 236,
    d: "M165 730h88l-155 -730h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 592,
    d: "M76 427q0 58 25 110.5t67 92t96 62.5t112 23q90 0 140.5 -60t50.5 -166q0 -99 -26 -189.5t-72.5 -159.5t-112 -109.5t-143.5 -40.5q-66 0 -112 33.5t-65 93.5l65 53q11 -47 45.5 -74.5t83.5 -27.5q77 0 138.5 72t90.5 205q-32 -52 -84.5 -83t-110.5 -31q-42 0 -77 15 t-59.5 41.5t-38 62.5t-13.5 77zM359 640q-36 0 -71.5 -16.5t-63 -44t-44.5 -63.5t-17 -75q0 -29 9 -54t25.5 -44t39.5 -29.5t51 -10.5q36 0 71.5 16t63.5 43t45 63t17 75q0 29 -9.5 54.5t-26 44.5t-39.5 30t-51 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 424,
    d: "M18 80h129l116 545q-10 -12 -30.5 -26.5t-45 -28t-49.5 -22.5t-44 -9l17 82q25 0 55 14.5t55.5 32.5t43 33t18.5 17h90l-136 -638h121l-17 -80h-340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 599,
    d: "M400 103q-45 -56 -97 -84.5t-109 -28.5q-41 0 -73 17t-54 46t-33.5 67.5t-11.5 82.5q0 66 25.5 125.5t67.5 104.5t95.5 71.5t110.5 26.5q58 0 99 -30t58 -78l21 99h78l-156 -735h-88zM240 66q52 0 97 32.5t79 79.5l32 150q0 25 -10 48.5t-27 40.5t-39 27.5t-47 10.5 q-41 0 -79.5 -20.5t-67.5 -54t-46.5 -76t-17.5 -86.5q0 -32 8.5 -59.5t25 -48t39.5 -32.5t53 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 514,
    d: "M440 629h-342l17 81h482l-491 -710h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 591,
    d: "M238 -10q-91 0 -141 60t-50 166q0 100 26 190.5t72.5 159t111.5 109t144 40.5q66 0 112 -33t65 -93l-65 -53q-11 47 -45.5 74.5t-84.5 27.5q-38 0 -73 -18.5t-64.5 -54.5t-53 -87.5t-38.5 -117.5q32 52 84.5 83t110.5 31q42 0 77 -15t59.5 -41.5t38 -62t13.5 -77.5 q0 -58 -25 -110.5t-66.5 -92t-95.5 -62.5t-112 -23zM255 66q36 0 71.5 16t63 43.5t44.5 63.5t17 76q0 29 -9 54t-25.5 44t-39.5 29.5t-51 10.5q-37 0 -72 -16t-62.5 -43.5t-44.5 -63.5t-17 -75q0 -29 9 -54.5t25.5 -44t39.5 -29.5t51 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 330,
    d: "M130 442h-73l17 80h73l37 174h90l-37 -174h117l-17 -80h-117l-94 -442h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 559,
    d: "M201 -9q-89 0 -140 42.5t-51 114.5l61 53q0 -26 8.5 -49t26 -40.5t44 -28t63.5 -10.5t70.5 10.5t59 29t40.5 44.5t15 57q0 55 -48 83.5t-136 28.5h-32l16 75h32q48 0 88.5 9t69 26t44.5 43t16 59q0 49 -32 76t-83 27q-28 0 -54.5 -7.5t-50 -20.5t-42 -30.5t-30.5 -36.5 l-46 61q20 26 47.5 47t59.5 35.5t66.5 22t68.5 7.5q43 0 78.5 -12.5t60.5 -35t38.5 -53t13.5 -67.5q0 -65 -42.5 -114.5t-125.5 -69.5q54 -11 83.5 -51.5t29.5 -97.5q0 -53 -25 -95t-66 -71.5t-92.5 -45t-103.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 565,
    d: "M-18 0q15 70 37 121t52.5 89t70 66t89.5 51q40 18 81 34.5t74.5 39t55 54.5t21.5 82q0 42 -25 71t-79 29q-33 0 -63 -9.5t-55.5 -24t-46.5 -31t-36 -31.5l-44 57q10 10 34 30t59.5 40.5t80.5 35.5t98 15q45 0 78.5 -13t55 -35.5t32.5 -53t11 -64.5q0 -60 -21 -102 t-55.5 -72.5t-78 -53t-88.5 -42.5q-53 -24 -89 -45.5t-60 -45.5t-37.5 -51t-20.5 -61h354l-17 -80h-468v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 571,
    d: "M161 -10q-71 0 -99.5 36.5t-28.5 95.5q0 38 11 87l67 313h87l-63 -296q-4 -19 -6.5 -36.5t-2.5 -33.5q0 -41 18 -65.5t64 -24.5q25 0 51.5 10t50.5 27t45 41t37 51l69 327h88l-111 -522h-85l23 107q-40 -56 -98.5 -86.5t-116.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 805,
    d: "M62 522h92l44 -414l207 414h84l31 -414l220 414h91l-284 -522h-94l-35 387l-200 -387h-93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 517,
    d: "M27 -213q1 1 12 19.5t28 48t39.5 67t47.5 78.5l-98 522h92l71 -443l245 443h84l-421 -735h-100v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 665,
    d: "M267 -10q-57 0 -98.5 25.5t-68 66.5t-39 92t-12.5 102q0 49 13.5 100.5t37.5 100t58 91t75 74t88 50t98 18.5q58 0 99 -26t67 -67.5t38.5 -92.5t12.5 -102q0 -50 -13.5 -101t-37.5 -99t-58 -90.5t-75 -74t-88 -49.5t-97 -18zM283 71q58 0 106 34.5t82.5 86t53.5 112 t19 112.5q0 40 -8.5 78t-26 68t-44 48.5t-63.5 18.5q-59 0 -107.5 -36t-82.5 -90t-52.5 -117t-18.5 -116q0 -39 8 -75t25 -63.5t44 -44t65 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 175,
    d: "M9 -182l23 106h79l-22 -106h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 450,
    d: "M230 319q-40 0 -68.5 15t-47 39.5t-27 54.5t-8.5 60q0 42 18.5 85t51 78t75.5 57t93 22q39 0 67.5 -15.5t46.5 -40t26.5 -54.5t8.5 -60q0 -42 -18 -84.5t-50 -77.5t-75 -57t-93 -22zM137 495q0 -22 6 -43.5t19 -39t32.5 -28t46.5 -10.5q39 0 70.5 17.5t53 44.5t33.5 58.5 t12 58.5q0 22 -6.5 44t-19 39.5t-32.5 28t-47 10.5q-39 0 -70 -18t-52.5 -45t-33.5 -58.5t-12 -58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 269,
    d: "M265 375l-12 -55h-201l12 55h76l62 294q-6 -6 -18.5 -14.5t-27 -16t-29 -13t-26.5 -5.5l12 55q15 0 32.5 8.5t33 18.5t26 19t10.5 10h56l-76 -356h70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 383,
    d: "M39 320q8 39 21.5 68.5t33 51.5t45.5 38.5t61 29.5q26 10 53 19.5t49 21.5t36 29t14 43q0 24 -19.5 40t-58.5 16q-46 0 -79 -18t-52 -35l-27 39q6 7 21 18.5t38 22.5t53 19t65 8q62 0 92 -27.5t30 -71.5q0 -58 -39 -91.5t-122 -60.5q-31 -10 -52 -22.5t-34.5 -27 t-20.5 -29t-10 -27.5h218l-12 -54h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 379,
    d: "M184 314q-60 0 -95 23t-37 63l40 38q0 -11 6.5 -23t19 -22t32 -16.5t45.5 -6.5q24 0 46 5t38.5 15t26.5 23t10 30q0 29 -34 44.5t-94 15.5h-22l10 51h22q66 0 104.5 17.5t38.5 53.5q0 26 -24 40.5t-57 14.5q-38 0 -69.5 -15t-51.5 -39l-27 43q25 29 68.5 45.5t90.5 16.5 q59 0 94.5 -27t35.5 -69q0 -41 -28.5 -67t-80.5 -37q38 -6 58.5 -30t20.5 -56t-16 -56t-42.5 -41t-60 -25.5t-68.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 379,
    d: "M244 325l21 99h-214l11 53l285 253h38l-54 -252h57l-12 -54h-56l-21 -99h-55zM119 478h160l38 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 368,
    d: "M247 584q56 0 90 -29.5t34 -77.5q0 -35 -16 -64t-42.5 -50t-61.5 -32.5t-73 -11.5q-48 0 -82.5 20t-46.5 54l42 34q12 -26 38.5 -40.5t63.5 -14.5q24 0 46 7t38.5 20t26.5 31t10 41q0 35 -25 52.5t-56 17.5q-28 0 -56.5 -13t-46.5 -34h-50q9 21 23.5 54.5t30 68.5t29 66 t19.5 47h219l-12 -55h-178l-53 -117q17 12 40 19t49 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 399,
    d: "M403 477q0 -33 -16 -62.5t-43 -51.5t-62.5 -35t-74.5 -13q-61 0 -95.5 36.5t-34.5 100.5q0 58 16.5 109t46.5 88.5t71.5 59t91.5 21.5q43 0 75 -18t45 -51l-41 -37q-8 24 -33 39t-59 15q-52 0 -92 -37.5t-55 -106.5q10 13 24.5 24t31.5 18.5t35 11.5t36 4q60 0 96.5 -33 t36.5 -82zM220 366q24 0 47.5 8.5t41.5 22.5t29 32t11 38q0 32 -25.5 54.5t-66.5 22.5q-25 0 -48.5 -8t-41.5 -22t-28.5 -32t-10.5 -38q0 -32 26 -55t66 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 352,
    d: "M336 675h-233l11 55h320l-314 -405h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 390,
    d: "M385 455q0 -30 -16 -55t-42 -43t-59.5 -28t-69.5 -10q-61 0 -97.5 30.5t-36.5 74.5q0 23 9.5 42t25 33.5t35 25t39.5 17.5q-23 9 -38.5 26.5t-15.5 43.5q0 27 15.5 48.5t40 37t54 24t57.5 8.5q24 0 46 -6.5t39 -18t27.5 -28.5t10.5 -38q0 -36 -26.5 -60.5t-63.5 -36.5 q29 -12 47.5 -34t18.5 -53zM330 454q0 15 -7.5 26.5t-20 19.5t-28.5 12.5t-33 4.5q-22 0 -43.5 -6t-38.5 -16.5t-27.5 -25.5t-10.5 -33q0 -15 8 -26.5t20.5 -19.5t29 -12t33.5 -4q21 0 42 5.5t38 16t27.5 25.5t10.5 33zM174 613q0 -24 24 -37t53 -13q16 0 34 4.5t33 12.5 t25 20t10 27q0 24 -23.5 37t-54.5 13q-19 0 -37 -4.5t-32.5 -13t-23 -20t-8.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 399,
    d: "M90 568q0 33 16 62.5t43 51.5t62.5 35t73.5 13q61 0 96 -36.5t35 -100.5q0 -59 -16.5 -109.5t-46.5 -88t-71.5 -59t-91.5 -21.5q-43 0 -75 18.5t-45 51.5l41 36q8 -25 32.5 -39.5t59.5 -14.5q52 0 92 37.5t55 106.5q-20 -26 -56 -42t-72 -16q-60 0 -96 33t-36 82z M273 679q-24 0 -47.5 -8.5t-41.5 -22.5t-29 -32t-11 -38q0 -32 26 -54t66 -22q24 0 47.5 8t41.5 21.5t29 31.5t11 38q0 32 -26 55t-66 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 450,
    d: "M161 -5q-40 0 -68.5 15t-47 39.5t-27 54.5t-8.5 60q0 42 18.5 85t51 78t75.5 57t93 22q39 0 67.5 -15.5t46.5 -40t26.5 -54.5t8.5 -60q0 -42 -18.5 -84.5t-50 -77.5t-75 -57t-92.5 -22zM172 50q39 0 70 17.5t53 44.5t34 58.5t12 58.5q0 22 -6.5 44t-19.5 39.5t-32.5 28 t-46.5 10.5q-39 0 -70 -18t-53 -45t-34 -58.5t-12 -58.5q0 -22 6.5 -43.5t19 -39t32.5 -28t47 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 290,
    d: "M-5 54h87l63 295q-7 -7 -20.5 -15.5t-29.5 -16t-32.5 -12.5t-29.5 -5l12 55q17 0 36.5 8.5t36.5 18.5t28.5 19t11.5 10h56l-76 -357h81l-11 -54h-224z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 386,
    d: "M-29 0q8 39 21.5 68.5t33 51.5t46 38.5t61.5 29.5q26 10 53 19t48.5 21t35.5 29t14 43q0 25 -19.5 41t-58.5 16q-46 0 -79 -18.5t-52 -35.5l-27 40q6 7 21.5 18.5t38 22.5t52.5 19t65 8q62 0 92 -27.5t30 -71.5q0 -30 -9 -52t-28.5 -39.5t-49.5 -32t-73 -28.5 q-31 -10 -52 -23t-34.5 -27t-20.5 -28.5t-10 -27.5h225l-12 -54h-312v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 380,
    d: "M117 -5q-60 0 -95.5 22.5t-36.5 63.5l39 37q0 -11 6.5 -22.5t19.5 -22t32.5 -17t45.5 -6.5q24 0 45.5 5t38 15t26.5 23t10 30q0 29 -33.5 45t-93.5 16h-22l10 50h22q65 0 104 17.5t39 53.5q0 26 -24.5 40.5t-56.5 14.5q-39 0 -70 -15t-51 -39l-27 43q25 29 68.5 45.5 t89.5 16.5q60 0 95.5 -27t35.5 -69q0 -41 -28.5 -67t-80.5 -37q38 -6 58.5 -30t20.5 -56t-16 -56t-42.5 -40.5t-60 -25t-68.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 377,
    d: "M195 100h-214l11 53l285 253h38l-54 -252h57l-12 -54h-56l-21 -100h-55zM209 154l38 180l-198 -180h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 369,
    d: "M111 -5q-48 0 -82.5 20t-47.5 53l42 34q13 -25 39 -40t63 -15q24 0 46 7t38.5 20.5t26.5 31.5t10 41q0 35 -25 52.5t-56 17.5q-28 0 -56.5 -13t-46.5 -34h-50q9 21 23.5 54.5t30 68.5t29 66t19.5 47h219l-12 -55h-178l-53 -117q17 12 40 19t49 7q56 0 90 -30t34 -78 q0 -34 -16 -63t-42.5 -50t-61 -32.5t-72.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 398,
    d: "M139 -5q-61 0 -95.5 36t-34.5 101q0 58 16.5 109t46.5 88t71.5 58.5t91.5 21.5q43 0 75 -18t44 -51l-40 -37q-8 25 -33.5 39.5t-58.5 14.5q-53 0 -92.5 -37.5t-54.5 -106.5q10 13 24.5 24t31.5 18.5t35 11.5t36 4q60 0 96 -33t36 -82q0 -33 -16 -62t-43 -51t-62 -35 t-74 -13zM152 45q24 0 47 8.5t41 22.5t29 32t11 38q0 32 -25 54.5t-66 22.5q-25 0 -48.5 -8t-41.5 -22t-29 -32t-11 -38q0 -32 26.5 -55t66.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 352,
    d: "M269 351h-234l12 55h320l-315 -406h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 391,
    d: "M129 -5q-61 0 -97.5 30.5t-36.5 74.5q0 23 9.5 42t25 33.5t35 25t39.5 17.5q-23 9 -38.5 26.5t-15.5 43.5q0 27 15.5 48.5t40 37t54 24t57.5 8.5q24 0 46 -6.5t39.5 -18t28 -28.5t10.5 -38q0 -36 -27 -60.5t-64 -36.5q29 -12 48 -34t19 -53q0 -30 -16 -55t-42.5 -43 t-60 -28t-69.5 -10zM143 50q21 0 42 5.5t38 16t27.5 25.5t10.5 33q0 15 -7.5 26.5t-20 19.5t-28.5 12.5t-33 4.5q-21 0 -42.5 -6t-39 -16.5t-28 -26t-10.5 -33.5q0 -14 8 -25.5t20.5 -19.5t29 -12t33.5 -4zM182 238q17 0 35 4.5t33 13t24.5 20.5t9.5 27q0 23 -23.5 36.5 t-54.5 13.5q-19 0 -37 -4.5t-32.5 -13t-23 -20.5t-8.5 -27q0 -12 6.5 -21t17.5 -15.5t25 -10t28 -3.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 399,
    d: "M122 -5q-44 0 -76 18t-45 51l42 37q8 -25 32.5 -39.5t59.5 -14.5q51 0 91.5 37t55.5 106q-20 -26 -56 -42t-72 -16q-60 0 -96 33t-36 82q0 33 16 62.5t43 51.5t62.5 35t73.5 13q61 0 96 -36.5t35 -100.5q0 -59 -16.5 -109.5t-46.5 -87.5t-71.5 -58.5t-91.5 -21.5z M168 181q24 0 47 8t41 22t29 32t11 38q0 32 -25.5 54.5t-65.5 22.5q-24 0 -47.5 -8.5t-41.5 -22.5t-29 -32t-11 -38q0 -32 26 -54t66 -22z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0259",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0135",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEF",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xEE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0166",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "eight.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 277
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\u2212",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xF7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xD7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "=",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xF7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xD7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0135",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEE",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0129",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012D",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xEF",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0259",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0126",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1EF9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0135",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012D",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0127",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEF",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEE",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0129",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0135",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u017E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0169",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0135",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012D",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEF",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0131",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012D",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xDF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EF9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u017E",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0177",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012D",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEF",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0135",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0129",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0135",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0142",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0129",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "y.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "t.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "Y.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "V.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "T.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u018F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0166",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0141",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0126",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0110",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "y.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "T.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "\u0166",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "|",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xA6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "|",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\u2122",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "\xA6",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEE",
    u2: "*",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "|",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "two.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "one.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "nine.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "t.alt",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "l.alt",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    g2: "j.alt",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2120",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201C",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2018",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u017E",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xBA",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xAA",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "t",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "l",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "j",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "?",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "'",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\"",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "!",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "\u2122",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0111",
    u2: "*",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "t.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "l.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "j.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_f_l",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_f_i",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_l",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_i",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "f_f",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u1EE4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u1ECC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u01FE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u01F4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0172",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0170",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u016E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u016C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u016A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0168",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0152",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0150",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u014E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u014C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0133",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0126",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0122",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0120",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u011E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u011C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u010C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u010A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0108",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0106",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xFE",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xF0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xDC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xDA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xC7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "u",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "o",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "k",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "j",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "i",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "h",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "f",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "e",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "c",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "b",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "a",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "U",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "Q",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "O",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "G",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "'",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\"",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xA6",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "|",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012E",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "\u2122",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "*",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0166",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "l.alt",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "j.alt",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2120",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201D",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u201C",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2019",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2018",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u017E",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0133",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xFE",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xAA",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "t",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "l",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "k",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "i",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "h",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "b",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "?",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "*",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "'",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\"",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "!",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0166",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "w",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xEE",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2122",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u201D",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2019",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\xA6",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "}",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "|",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "]",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\\\\\\\\",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: ")",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FA",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0104",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0102",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0100",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC5",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC4",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC3",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC1",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC0",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "A",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0141",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0110",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xEE",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0126",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0166",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0166",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0135",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "j",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0135",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "j",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xF0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0135",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEE",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0129",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0129",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "|",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\xA6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "|",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xBA",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xA6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "|",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "X.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "|",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "|",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "|",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "|",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "X.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "|",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0135",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012D",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xEF",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2120",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xBA",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xA6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "|",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lnum",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xF7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "=",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\xB0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "ae,aeacute,a.alt2",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "bar",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "brokenbar",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.alt2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "AE,AEacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "bar",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "brokenbar",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "six",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "asterisk",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae,aeacute,a.alt2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "ae,aeacute,a.alt2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "T.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "bar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "brokenbar",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "bar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "brokenbar",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "question",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "brokenbar",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "AE,AEacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "bar",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "brokenbar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "brokenbar",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "AE,AEacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "AE,AEacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "asterisk",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bar",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "brokenbar",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "braceright",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bracketright",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "brokenbar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "asterisk",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "trademark",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "bar",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "brokenbar",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "AE,AEacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "bar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "AE,AEacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "backslash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "bar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "brokenbar",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "backslash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "ae,aeacute,a.alt2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "ae,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "AE,AEacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "bar",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bar",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "AE,AEacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "ae,aeacute,a.alt2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quoteright,quotedblright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "AE,AEacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "ae,aeacute,a.alt2",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "AE,AEacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "AE,AEacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -13
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayMediumItalic);
export default __webpack_public_path__ + "static/media/Raleway-MediumItalic.e870a3377a2a232a067d48263f7e24b4.svg";
export { ForwardRef as ReactComponent };